import { Component, ViewChild, Inject, AfterViewInit, SimpleChanges, Renderer2, DOCUMENT } from '@angular/core';
import { DxTreeListComponent } from 'devextreme-angular/ui/tree-list';
import {
  DxTooltipComponent
} from 'devextreme-angular/ui/tooltip';
import { Dates } from '../../../../limit-management/limit-management-common.component';
import { GenericService } from '../../../../common/common.service';
import { environment } from '../../../../environments/environment';

import { DataService } from "../../../../common/data.service";
import { CounterpartyLimitViewModel, DataEntityState, LimitCustomPropertyData, FourEyeStatus, TradingCounterpartyLegalHierarchyOwnership, TradingCounterpartyLimit } from './CounterpartyLimits.component.model'
import { LimitType, SubLimitType, Currency, ExchangeRateEF, PeriodType, Unit, TenorType, TradingCategory, TradingEntity, TradingCounterparty, TradingcounterpartySearchView, TradingEntityLegalHierarchyOwnership } from '../../../../limit-management/TradingLimits.model';
import { ConsoleLoggerService } from '../../../../common/LoggerService/console-logger.service';
import { LimitSideBarComponent } from '../CounterpartyLimits/ChildComponents/LimitSideBar.component'
import { CustomPropertyComponent } from '../../../../CustomProperty/CustomProperty.component';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe, Location } from '@angular/common';
import { UtilityService } from '../../../../common/utility.service';
import { CounterpartyLimitsManager } from '../CounterpartyLimits/CounterpartyLimits.counterpartyvalidationmanager';
import { OurEntityLimitsManager } from '../CounterpartyLimits/CounterpartyLimits.entityvalidationmanager';
import { AlertComponent } from '../CounterpartyLimits/Helpers/Popup-Alerts/Alerts.component';
import { TradingLimitCommentComponent } from '../CounterpartyLimits/Helpers/Comments/TradingLimitcomment.component';
import { LimitCustomPropertyComponent } from '../CounterpartyLimits/Helpers/Limit-Custom-Property/limit-custom-property.component';
import { ReviewDateComponent } from '../CounterpartyLimits/Helpers/Review-Dates/ReviewDate.component';
import { CounterpartyLimitsCommonManager } from '../CounterpartyLimits/CounterpartyLimits.common';
import { ConfirmationComponent, ConfirmationType } from '../../../../common/Controls/Confirmation/confirmation.component';
import { Constants, DataEntityIds } from '../../../../common/constants';
import { CounterpartyLimitsFourEyeManager } from './CounterpartyLimits.foureyemanager';
import { CommonHelper } from '../../../../common/Helpers/common.helper';
import { WorkflowDashBoardcomponent } from '../../../../WorkflowDashBoard/WorkflowDashBoard.component';
import { Subject, Subscription, catchError, throwError } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SideBarClickService } from '../../side-bar-click-service';
import { DatePickerService } from '../../../../common/date-picker/date-picker.service';
import { InstanceLevelPermissionService } from '../../../../common/InstanceLevelPermission/instancelevelpermission.service';
import { Workbook } from 'exceljs';
import { exportDataGrid } from 'devextreme/excel_exporter';
import saveAs from 'file-saver';

@Component({
    selector: 'app-Counterpartylimits',
    templateUrl: './CounterpartyLimits.component.html',
    styleUrls: ['./CounterpartyLimits.component.css'],
    providers: [GenericService, Dates, ConsoleLoggerService, UtilityService, InstanceLevelPermissionService],
    standalone: false
})

export class CounterpartyLimitsComponent implements AfterViewInit {
  //complex types
  //Start FB46162-Pawan Prajapati
  public __oBindDatasource: CounterpartyLimitViewModel[];

  private __oApiDataSource: CounterpartyLimitViewModel[];
  private __oGridDatasource: CounterpartyLimitViewModel[];
  public get __oDatasource() {
    return this.__oGridDatasource;
  }
  public set __oDatasource(oDatas: CounterpartyLimitViewModel[]) {
    if (oDatas) {
      this.__oGridDatasource = oDatas;
      this.refreshBindingData();
    }
  }
  //End FB46162-Pawan Prajapati

  public __oDatasourceDeleted: CounterpartyLimitViewModel[] = [];

  public __oTradingCounterpartyLegalHierarchyOwnerships: TradingCounterpartyLegalHierarchyOwnership[] = [];
  public __oTradingEntityLegalHierarchyOwnerships: TradingEntityLegalHierarchyOwnership[] = [];
  public __oCounterpartyLegalHierarchyOwnerships: any[] = [];
  public __oOurEntityLegalHierarchyOwnerships: any[] = [];
  public __oLimitTypes: LimitType[];
  public __oUnits: Unit[] = [];
  public __oExchangeRateEFs: ExchangeRateEF[] = [];
  public __oTradingCategories: TradingCategory[] = [];
  public __oPopupTradingCategories: TradingCategory[] = [];
  public __oTenorTypes: TenorType[] = [];
  public __oPeriodTypes: PeriodType[] = [];
  public __oCurrencies: Currency[] = [];
  public __oTradingEntities: TradingEntity[] = [];
  public __oTradingcounterpartySearchView: any = new TradingcounterpartySearchView();
  public __oSubLimitTypes: SubLimitType[] = [];
  public __oColuDetails: any[] = [];
  public __oViews: any[] = [];
  public __oLimitTabs: any[] = [];
  public __oSystemSettings: any[] = [];
  public __oGridcolumns: Array<any> = [];
  public __oNewLimit: any = {};
  public __oCounterParties: any[] = [];
  public __oWarnings: any[] = [];
  public __oLimitCounterParties: any[] = []
  public __oBreaches: any[] = [];
  public __oCounterpartyLimit: any = {};
  private __oTradingProducts: any[] = [];
  //primitive types
  public __sUserName: string = "";
  public __bIsLimitLoadingVisible: boolean = false;
  public __oLimitGridSelectedKeys: any = "";
  public __sViewName: string = "Simple view";
  public __sAlert: string = "";
  public __iFocusedRowKey: number = 4121;
  public __bViewDisabled: boolean = false;
  public __bTimelineViewVisible: boolean = false;
  public __iTabIndex: number;
  public __sTabContent: string = 'General';

  public __sEntityGroup: string = 'Limit Management';
  public __oIsCustomPropertyLoaded: boolean = false;
  public __ilTradingLimitId: number = 0;
  public __bAddNewVisible: boolean = false;
  public __bWarningVisible: boolean = false;
  public __bOverAllocationAlertVisible: boolean = false;
  public __bOverAllocationFocusOutAlertVisible: boolean = false;
  public __dValuationDate: Date = new Date();
  public __dtMinDate: Date = new Date();
  public __dtMaxDate: Date = new Date();
  public __dtMinFrom: Date = new Date();//CRD-498-Pawan Prajapati
  public __bAmendLimitsVisible: boolean = false;
  public __sCounterpartyLimit: string = "";
  public __bIsAddNewLimitFormFilled: boolean = true;
  public __sPopupDuplicateMessage = "";
  public __bSidebarApply: boolean = false;
  public __ilParentCounterpartyLimitId: string = "-1";
  public __bSwitch: boolean = false;
  //public bIsIndexPresent: boolean = false;
  public sub: any;
  public TradingCounterparty: any;
  public __bIsLoadedFromDataSearch: boolean;//CRD-376-Pawan Prajapati
  //permissions
  public __bAllowAddLimits: boolean;
  public __bDisableSave: boolean;
  //permissions
  //form api url
  public documentURL: string;
  public baseApiURL: string;
  public urlAarray: string[];
  public baseURL: string;
  public hostname: string;
  public __sGetApiUrl: string = this.__oUtilityService.GetBasewebAPIURL();
  public __bSideBar: boolean = false;
  public __bAllowDeleting: boolean = true;
  public __oSideBarCounterPartyLimit: any;
  public __oOverAllocation: any = {};
  public defaultVisible: boolean = false;
  public __oAudit: any = {};
  public __bAddNewTemporaryLimitVisible: boolean = false;
  public __oNewTempLimit: any = {};
  public __bIsAddNewTempLimitFormFilled: boolean = false;
  public __bTTActiveUntil: boolean = false;
  public __bTTActiveFrom: boolean = false;
  public __bTTLimitValue: boolean = false;
  public __dtMinTempDate: Date = new Date();
  public __dtMaxTempDate: Date = new Date();
  public __bIsTempLimitEditing: boolean = false;
  public __sTempPopupMessage = "Fill all mandatory  fields to continue";
  public __bValidationsVisible: boolean = false;
  public __bIsFreezed: boolean = false;
  public __sMessageTitle: string = "Limit validation";
  public __sMessage: string = "";
  public __sMessageType: string = "";
  public __bValidationFailed: boolean = false;
  public __bConfirmationVisible: boolean = false;
  public __bCommentVisible: boolean = false;
  public __iCounterpartyLimitIds: number[] = [];
  public __oOverallLimitSettings: any[] = []
  public __bLCPCGVisible: boolean = false;
  public __oLCPCGLimit: any = {};
  public __bIsDeleteRowEnabled: boolean = false;
  todayButton: any;
  todayButton1: any;
  //component controller instances
  @ViewChild(CustomPropertyComponent, { static: false }) __oCustomPropertyComponent: CustomPropertyComponent;//FB44675-Pawan Prajapati
  @ViewChild("trlCounterpartyLimits") __otrCounterpartyLimits: DxTreeListComponent;
  @ViewChild(LimitSideBarComponent) __oLimitSideBarComponent: LimitSideBarComponent;
  @ViewChild(AlertComponent) __oAlertComponent: AlertComponent;
  @ViewChild("ttCommands") __oTooltip: DxTooltipComponent;
  @ViewChild(ReviewDateComponent) __oReviewDateComponent: ReviewDateComponent;
  @ViewChild(WorkflowDashBoardcomponent) __oWorkflowDashBoardcomponent: WorkflowDashBoardcomponent;//FB47640-Pawan Prajapati
  public __oProfileSettings: any[] = [];
  @ViewChild(TradingLimitCommentComponent) __oCommentsComponent: TradingLimitCommentComponent;;
  //Start CRD-408-Pawan Prajapati
  public __bLimitCustomPropertyVisible: boolean = false;
  public __oLimitCustomProperties: LimitCustomPropertyData[] = [];
  @ViewChild(LimitCustomPropertyComponent) __oLimitCustomPropertyComponent: LimitCustomPropertyComponent;
  //End CRD-408-Pawan Prajapati
  //Start CRD-409 Pawan Prajapati
  public __bIsIsCustomColumn = false;
  public __iColumnCountBeforeAmanded = 0;//CRD-420-Pawan Prajapati
  public __sPortalDateFormat = '';
  public get __bIsCustomColumnsAvailable() {
    return this.__oLimitCustomProperties && this.__oLimitCustomProperties.length > 0;
  }
  //End CRD-409 Pawan Prajapati
  __oMonthNames: any[] = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  __iKeys: number[] = [];
  __iCptysUnderHierarchy: number[] = [];
  @ViewChild(ConfirmationComponent) __oConfirmationComponent: ConfirmationComponent;

  public __sLinkLCsGuaranteesPopupTitle: string;//FB44260-Pawan Prajapati

  //Start FB46162-Pawan Prajapati
  public __oFourEyeManager: CounterpartyLimitsFourEyeManager = new CounterpartyLimitsFourEyeManager(this.Logger, this.__oUtilityService);
  public __bLocalPendingApprovalVisible = false;
  public get __bPendingApprovalVisible() {
    return this.__bLocalPendingApprovalVisible;
  };
  public set __bPendingApprovalVisible(bIsVisible) {
    if (!bIsVisible) {
      this.__iBPIId = 0;
    }
    this.__bLocalPendingApprovalVisible = bIsVisible;
  };

  //End FB46162-Pawan Prajapati
  //Start FB47640-Pawan Prajapati
  public __owfBusinessProcessDefinition = null;
  public __iBPIId: number;
  //End FB47640-Pawan Prajapati
  public __iColumnCountBeforeLimitValue = 0;//CRD-420-Pawan Prajapati
  public __bIsOverallNeedToBeCreate = false;//CRD-1034-Pawan Prajapati
  private destroy: Subject<boolean> = new Subject();
    private sideBarClickSub: Subscription;
    constructor(@Inject(DOCUMENT) private document: any, private SideBarClickService: SideBarClickService, private route: ActivatedRoute, public _oDatepipe: DatePipe, public __oService: GenericService, private __oRouter: Router, public __oDataService: DataService, private Logger: ConsoleLoggerService, public __oUtilityService: UtilityService, public datePickerService: DatePickerService, public __oInstanceLevelPermissionService: InstanceLevelPermissionService) {
    try {
      this.__oGridcolumns = [];
      this.__sTabContent = 'General';
      this.__iTabIndex = 0;
    }
    //Start Siju FB 27203
    catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while executing Limit contructor.');
    }
    //End Siju FB 27203
    this.__oNewTempLimit.ActiveFrom = new Date();
    this.todayButton = {
      text: 'Today',
      onClick: () => {
        this.__oNewTempLimit.ActiveFrom = new Date();
      },
    };
    this.__oNewTempLimit.ActiveUntil = new Date();
    this.todayButton1 = {
      text: 'Today',
      onClick: () => {
        this.__oNewTempLimit.ActiveUntil = new Date();
      },
    };
  }
  //fires when selection changes
  selectbox_onSelectionChanged(event: any, dataField: string, controlEvent: any) {
    try {
      switch (dataField) {
        case "lTradingCounterpartyId": event.lTradingCounterpartyId = this.__oCounterParties.find(x => x.TradingCounterpartyName == event.TradingCounterpartyName).lTradingCounterpartyId;
          break;
        case "lTradingEntityId": event.lOurEntityId = this.__oTradingEntities.find(x => x.TradingEntityName == event.TradingEntityName).lTradingEntityId;
          break;
        case "lLimitTypeId": event.lLimitTypeId = this.__oLimitTypes.find(x => x.LimitTypeName == event.LimitTypeName).lLimitTypeId;
          break;
        case "lSubLimitTypeId": event.lSubLimitTypeId = this.__oSubLimitTypes.find(x => x.SubLimitTypeName == event.SubLimitTypeName).lSubLimitTypeId;
          break;
        case "lLimitValueCurrencyId":
          //FB39932-Pawan Prajapati
          if (event.lLimitValueCurrencyId != controlEvent.selectedItem.lCurrencyId && event.TradingCounterpartyLimit && (event.TradingCounterpartyLimit.lOverallLimitSettingId == 2 || event.TradingCounterpartyLimit.lOverallLimitSettingId == 1)) {
            event.lLimitValueCurrencyId = this.__oCurrencies.find(x => x.CurrencyName == event.CurrencyName).lCurrencyId;
            //Start FB42947-Pawan Prajapati
            if (!this.__oLCPCGLimit.Info) {
              this.__oLCPCGLimit.Info = {};
              this.__oLCPCGLimit.IsEnabled = true;
            }
            //End FB42947-Pawan Prajapati
            this.__oLCPCGLimit.Info.data = event;
            this.__oLCPCGLimit.OverallLimitSettingName = this.__oOverallLimitSettings.find(x => x.lOverallLimitSettingId == event.TradingCounterpartyLimit.lOverallLimitSettingId)?.OverallLimitSettingName;
            this.btnLCPCG_Click();
          } else {
            event.lLimitValueCurrencyId = this.__oCurrencies.find(x => x.CurrencyName == event.CurrencyName).lCurrencyId;
            var evntData: any = {};
            evntData.data = event;
            evntData.columnIndex = 0;//CRD-420-Pawan Prajapati
            this.checkForAnyLimitBreachByRow(evntData, true);
            this.updateWarnings();

            for (let i = 0; i < event.DataValues.length; i++) {
              event.DataValues[i].lTradingLimitId > 0 ? (event.EntityState = 2, event.DataValues[i].EntityState = 2) : (event.DataValues[i].EntityState === 1 ? (event.EntityState = 1, event.DataValues[i].EntityState = 1) : event.DataValues[i].EntityState = 0)
            }
            if (event.IsTempLimitAllocated) {
              for (let i = 0; i < event.TempDataValues.length; i++) {//CRD-420-Pawan Prajapati
                event.TempDataValues[i].lTradingLimitId > 0 ? (event.EntityState = 2, event.TempDataValues[i].EntityState = 2) : (event.TempDataValues[i].EntityState === 1 ? (event.EntityState = 1, event.TempDataValues[i].EntityState = 1) : event.TempDataValues[i].EntityState = 0)
              }
            }
          }
          break;
        case "lTenorTypeId":
          event.lTenorTypeId = this.__oTenorTypes.find(x => x.TenorTypeName == event.TenorTypeName).lTenorTypeId;
          break;

        case "lTradingProductId":
          event.lTradingProductId = this.__oTradingProducts.find(x => x.TradingProductName == event.TradingProductName).lTradingProductId;
          break;

        case "lUnitId":
          var oCounterpartyVolumeLimit = null;
          event.lUnitId = this.__oUnits.find(x => x.UnitName == event.UnitName).lUnitId;

          event.LimitTypeName === 'Volume' ? oCounterpartyVolumeLimit = this.__oDatasource.filter(x => x.lLimitTypeId == 2 && x.lTradingCounterpartyId == event.lTradingCounterpartyId && x.lOurEntityId == event.lOurEntityId && x.lLimitTypeId == event.lLimitTypeId && x.lSubLimitTypeId == event.lSubLimitTypeId && x.lTradingProductId == event.lTradingProductId
            && x.lPeriodTypeId == event.lPeriodTypeId && x.IsBuy !== event.IsBuy)[0] : "";//FB43985-Pawan Prajapati
          oCounterpartyVolumeLimit ? ((oCounterpartyVolumeLimit.lUnitId = this.__oUnits.find(x => x.UnitName == event.UnitName).lUnitId), (oCounterpartyVolumeLimit.UnitName = event.UnitName)) : "";

          for (let i = 0; i < event.DataValues.length; i++) {
            event.DataValues[i].lTradingLimitId > 0 ? (event.EntityState = 2, event.DataValues[i].EntityState = 2) : (event.DataValues[i].EntityState === 1 ? (event.EntityState = 1, event.DataValues[i].EntityState = 1) : event.DataValues[i].EntityState = 0)
          }
          for (let i = 0; (i < event.DataValues.length && oCounterpartyVolumeLimit); i++) {
            oCounterpartyVolumeLimit.DataValues[i].lTradingLimitId > 0 ? (oCounterpartyVolumeLimit.EntityState = 2, oCounterpartyVolumeLimit.DataValues[i].EntityState = 2) : (oCounterpartyVolumeLimit.DataValues[i].EntityState === 1 ? (oCounterpartyVolumeLimit.EntityState = 1, oCounterpartyVolumeLimit.DataValues[i].EntityState = 1) : oCounterpartyVolumeLimit.DataValues[i].EntityState = 0)
          }
          break;

        case "lTempLimitTenorTypeId":
          event.lTempLimitTenorTypeId = this.__oTenorTypes.find(x => x.TenorTypeName == event.TempLimitTenorTypeName).lTenorTypeId;
          for (let i = 0; i < event.TempDataValues.length; i++) {
            event.TempDataValues[i].lTradingLimitId > 0 ? (event.EntityState = 2, event.TempDataValues[i].EntityState = 2) : (event.TempDataValues[i].EntityState === 1 ? (event.EntityState = 1, event.TempDataValues[i].EntityState = 1) : event.TempDataValues[i].EntityState = 0)
          }
          break;
        case "lTradingCategoryId":
          event.lTradingCategoryId = this.__oTradingCategories.find(x => x.TradingCategoryName == event.TradingCategoryName).lTradingCategoryId;
          break;
      }
    }
    catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while executing selectbox selection changed event.');
    }
  }
  //volume limits selection changed event
  selectbox_onValueChanged(event: any, dataField: string, controlEvent: any) {
    try {
      switch (dataField) {
        case "lTenorTypeId":
          var oCounterpartyVolumeLimit = null;

          event.LimitTypeName === 'Volume' ? oCounterpartyVolumeLimit = this.__oDatasource.find(x => x.lLimitTypeId == 2 && x.lTradingCounterpartyId == event.lTradingCounterpartyId && x.lOurEntityId == event.lOurEntityId && x.lLimitTypeId == event.lLimitTypeId && x.lSubLimitTypeId == event.lSubLimitTypeId && x.lTradingProductId == event.lTradingProductId
            && x.TenorTypeName == controlEvent.previousValue && x.lPeriodTypeId == event.lPeriodTypeId && x.IsBuy !== event.IsBuy) : "";

          oCounterpartyVolumeLimit ? ((oCounterpartyVolumeLimit.lTenorTypeId = (this.__oTenorTypes.find(x => x.TenorTypeName == controlEvent.value).lTenorTypeId)), (oCounterpartyVolumeLimit.TenorTypeName = controlEvent.value)) : "";
          event.lTenorTypeId = this.__oTenorTypes.find(x => x.TenorTypeName == controlEvent.value).lTenorTypeId;

          for (let i = 0; i < event.DataValues.length; i++) {
            event.DataValues[i].lTradingLimitId > 0 ? (event.EntityState = 2, event.DataValues[i].EntityState = 2) : (event.DataValues[i].EntityState === 1 ? (event.EntityState = 1, event.DataValues[i].EntityState = 1) : event.DataValues[i].EntityState = 0)
          }
          for (let i = 0; (i < event.DataValues.length && oCounterpartyVolumeLimit); i++) {
            oCounterpartyVolumeLimit.DataValues[i].lTradingLimitId > 0 ? (oCounterpartyVolumeLimit.EntityState = 2, oCounterpartyVolumeLimit.DataValues[i].EntityState = 2) : (oCounterpartyVolumeLimit.DataValues[i].EntityState === 1 ? (oCounterpartyVolumeLimit.EntityState = 1, oCounterpartyVolumeLimit.DataValues[i].EntityState = 1) : oCounterpartyVolumeLimit.DataValues[i].EntityState = 0)
          }

          break;
      }
    } catch (oError) {
      this.Logger.Write(oError, 'Error', 'Error occurred while executing selectbox onValueChanged function.');
    }
  }
  // freeze and unfreeze the columns
  checkBox_valueChanged(event: any, dataField: string) {
    try {
      switch (dataField) {
        case "IsFreezed":
          this.__bIsLimitLoadingVisible = true;
          setTimeout(() => {                          // <<<---using ()=> syntax
            this.__bIsLimitLoadingVisible = false;
          }, 4000);
          this.freezeUnFreezeColumns();
          break;
        case "bIsCustomColumn"://CRD-409 Pawan Prajapati
          this.createGridColumns(0, this.__oColuDetails);
          break;
      }
    }
    catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while executing checkbox value changed event.');
    }
  }
  //freeze and unfreeze helper
  private freezeUnFreezeColumns() {
    try {
      if (this.__bIsFreezed) {
        this.__otrCounterpartyLimits.instance.columnOption("TradingCounterpartyName", "fixed", true);
        this.__otrCounterpartyLimits.instance.columnOption("TradingEntityName", "fixed", true);
        this.__otrCounterpartyLimits.instance.columnOption("LimitTypeName", "fixed", true);
        this.__otrCounterpartyLimits.instance.columnOption("TradingCategoryName", "fixed", true);
      }
      else {
        this.__otrCounterpartyLimits.instance.columnOption("TradingCounterpartyName", "fixed", false);
        this.__otrCounterpartyLimits.instance.columnOption("TradingEntityName", "fixed", false);
        this.__otrCounterpartyLimits.instance.columnOption("LimitTypeName", "fixed", false);
        this.__otrCounterpartyLimits.instance.columnOption("TradingCategoryName", "fixed", false);
      }
    }
    catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while executing checkbox value changed event.');
    }
  }
  //gets data from CPM compnent(service)
  private onLoad_GetDataFromService() {
    this.__oCounterParties = [];
    let array = [];
    try {
      //this.__oDataService.__oTCPCurrentTreeDataStore.subscribe(x => this.__oTradingCounterpartyLegalHierarchyOwnerships = x);
      // this.__oTradingCounterpartyLegalHierarchyOwnerships = JSON.parse(localStorage.getItem("oTCPCurrentDataStore"));//FB48011-Pawan Prajapati
      this.__oDataService.__oCounterpartiesCurrentDataStore.subscribe(x => {
        if (this.__oUtilityService.IsNullOrUndefined(x) || (Array.isArray(x) && x.length == 0)) {
          x = JSON.parse(localStorage.getItem('CounterpartyStore'));
        }
        if (x != null && x != undefined && x.length > 0) {
          x = x.filter(y => y.IsSave === true);
          this.__oCounterParties = x.sort((a, b) => a.TradingCounterpartyName.localeCompare(b.TradingCounterpartyName));;
          let oCounterparties: any[] = this.__oCounterParties.map(tc => tc.TradingCounterpartyName.trim());
          var set = new Set();
          for (var a = 0; a < oCounterparties.length; a++) {
            set.add(oCounterparties[a]);
          }
          oCounterparties = Array.from(set);
          array = this.__oCounterParties.filter((tc, index) => {
            return oCounterparties.indexOf(tc.TradingCounterpartyName) === index;
          });
          this.__oCounterParties = [];
          this.__oCounterParties = array;
        }
      });
      //this.__oDataService.__oTradingEntitiesCurrentDataStore.subscribe(x => {
      //    if (x == null || x == undefined || (Array.isArray(x) && x.length == 0)) {
      //        x = JSON.parse(localStorage.getItem('TradingEntitiesStore'));
      //    }
      //    if (x != null && x != undefined && x.length > 0) {
      //        this.__oTradingEntities = x.sort((a, b) => a.TradingEntityName.localeCompare(b.TradingEntityName));
      //        let UniqueArray: any[] = this.__oTradingEntities.map(tc => tc.TradingEntityName.trim());
      //        var set = new Set();
      //        for (var a = 0; a < UniqueArray.length; a++) {
      //            set.add(UniqueArray[a]);
      //        }
      //        UniqueArray = Array.from(set);
      //        let array = this.__oTradingEntities.filter((tc, index) => {
      //            return UniqueArray.indexOf(tc.TradingEntityName) === index;
      //        });
      //        this.__oTradingEntities = [];
      //        this.__oTradingEntities = array;
      //    }
      //});
      this.__oDataService.__oSystemSettingsCurrentDataStore.subscribe(x => {
        if (this.__oUtilityService.IsNullOrUndefined(x) || (Array.isArray(x) && x.length == 0)) {
          x = JSON.parse(localStorage.getItem('SystemSettingData'));
        }
        this.__oSystemSettings = x;
        this.__sPortalDateFormat = this.__oSystemSettings[0].PortalDateFormat;//CRD-409 Pawan Prajapati
      });
      if (!this.__bIsLoadedFromDataSearch) {//CRD-376-Pawan Prajapati
        this.__oDataService.currentData.subscribe(x => {
          if (this.__oUtilityService.IsNullOrUndefined(x) || (Array.isArray(x) && x.length == 0)) {
            x = JSON.parse(localStorage.getItem('TradingcounterpartySearchView'));
          }
          this.__oTradingcounterpartySearchView = x;
        });
      }
    }
    catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while executing onLoad_GetDataFromService function.');
    }
  }
  //fires on initializing limit component
  ngOnInit(): void {
    try {

      //Tabs to load
      this.__oLimitTabs = [
        { id: 0, text: "General", disabled: false },
        { id: 1, text: "PCG Hierarchy", disabled: true, visible: false },//FB44675-Pawan Prajapati
        { id: 2, text: "Limit Review Dates", disabled: false },
        { id: 3, text: "Custom Properties", disabled: false }//FB44675-Pawan Prajapati
      ]
      this.onLoad_GetDataFromService();

      this.__oViews = [
        "Simple view",
        "Timeline view"
      ]
      //Start CRD-408-Pawan Prajapati
      this.__oService.getDataByObservable(this.__sGetApiUrl + "api/CounterpartyLimit/getLimitCustomProperties").subscribe((oData) => {
        if (oData != null) {
          this.__oLimitCustomProperties = oData;
        }
      });
      //End CRD-408-Pawan Prajapati
      //Start CRD-376-Pawan Prajapati
      const oParams = this.route.snapshot.params;
      const sTradingCounterparty = oParams['TradingCounterparty'];
      if ((this.route.snapshot as any)._routerState.url.indexOf("CounterpartyLimits") == 1) {
        this.__bIsLoadedFromDataSearch = true;
        this.__bIsLimitLoadingVisible = true;
        let strToReplace = sTradingCounterparty;
        let dot = /\./gi, carriageReturn = /\n/gi, and = /&/gi, hash = /#/gi, colon = /:/gi, backSlash = /\\/gi, percent = /%/gi, plus = /\+/gi, star = /\*/gi, fslash = /\//gi, Lessthan = /</gi, Greaterthan = />/gi, Questionmark = /\?/gi;
        let result = strToReplace.replace(dot, 'd0t').replace(carriageReturn, 'carriageReturnnn').replace(and, 'annd')
          .replace(hash, 'haaash').replace(colon, 'cln100').replace(backSlash, 'bckwrdslsh101')
          .replace(percent, 'peeercennt').replace(plus, 'pluuus').replace(star, 'staaar').replace(fslash, 'fwdslash')
          .replace(Lessthan, 'lessthaan').replace(Greaterthan, 'Greaterthaaan').replace(Questionmark, 'Questionmaaark');
        result = result.replace(/peeercennt28/g, "(").replace(/peeercennt29/g, ")");
        result = result.trim();

        this.__oService.getDataByObservable(this.__sGetApiUrl + "api/Counterparty/" + result + "/TradingcounterpartySearchView").subscribe((oAllCounterparties) => {
          //this.__oTradingcounterpartySearchView = oAllCounterparties.find(x => x.TradingCounterparty == sTradingCounterparty);
          this.__oTradingcounterpartySearchView = oAllCounterparties.find(x => x.TradingCounterparty.toLowerCase() == sTradingCounterparty.toLowerCase());

          this.__oService.getDataByObservable(this.__sGetApiUrl + "api/TradingLimit/SystemSetting").subscribe((oData) => {
            if (oData != null) {
              this.__oSystemSettings = oData;
              localStorage.setItem('SystemSettingData', JSON.stringify(this.__oSystemSettings));
              this.__sPortalDateFormat = this.__oSystemSettings[0].PortalDateFormat;
              this.loadTradingCounterpartyLegalHierarchy();
            }
          });
        });
      } else {
        this.loadInitData();
      }
      //End CRD-376-Pawan Prajapati
      //Start: CRD-611- Mohamed Kaleemulla
      this.sideBarClickSub = this.SideBarClickService.getValue().pipe(takeUntil(this.destroy)).subscribe(x => {
        setTimeout(() => { this.__otrCounterpartyLimits.instance.updateDimensions() }, 1000);
      });
      //End: CRD-611- Mohamed Kaleemulla
    }
    catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while executing ngoninit function.');
    }
  }
  //Start: CRD-611- Mohamed Kaleemulla
  ngDestroy() {
    this.destroy.next(null);
    if (this.sideBarClickSub)
      this.sideBarClickSub.unsubscribe();
  }
   //End: CRD-611- Mohamed Kaleemulla

  //Start CRD-376-Pawan Prajapati
  loadTradingCounterpartyLegalHierarchy() {
    try {
      this.__bIsLimitLoadingVisible = true;
      this.__oService.getDataByObservable(this.__sGetApiUrl + `api/TradingLimit/${this.__oTradingcounterpartySearchView.lTradingCounterpartyId}/TradingCounterpartyLegalHierarchyOwnership`).subscribe((oData) => {
        if (oData.length > 0) {
          this.__oTradingCounterpartyLegalHierarchyOwnerships = oData;
          this.__oCounterParties = (this.__oTradingCounterpartyLegalHierarchyOwnerships[0] as any).TradingCounterpartys;
        } else {
          let oTradingCounterpartyLegalHierarchyOwnerships: any[] = [];
          if (this.__oSystemSettings[0].IsDisabledCptysIncludedInLimit) {
            let oTradingCounterpartyLegalHierarchyOwnership: any = {};
            oTradingCounterpartyLegalHierarchyOwnership.lChildTradingCounterpartyId = this.__oTradingcounterpartySearchView.lTradingCounterpartyId;
            oTradingCounterpartyLegalHierarchyOwnership.ChildTradingCounterparty = this.__oTradingcounterpartySearchView.TradingCounterparty;
            oTradingCounterpartyLegalHierarchyOwnership.IdentityColumn = 1;
            oTradingCounterpartyLegalHierarchyOwnership.ID = "1";
            oTradingCounterpartyLegalHierarchyOwnerships.push(oTradingCounterpartyLegalHierarchyOwnership);
          }
          this.__oTradingCounterpartyLegalHierarchyOwnerships = oTradingCounterpartyLegalHierarchyOwnerships;
          this.__oCounterParties = [];
          if (this.__oSystemSettings[0].IsDisabledCptysIncludedInLimit || this.__oTradingcounterpartySearchView.Enabled) {
            let instanceLevelPermissionModel: any[] = this.__oInstanceLevelPermissionService.AddToCollection(DataEntityIds.TradingCounterparty, this.__oTradingcounterpartySearchView.lTradingCounterpartyId);
            this.__oInstanceLevelPermissionService.CheckAccess(instanceLevelPermissionModel).subscribe((IsValid) => {
              let oCounterParty: any = {};
              oCounterParty.lTradingCounterpartyId = this.__oTradingcounterpartySearchView.lTradingCounterpartyId;
              oCounterParty.TradingCounterpartyName = this.__oTradingcounterpartySearchView.TradingCounterparty;
              oCounterParty.Enabled = this.__oTradingcounterpartySearchView.Enabled;
              oCounterParty.IsSave = IsValid;
              oCounterParty.lParentTradingCounterpartyId = null;
              this.__oCounterParties.push(oCounterParty);
              localStorage.setItem("CounterpartyStore", JSON.stringify(this.__oCounterParties));
              this.__oDataService.setCounterpartyStore(this.__oCounterParties);
            });
          }
        }
        localStorage.setItem("oTCPCurrentDataStore", JSON.stringify(this.__oTradingCounterpartyLegalHierarchyOwnerships));
        this.__oDataService.setTCPStore(this.__oTradingCounterpartyLegalHierarchyOwnerships);
        localStorage.setItem("CounterpartyStore", JSON.stringify(this.__oCounterParties));
        this.__oDataService.setCounterpartyStore(this.__oCounterParties);
        this.__bIsLimitLoadingVisible = false;
        this.loadInitData();
      });
    }
    catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while executing loadTradingCounterpartyLegalHierarchy function.');
    }
  }
  //End CRD-376-Pawan Prajapati

  loadInitData() {
    try {
      //this.collapseSidePanel();
      ///counterparty management GO click
      this.sub = this.route.params.subscribe(params => {
        this.TradingCounterparty = params['TradingCounterparty'];
        if (this.TradingCounterparty) {
          this.onLoad_GetDataFromService();
          this.getStaticDataFromAPI();
          this.loadCustomPropertyComponent();//FB44675-Pawan Prajapati
        }
      });

      let dDates: Dates = new Dates();
      this.__dtMaxTempDate = this.__dtMaxDate = dDates.dateAdd(new Date(new Date(this.__oSystemSettings[0].ValuationDate).getFullYear(), new Date(this.__oSystemSettings[0].ValuationDate).getMonth(), new Date(this.__oSystemSettings[0].ValuationDate).getDate() == 29 ? 1 : new Date(this.__oSystemSettings[0].ValuationDate).getDate()), this.__oSystemSettings[0].CounterpartyLimitMaxTenure - 1, "months");
      this.__dtMinTempDate = this.__dtMinDate = this.__dtMinFrom = new Date(this.__oSystemSettings[0].ValuationDate);//CRD-498-Pawan Prajapati
      this.__dValuationDate = new Date(this.__oSystemSettings[0].ValuationDate);
      this.__bIsLimitLoadingVisible = true;

      this.__oService.getAuthenticate().pipe(
        catchError((error) => {
          this.__bIsLimitLoadingVisible = false;
          throw Error(error);
        })
      ).subscribe((data: any) => {

        if (this.__oService.redirectToUnauthorizePage(data)) {
          this.__bIsLimitLoadingVisible = false;
          this.__oRouter.navigate(['/UnAuthorized/' + data]);
          return throwError(data);
        }
        this.__sUserName = data

        this.getStaticDataFromAPI();
      }

      );
    }
    catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while executing loadInitData function.');
    }

  }
  //Start FB44675-Pawan Prajapati
  ngAfterViewInit() {
    this.loadCustomPropertyComponent();
  }

  loadCustomPropertyComponent() {
    try {
      if (this.__oTradingcounterpartySearchView) {
        this.__oCustomPropertyComponent?.PopulateCustomProperty(this.__oTradingcounterpartySearchView.lTradingCounterpartyId);
      }
    } catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while executing loadCustomPropertyComponent function.');
    }
  }
  //End FB44675-Pawan Prajapati
  //static data from service
  private getStaticDataFromAPI() {
    try {
      this.__bIsLimitLoadingVisible = true;
      this.__oService.getDataByObservable(this.__sGetApiUrl + "api/CounterpartyLimit/2/0/true/TradingLimit/Authorize").subscribe((Data: any) => {
        if (Data != null) {
          let sPermissionInfo: string = Array.isArray(Data) == true ? Data[0] : Data.toString();
          this.__bIsDeleteRowEnabled = (sPermissionInfo.split(',')[2] == "1") ? true : false;
        }
      });

      this.__oService.getDataByObservable(this.__sGetApiUrl + "api/CounterpartyLimit/463/0/true/Authorize").subscribe((Data) => {
        if (Data != null) {
          this.__bAllowAddLimits = (Data[0] == "1") ? true : false;
        }
      });
      //Start FB46162-Pawan Prajapati
      this.__oService.getDataByObservable(this.__sGetApiUrl + "api/TradingLimit/DataEntityFieldName").subscribe((oDatas) => {
        this.__oFourEyeManager.setDataEntityFieldName(oDatas);
      });
      //End FB46162-Pawan Prajapati

      this.__oService.getDataByObservable(this.__sGetApiUrl + "api/CounterpartyLimit/OverallLimitSetting").subscribe((Data) => {
        if (Data != null) {
          this.__oOverallLimitSettings = Data;
        }
      });
      //Start FB47640-Pawan Prajapati
      this.__oService.getDataByObservable(this.__sGetApiUrl + "api/CounterpartyLimit/GetwfBusinessProcessDefinition").subscribe((oData) => {
        if (oData != null) {
          this.__owfBusinessProcessDefinition = oData;
        }
      });
      //End FB47640-Pawan Prajapati

      this.__oService.getDataByObservable(this.__sGetApiUrl + "api/TradingLimit/LimitTypes").subscribe((Data) => {
        if (Data != null) {
          this.__oLimitTypes = Data.sort((a, b) => a.LimitTypeName.localeCompare(b.LimitTypeName));
        }
      });
      if (this.__oUnits == null || this.__oUnits.length == 0) {//FB48011-Pawan Prajapati
        this.__oService.getDataByObservable(this.__sGetApiUrl + "api/TradingLimit/Units").subscribe((Data) => {
          if (Data != null) {
            this.__oUnits = Data;
          }
        });
      }
      if (this.__oTradingEntities == null || this.__oTradingEntities.length == 0) {//FB48011-Pawan Prajapati
        this.__oService.getDataByObservable(this.__sGetApiUrl + "api/CounterpartyLimit/GetRestrictedTradingEntities").subscribe((Data) => {//FB47392-Pawan Prajapati
          if (Data != null) {
            this.__oTradingEntities = Data;
          }
        });
      }
      //api/LetterOfCredit/TradingEntity
      if (this.__oSubLimitTypes == null || this.__oSubLimitTypes.length == 0) {//FB48011-Pawan Prajapati
        this.__oService.getDataByObservable(this.__sGetApiUrl + "api/TradingLimit/SubLimitType").subscribe((Data) => {
          if (Data != null) {
            this.__oSubLimitTypes = Data;
          }
        });
      }
      if (this.__oExchangeRateEFs == null || this.__oExchangeRateEFs.length == 0) {//FB48011-Pawan Prajapati
        this.__oService.getDataByObservable(this.__sGetApiUrl + "api/TradingLimit/ExchangeRateEF").subscribe((Data) => {
          if (Data != null) {
            this.__oExchangeRateEFs = Data;
          }
        });
      }
      // this.__bIsLimitLoadingVisible = true;
      //Start FB48011-Pawan Prajapati
      this.__oService.getDataByObservable(this.__sGetApiUrl + "api/CounterpartyLimit/TradingEntityLegalHierarchyOwnership/" + this.__oSystemSettings[0].lParentLimitEntityId).subscribe((oTradingEntityLegalHierarchyOwnership) => {
        if (oTradingEntityLegalHierarchyOwnership != null && oTradingEntityLegalHierarchyOwnership.length > 0) {
          this.__oTradingEntityLegalHierarchyOwnerships = oTradingEntityLegalHierarchyOwnership;
          this.__oOurEntityLegalHierarchyOwnerships = this.__oTradingEntityLegalHierarchyOwnerships[0].TradingEntityLegalHierarchyOwnershipForUltimateIds;
        }
        else {
          let oTradingEntityLegalHierarchyOwnerships: any[] = [];
          let oTradingEntityLegalHierarchyOwnership: any = {};

          oTradingEntityLegalHierarchyOwnership.lChildTradingEntityId = this.__oSystemSettings[0].lParentLimitEntityId;
          oTradingEntityLegalHierarchyOwnership.ChildTradingEntity = "";
          oTradingEntityLegalHierarchyOwnership.IdentityColumn = 1;
          oTradingEntityLegalHierarchyOwnership.ID = "1";
          oTradingEntityLegalHierarchyOwnerships.push(oTradingEntityLegalHierarchyOwnership);
          this.__oTradingEntityLegalHierarchyOwnerships = oTradingEntityLegalHierarchyOwnerships;
          this.__oOurEntityLegalHierarchyOwnerships = [];
        }
        this.__oService.getDataByObservable(this.__sGetApiUrl + "api/TradingLimit/" + this.__oTradingcounterpartySearchView.lTradingCounterpartyId + "/TradingCounterpartyLegalHierarchyOwnership").subscribe((oTradingCounterpartyLegalHierarchyOwnership) => {
          if (oTradingCounterpartyLegalHierarchyOwnership != null && oTradingCounterpartyLegalHierarchyOwnership.length > 0) {
            this.__oTradingCounterpartyLegalHierarchyOwnerships = oTradingCounterpartyLegalHierarchyOwnership;
          } else {
            this.__oTradingCounterpartyLegalHierarchyOwnerships = JSON.parse(localStorage.getItem("oTCPCurrentDataStore"));
          }
          this.__oService.getDataByObservable(this.__sGetApiUrl + "api/CounterpartyLimit/TradingCounterpartyLegalHierarchyOwnership/" + this.__oTradingcounterpartySearchView.lTradingCounterpartyId).subscribe((res) => {
            if (res != null) {
              this.__oCounterpartyLegalHierarchyOwnerships = res;
              this.__oService.getDataByObservable(this.__sGetApiUrl + "api/TradingLimit/TradingCategoryList").subscribe((Data) => {
                if (Data != null) {
                  this.__oTradingCategories = Data;
                  this.__oService.getDataByObservable(this.__sGetApiUrl + "api/CounterpartyLimit/columnDetails").subscribe((result) => {
                    if (result != null) {
                      this.__oColuDetails = result;
                      //let iColumnIndex: number = this.__iLimitValueStartIndex;
                      let iColumnIndex: number = 0;//CRD-420-Pawan Prajapati
                      this.createGridColumns(iColumnIndex, this.__oColuDetails);
                      this.__bIsLimitLoadingVisible = false;
                      this.__bSideBar = false;
                      this.btnEdit_Clicked();
                    }
                  });
                  this.__oService.getDataByObservable(this.__sGetApiUrl + "api/TradingLimit/TradingProduct").subscribe((Data) => {
                    if (Data != null) {
                      this.__oTradingProducts = Data;
                    }
                  });
                  this.__bIsLimitLoadingVisible = false;
                }
              });
            }
          });
        }
        );
      });
      //End FB48011-Pawan Prajapati
      if (this.__oTenorTypes == null || this.__oTenorTypes.length == 0) {//FB48011-Pawan Prajapati
        this.__oService.getDataByObservable(this.__sGetApiUrl + "api/TradingLimit/TenorTypes").subscribe((Data) => {
          if (Data != null) {
            this.__oTenorTypes = Data;
          }
        });
      }
      if (this.__oPeriodTypes == null || this.__oPeriodTypes.length == 0) {//FB48011-Pawan Prajapati
        this.__oService.getDataByObservable(this.__sGetApiUrl + "api/TradingLimit/PeriodTypes").subscribe((Data) => {
          if (Data != null) {
            this.__oPeriodTypes = Data;
          }
        });
      }
      if (this.__oCurrencies == null || this.__oCurrencies.length == 0) {//FB48011-Pawan Prajapati
        this.__oService.getDataByObservable(this.__sGetApiUrl + "api/TradingLimit/Currencies").subscribe((Data) => {
          if (Data != null) {
            this.__oCurrencies = Data;
          }
        });
      }
    } catch (oError) {
      this.Logger.Write(oError, 'Error', 'Error occurred while executing get Static Data From API function.');
    }
  }

  ///initialises instance
  onInitialized(event: any) {
    try {
      this.__otrCounterpartyLimits = event.component;
    } catch (oError) {
      this.Logger.Write(oError, 'Error', 'Error occurred while executing onInitialized function.');
    }
  }
  //fires when radio button value changes
  radioButton_OnValueChanged(event: any) {
    try {
      this.__bIsLimitLoadingVisible = true;
      event.value === false ? this.__sViewName = "Simple view" : this.__sViewName = "Timeline view";
      this.__bSwitch = event.value;
      if (this.__sViewName == "Simple view") {
        this.__bTimelineViewVisible = false;
        let iColumnIndex: number = 0;//CRD-420-Pawan Prajapati
        this.createGridColumns(iColumnIndex, this.__oColuDetails);
        this.updateWarnings();
      }
      else {
        this.__bTimelineViewVisible = true;
        let iColumnIndex: number = 0;//CRD-420-Pawan Prajapati
        this.createGridColumns(iColumnIndex, this.__oColuDetails);
        //let iColumnIndex = 9;
        //for (iColumnIndex; iColumnIndex < this.__oColuDetails.length; iColumnIndex++) {
        //    this.__otrCounterpartyLimits.instance.columnOption("DataValues[" + iColumnIndex + "].LimitValue", "visible", true);
        //}
      }

      // this.__otrCounterpartyLimits.instance.refresh();
      this.__otrCounterpartyLimits.instance.option('autoExpandAll', true);
      this.__otrCounterpartyLimits.instance.refresh();
      this.__bIsLimitLoadingVisible = false;
    }
    catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while executing radio button value changed event.');
    }
  }
  private refreshGridStyle() {
    try {
      setTimeout(() => {
        // this.__otrCounterpartyLimits.instance.refresh();
        this.__otrCounterpartyLimits.instance.option('autoExpandAll', true);
        this.__otrCounterpartyLimits.instance.refresh();
      }, 10);
    } catch (oError) {
      this.Logger.Write(oError, 'Error', 'Error occurred while executing refresh Grid Style function.');
    }
  }
  //forms api url

  //Selected tab click
  tab_Selected(e: any) {
    try {

      if (this.__sTabContent == "Limit Review Dates" && this.__oLimitTabs[e.itemIndex].text !== "Limit Review Dates") {
        this.__oDatasource = this.__oReviewDateComponent.transformTradingCounterpartyLimit(this.__oDatasource);
      }

      this.__sTabContent = this.__oLimitTabs[e.itemIndex].text;
      switch (this.__sTabContent) {
        case "General":
          this.__iTabIndex = 0;
          this.__sTabContent = this.__oLimitTabs[e.itemIndex].text;
          break;
        case "PCG Hierarchy":
          this.__iTabIndex = 1;
          this.__sTabContent = this.__oLimitTabs[e.itemIndex].text;
          break;
        case "Limit Review Dates":
          this.__bIsLimitLoadingVisible = true; this.__iTabIndex = 2;
          this.__sTabContent = this.__oLimitTabs[e.itemIndex].text;
          this.__oReviewDateComponent.formTradingCounterpartyLimit(); this.__bIsLimitLoadingVisible = false;
          break;
        case "Custom Properties":
          this.__iTabIndex = 3;
          this.__sTabContent = this.__oLimitTabs[e.itemIndex].text;
          break;
      }
      this.__sTabContent = this.__oLimitTabs[e.itemIndex].text;

    } catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while executing tab selection.');
    }
  }

  //date value changed should trigger limit values
  rollingMonth_ValueChanged(eventData: any, event: any, nRowNumber: any, sColumnName: string, name?: any) {
    try {
      if(name) {
        event[name] = eventData.value;
      }
      let dDates: Dates = new Dates();
      if (event.DataValues && event.DataValues.filter(x => x.LimitValue).length && event.TempDataValues && event.TempDataValues.filter(x => x.LimitValue).length) {
        let iLastValue = 0;
        let iLastValueIndex = 0;
        let iOverallLastValueIndex = 0;

        if (this.__oSystemSettings[0].IsOverAllLimitValidated && this.__oDatasource.find(x => x.lCounterpartyLimitId === event.lCounterpartyLimitId)) {

          let oParmanentLimit = this.__oDatasource.find(x => x.lCounterpartyLimitId === event.lCounterpartyLimitId)

          for (let i = oParmanentLimit.DataValues.length - 1; i >= 0; i--) {//CRD-420-Pawan Prajapati
            if (oParmanentLimit.DataValues[i].LimitValue) {
              iOverallLastValueIndex = i;
              event.RollingToMonthMax = i;//CRD-420-Pawan Prajapati
              let tempLimitMaxDate = dDates.dateAdd(new Date(this.__oSystemSettings[0].ValuationDate), (i), "months");//CRD-420-Pawan Prajapati
              event.TemporaryLimitToDateMax = new Date(tempLimitMaxDate.getFullYear(), tempLimitMaxDate.getMonth() + 1, 0);
              break;
            } else {
              event.TempDataValues[i].IsDisabled = true;
            }
          }
        }

        if (sColumnName === "To") {
          let iDiff = 0;
          if (event.TempLimitTenorTypeName === "Calendar") {
            iDiff = (new Date(event.TemporaryLimitToDate).getMonth() - new Date(this.__oSystemSettings[0].ValuationDate).getMonth() + (12 * (new Date(event.TemporaryLimitToDate).getFullYear() - new Date(this.__oSystemSettings[0].ValuationDate).getFullYear())));
            event.MaxRollingToDate = event.TemporaryLimitToDate;
            event.RollingToMonth = this.rollingMonth(new Date(event.TemporaryLimitToDate), "", false);
            //this.__dtMaxTempDate = event.TemporaryLimitToDate;
          } else {
            iDiff = event.RollingToMonth; //(new Date(event.RollingToMonth).getMonth() - new Date(this.__oSystemSettings[0].ValuationDate).getMonth() + (12 * (new Date(event.RollingToMonth).getFullYear() - new Date(this.__oSystemSettings[0].ValuationDate).getFullYear())));
            //event.MaxRollingToDate = event.TemporaryLimitToDate;
            //event.TemporaryLimitToDate = this.rollingMonth(new Date(event.TemporaryLimitToDate));
            //let temporaryLimitToDate = dDates.dateAdd(new Date(this.__oSystemSettings[0].ValuationDate), event.RollingToMonth, "months");
            //temporaryLimitToDate.setDate(new Date(event.TemporaryLimitToDate).getDate());
            //event.TemporaryLimitToDate = new Date(temporaryLimitToDate.getFullYear(), temporaryLimitToDate.getMonth() + 1, 0);//dDates.dateAdd(new Date(this.__oSystemSettings[0].ValuationDate), event.RollingToMonth, "months");
            let temporaryLimitToDate = dDates.dateAdd(new Date(this.__oSystemSettings[0].ValuationDate), event.RollingFromMonth, "months")
            let dtTemp: Date = new Date(new Date(temporaryLimitToDate).setDate(new Date(event.TemporaryLimitToDate).getDate()));
            event.TemporaryLimitToDate = dDates.dateAdd(dtTemp, (event.RollingToMonth - event.RollingFromMonth), "months");
          }

          for (let i = event.TempDataValues.length - 1; i >= 0; i--) {//CRD-420-Pawan Prajapati
            if (event.TempDataValues[i].LimitValue) {
              iLastValue = event.TempDataValues[i].LimitValue;
              iLastValueIndex = i + 1;

              if (event.TempDataValues[i].TempLimitEndDate && event.TempLimitTenorTypeName === "Rolling") {
                let dEndDate = new Date(event.TempDataValues[i].TempLimitEndDate);
                event.TempDataValues[i].lTradingLimitId > 0 ? (event.EntityState = 2, event.TempDataValues[i].EntityState = 2) : (event.EntityState = 1, event.TempDataValues[i].EntityState = 1);
                event.TempDataValues[i].TempLimitEndDate = this.formatDate(new Date(dEndDate.getFullYear(), dEndDate.getMonth() + 1, 0));
              }

              break;
            }
          }

          for (let i = iLastValueIndex;
            (i <= (iDiff)) && (i <= iOverallLastValueIndex || iOverallLastValueIndex == 0); i++) {//CRD-420-Pawan Prajapati
            event.TempDataValues[i].LimitValue = iLastValue;
            let tempLimitStartDate = dDates.dateAdd(new Date(this.__oSystemSettings[0].ValuationDate), (i), "months");//CRD-420-Pawan Prajapati
            (event.TempLimitTenorTypeName === "Calendar") && (!event.TempDataValues[i].TempLimitStartDate) ? ((event.TempDataValues[i].TempLimitStartDate = this.formatDate(new Date(tempLimitStartDate.getFullYear(), tempLimitStartDate.getMonth(), 1))), (event.TempDataValues[i].TempLimitEndDate = this.formatDate(new Date(tempLimitStartDate.getFullYear(), tempLimitStartDate.getMonth() + 1, 0)))) : "";
            if (event.TempLimitTenorTypeName === "Rolling") {
              event.TempDataValues[i].TempLimitStartDate = this.formatDate(new Date(tempLimitStartDate.getFullYear(), tempLimitStartDate.getMonth(), 1));
              event.TempDataValues[i].TempLimitEndDate = this.formatDate(new Date(tempLimitStartDate.getFullYear(), tempLimitStartDate.getMonth() + 1, 0));
              event.TempDataValues[i].RollingHaltDate = tempLimitStartDate;
            }
            event.TempDataValues[i].lTradingLimitId > 0 ? (event.EntityState = 2, event.TempDataValues[i].EntityState = 2) : (event.EntityState = 1, event.TempDataValues[i].EntityState = 1);
          }
          (event.TempDataValues[iDiff] && event.TempDataValues[iDiff].LimitValue) ? ((event.TempDataValues[iDiff].TempLimitEndDate = this.formatDate(event.TemporaryLimitToDate)), (event.TempDataValues[iDiff].lTradingLimitId > 0 ? (event.EntityState = 2, event.TempDataValues[iDiff].EntityState = 2) : (event.EntityState = 1, event.TempDataValues[iDiff].EntityState = 1))) : "";//CRD-420-Pawan Prajapati
          //event.MaxRollingToMonth = event.RollingToMonth

          //for (let i = (event.RollingFromMonth ? event.RollingFromMonth : iLastValueIndex+1); (i <= iLastValueIndex) && (i <= iOverallLastValueIndex || iOverallLastValueIndex == 0) && (event.TempLimitTenorTypeName === "Rolling"); i++) {
          //  event.TempDataValues[i].lTradingLimitId > 0 ? (event.EntityState = 2, event.TempDataValues[i].EntityState = 2) : (event.EntityState = 1, event.TempDataValues[i].EntityState = 1);
          //}

        }
        else {
          let iDiff = 0;
          if (event.TempLimitTenorTypeName === "Calendar") {
            iDiff = (new Date(event.TemporaryLimitFromDate).getMonth() - new Date(this.__oSystemSettings[0].ValuationDate).getMonth() + (12 * (new Date(event.TemporaryLimitFromDate).getFullYear() - new Date(this.__oSystemSettings[0].ValuationDate).getFullYear())));
          } else {
            iDiff = event.RollingFromMonth;
            event.TemporaryLimitFromDate = dDates.dateAdd(new Date(event.TemporaryLimitFromDate), event.RollingFromMonth, "months")
            //let temporaryLimitFromDate = dDates.dateAdd(new Date(this.__oSystemSettings[0].ValuationDate), event.RollingFromMonth, "months");
            //event.TemporaryLimitFromDate = new Date(temporaryLimitFromDate.getFullYear(), temporaryLimitFromDate.getMonth(), 1);//dDates.dateAdd(new Date(this.__oSystemSettings[0].ValuationDate), event.RollingFromMonth, "months")
          }
          iDiff = iDiff - 1;
          for (let i = 0; (i <= (iDiff)) && (i <= iOverallLastValueIndex || iOverallLastValueIndex == 0) && (iDiff >= 0); i++) {//CRD-420-Pawan Prajapati
            event.TempDataValues[i].LimitValue = null;
            event.TempDataValues[i].lTradingLimitId > 0 ? (event.EntityState = 2, event.TempDataValues[i].EntityState = 2) : (event.EntityState = 1, event.TempDataValues[i].EntityState = 1)
          }

          (event.TempLimitTenorTypeName === "Calendar") && (event.TempDataValues[iDiff + 1] && event.TempDataValues[iDiff + 1].LimitValue) ? ((event.TempDataValues[iDiff + 1].TempLimitStartDate = this.formatDate(event.TemporaryLimitFromDate)), (event.TempDataValues[iDiff + 1].lTradingLimitId > 0 ? (event.EntityState = 2, event.TempDataValues[iDiff + 1].EntityState = 2) : (event.EntityState = 1, event.TempDataValues[iDiff + 1].EntityState = 1))) : "";//CRD-420-Pawan Prajapati

          if (event.TempLimitTenorTypeName === "Rolling") {
            event.TempDataValues[iDiff + 1] && event.TempDataValues[iDiff + 1].LimitValue ? event.TempDataValues[iDiff + 1].TempLimitStartDate = this.formatDate(event.TemporaryLimitFromDate) : "";//CRD-420-Pawan Prajapati
            event.TempDataValues[iDiff + 1].lTradingLimitId > 0 ? (event.EntityState = 2, event.TempDataValues[iDiff + 1].EntityState = 2) : (event.EntityState = 1, event.TempDataValues[iDiff + 1].EntityState = 1);//CRD-420-Pawan Prajapati
          }
        }

        for (let i = event.TempDataValues.length - 1; i >= 0; i--) {//CRD-420-Pawan Prajapati
          if (event.TempDataValues[i] && event.TempLimitTenorTypeName === "Rolling" && event.TempDataValues[i].RollingHaltDate && event.TempDataValues[i].TempLimitEndDate && new Date(event.TempDataValues[i].RollingHaltDate) <= new Date(event.TemporaryLimitToDate)) {
            event.TempDataValues[i].IsLimitExpired = false;
          }
        }

        this.updateWarnings();
      }
    } catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while executing data value changed event to trigger limit values.');
    }
  }

  //date value changed should trigger limit values
  date_ValueChanged(eventData, event: any, nRowNumber: any, sColumnName: string, isDate?: boolean) {//CRD-420-Pawan Prajapati
    if(isDate) {
    event[sColumnName] = eventData.value;
    }
    try {
      if (event.DataValues && event.DataValues.filter(x => x.LimitValue || x.LimitValue===0).length) {//CRD-612 -Venkat
        let iOverallLastValueIndex = 0;

        if (this.__oSystemSettings[0].IsOverAllLimitValidated && event.TradingCategoryName !== 'Overall' && event.LimitTypeName !== 'Volume' && this.__oDatasource.find(x => x.lCounterpartyLimitId === event.lParentCounterpartyLimitId)) {

          let oOverall = this.__oDatasource.find(x => x.lCounterpartyLimitId === event.lParentCounterpartyLimitId)

          for (let i = oOverall.DataValues.length - 1; i >= 0; i--) {//CRD-420-Pawan Prajapati
            if (oOverall.DataValues[i].LimitValue || oOverall.DataValues[i].LimitValue === 0) {//CRD-612 -Venkat
              iOverallLastValueIndex = i;
              break;
            }
            else {
              event.DataValues[i].IsDisabled = true;
            }
          }
        }

        if (sColumnName === "To") {
          let iLastValue = 0;//CRD-498-Pawan Prajapati
          let iLastValueIndex = 0;//CRD-498-Pawan Prajapati
          let iDiff = (new Date(event.To).getMonth() - new Date(this.__oSystemSettings[0].ValuationDate).getMonth() + (12 * (new Date(event.To).getFullYear() - new Date(this.__oSystemSettings[0].ValuationDate).getFullYear())));

          for (let i = event.DataValues.length - 1; i >= 0; i--) {//CRD-420-Pawan Prajapati
            if (event.DataValues[i].LimitValue || event.DataValues[i].LimitValue === 0) {//CRD-612 -Venkat
              iLastValue = event.DataValues[i].LimitValue;
              iLastValueIndex = i + 1;
              break;
            }
          }
          //Start FB37914-Pawan Prajapati
          if (iLastValueIndex > iDiff) {//CRD-420-Pawan Prajapati
            for (let i = (iDiff + 1); i < iLastValueIndex; i++) {//CRD-420-Pawan Prajapati
              if (!event.DataValues[i].lOverallLimitSettingId) {//FB44260-Pawan Prajapati
                event.DataValues[i].LimitValue = null;
                event.DataValues[i].lTradingLimitId > 0 ? (event.EntityState = 2, event.DataValues[i].EntityState = 2) : (event.EntityState = 1, event.DataValues[i].EntityState = 1)
              }
            }
          } else {
            for (let i = iLastValueIndex;
              (i <= (iDiff)) && (i <= iOverallLastValueIndex || iOverallLastValueIndex == 0); i++) {//CRD-420-Pawan Prajapati
              if (!event.DataValues[i].lOverallLimitSettingId) {//FB44260-Pawan Prajapati
                event.DataValues[i].LimitValue = iLastValue;
                event.DataValues[i].lTradingLimitId > 0 ? (event.EntityState = 2, event.DataValues[i].EntityState = 2) : (event.EntityState = 1, event.DataValues[i].EntityState = 1)
              }
            }
          }

          event.MaxToDate = event.From;
          //End FB37914-Pawan Prajapati
          this.setFromToDateMonths(event);//FB44260-Pawan Prajapati
        }
        else {
          //Start CRD-498-Pawan Prajapati
          let iFirstValue = null;
          let iFirstValueIndex = 0;
          for (let i = 0; i <= event.DataValues.length - 1; i++) {
            if (event.DataValues[i].LimitValue) {
              iFirstValue = event.DataValues[i].LimitValue;
              iFirstValueIndex = i;
              break;
            }
          }

          let iDiff = (new Date(event.From).getMonth() - new Date(this.__oSystemSettings[0].ValuationDate).getMonth() + (12 * (new Date(event.From).getFullYear() - new Date(this.__oSystemSettings[0].ValuationDate).getFullYear())));
          if (iFirstValueIndex < iDiff) {
            for (let i = 0; (i < iDiff) && (i <= iOverallLastValueIndex || iOverallLastValueIndex == 0); i++) {
              if (!event.DataValues[i].lOverallLimitSettingId) {//FB44260-Pawan Prajapati
                event.DataValues[i].LimitValue = null;
                event.DataValues[i].lTradingLimitId > 0 ? (event.EntityState = 2, event.DataValues[i].EntityState = 2) : (event.EntityState = 1, event.DataValues[i].EntityState = 1)
              }
            }
          } else {
            for (let i = iDiff; (i < iFirstValueIndex) && (i <= iOverallLastValueIndex || iOverallLastValueIndex == 0); i++) {
              if (!event.DataValues[i].lOverallLimitSettingId) {//FB44260-Pawan Prajapati
                event.DataValues[i].LimitValue = iFirstValue;
                event.DataValues[i].lTradingLimitId > 0 ? (event.EntityState = 2, event.DataValues[i].EntityState = 2) : (event.EntityState = 1, event.DataValues[i].EntityState = 1)
              }
            }
          }
          //End CRD-498-Pawan Prajapati
          for (let i = 0;//CRD-420-Pawan Prajapati
            (i < iDiff) && (i <= iOverallLastValueIndex || iOverallLastValueIndex == 0); i++) {//CRD-420-Pawan Prajapati
            if (!event.DataValues[i].lOverallLimitSettingId) {//FB44260-Pawan Prajapati
              event.DataValues[i].LimitValue = null;
              event.DataValues[i].lTradingLimitId > 0 ? (event.EntityState = 2, event.DataValues[i].EntityState = 2) : (event.EntityState = 1, event.DataValues[i].EntityState = 1)
            }
          }

          this.__dtMinDate = new Date(event.From);
        }

        var evntData: any = {};
        evntData.data = event;
        evntData.columnIndex = 0;//CRD-420-Pawan Prajapati
        (evntData.data.DataValues.filter(x => x.EntityState == 0 || x.EntityState == 2) && evntData.data.DataValues.filter(x => x.EntityState == 0 || x.EntityState == 2).length > 0) ? evntData.data.EntityState = 2 : null;

        this.checkForAnyLimitBreachByRow(evntData, false);
        this.updateWarnings();
        this.setFromToDateMonths(event);//FB44260-Pawan Prajapati
        if (this.__oLimitCustomProperties && this.__oLimitCustomProperties.length > 0) {
          evntData.data.DataValues.forEach((d, index) => {
            if (evntData.data.EntityState == 2) {
              if (d.lTradingLimitId > 0) {
                evntData.data.CustomPropertyEntityState = 3;
              }
            }
          });

        }
        if (this.__oLimitCustomProperties && this.__oLimitCustomProperties.length > 0) {
          evntData.data.DataValues.forEach((d, index) => {
            if (evntData.data.EntityState == 2) {
              if (d.lTradingLimitId > 0) {
                evntData.data.CustomPropertyEntityState = 3;
              }
            }
          });

        }
        this.refreshGridStyle();
      }
    }
    catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while executing data value changed event to trigger limit values.');
    }
  }

  //fires  on limit value change
  limitValue_Changed(event: any, data: any, evt: any, columnIndex: any, isTempLimit: boolean) {
    try {
      //Start FB43273-Pawan Prajapati
      if (data.EntityState == DataEntityState.Added && data.To && data.DataValues.filter(k => k.LimitValue || k.LimitValue === 0).length == 1 && !this.__bTimelineViewVisible) {//CRD-612 -Venkat
        this.date_ValueChanged(event, data, 0, 'To');
        this.refreshGridStyle();
        return;
      }
      //End FB43273-Pawan Prajapati
      this.__bIsLimitLoadingVisible = true;
      let iLastValue = 0;
      let iLastValueIndex = 0;
      let dDates: Dates = new Dates();

      if (data.DataValues && data.DataValues.length > 0) {
        data.DataValues.forEach(x => {
          if (x.LimitValue || x.LimitValue === 0) {
            x.LimitValue = Math.abs(x.LimitValue);
          }
        });
      }

      if (data.TempDataValues && data.TempDataValues.length > 0) {
        data.TempDataValues.forEach(x => {
          if (x.LimitValue || x.LimitValue === 0) {
            x.LimitValue = Math.abs(x.LimitValue);
          }
        });
      }

      if (isTempLimit) {
        data.TempDataValues && data.TempDataValues[columnIndex].lTradingLimitId > 0 ? (data.EntityState = 2, data.TempDataValues[columnIndex].EntityState = 2) : (data.EntityState = 1, data.TempDataValues[columnIndex].EntityState = 1);
      } else {
        data.DataValues[columnIndex].lTradingLimitId > 0 ? (data.EntityState = 2, data.DataValues[columnIndex].EntityState = 2) : (data.EntityState = 1, data.DataValues[columnIndex].EntityState = 1);
      }

      var iSum = 0;
      for (let i = data.DataValues.length - 1; i >= 0; i--) {//CRD-420-Pawan Prajapati
        if ((data.DataValues[i].LimitValue || data.DataValues[i].LimitValue === 0) && iLastValueIndex == 0 && !isTempLimit) {
          iLastValue = data.DataValues[i].LimitValue;
          iLastValueIndex = i;
          if (this.__bTimelineViewVisible) {
            break;
          }
        }

        if (data.TempDataValues && data.TempDataValues.length != 0 && (data.TempDataValues[i].LimitValue || data.TempDataValues[i].LimitValue === 0) && iLastValueIndex == 0 && isTempLimit) {
          iLastValue = data.TempDataValues[i].LimitValue;
          iLastValueIndex = i;
          if (this.__bTimelineViewVisible) {
            break;
          }
        }
        if (isTempLimit) {
          !this.__bTimelineViewVisible && i != columnIndex && iLastValueIndex !== 0 ? (data.TempDataValues[i].LimitValue = data.TempDataValues[columnIndex].LimitValue, (data.TempDataValues[i].lTradingLimitId > 0 ? (data.EntityState = 2, data.TempDataValues[i].EntityState = 2) : (data.EntityState = 1, data.TempDataValues[i].EntityState = 1))) : null;
        } else {
          !this.__bTimelineViewVisible && i != columnIndex && iLastValueIndex !== 0 ? (data.DataValues[i].LimitValue = data.DataValues[columnIndex].LimitValue, (data.DataValues[i].lTradingLimitId > 0 ? (data.EntityState = 2, data.DataValues[i].EntityState = 2) : (data.EntityState = 1, data.DataValues[i].EntityState = 1))) : null;
        }

      }

      var evntData: any = {};
      evntData.data = data;
      evntData.columnIndex = columnIndex;

      //let oCounterpartyLimitsManager: CounterpartyLimitsManager = new CounterpartyLimitsManager();
      //this.__oDatasource = oCounterpartyLimitsManager.updateWarningsForCommodity(this.__bSidebarApply, this.__oDatasource, this.__oSystemSettings, this.__oExchangeRateEFs, this.__otrCounterpartyLimits, this.__oTradingCounterpartyLegalHierarchyOwnerships, this.Logger, this.__oUtilityService);
      //this.updateWarningsForCommodity();

      this.getMaxOrOverAllocation(evntData, false);
      this.checkForAnyLimitBreachByRow(evntData, true);
      //this.__bTimelineViewVisible ? this.updateWarnings() : "";
      this.updateWarnings();
      this.__oSystemSettings[0].IsOverallLimitEditable === 0 ? this.__oDatasource.forEach(x => { if (x.TradingCategoryName === "Overall") { x.Warnings = [] } }) : "";

      let iMin = data.DataValues.filter(x => x.LimitValue != null).length > 0 ? (Math.min(...data.DataValues.filter(x => x.LimitValue != null).map(x => x.lDataValueId))) : -1;
      if (iMin != -1) {//FB39932/CRD-420-Pawan Prajapati
        //Start FB37914/CRD-420-Pawan Prajapati
        data.MaxToDate = data.From = dDates.dateAdd(new Date(this.__oSystemSettings[0].ValuationDate), iMin, "months");
        data.To = dDates.dateAdd(new Date(this.__oSystemSettings[0].ValuationDate), (iLastValueIndex), "months");//dDates.dateAdd(new Date(data.From), (iLastValueIndex - 9), "months");
        //End FB37914/CRD-420-Pawan Prajapati
        this.__dtMinDate = new Date(data.From);
      }
      //PD-116 changes start setting from and to date when overall limit updates automatically sub limit value change
      if (this.__oSystemSettings[0].IsOverallLimitEditable === 0) {
        let oOveralllimit = this.__oDatasource.find(x => x.lTradingCounterpartyId == data.lTradingCounterpartyId && x.lOurEntityId == data.lOurEntityId && x.lLimitTypeId == data.lLimitTypeId && x.TradingCategoryName == 'Overall');
        if (oOveralllimit != null && oOveralllimit != undefined)
          this.setFromToDateMonths(oOveralllimit);
      }
      //PD-116 changes END setting from and to date when overall limit updates automatically upon sub limit value change
      this.__bIsLimitLoadingVisible = false;
      this.checkFourEyeWarningMessage(data);//FB46162-Pawan Prajapati
      this.refreshGridStyle();//FB44260-Pawan Prajapati
    }
    catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while executing limit value changed event.');
    }
  }
  //fires  on adding new row
  btnAddNew_Click() {

    try {
      this.__oLimitCounterParties = this.__oSystemSettings[0].IsCompleteHeirarchyLoadedByDefault ? this.__oCounterParties : this.__oCounterParties.filter(x => x.TradingCounterpartyName === this.__oTradingcounterpartySearchView.TradingCounterparty);
      this.__bAddNewVisible = true;
      this.__oNewLimit = {};
      this.__sPopupDuplicateMessage = "";
      this.__bIsAddNewLimitFormFilled = false;
      this.__bIsOverallNeedToBeCreate = false;//CRD-1034-Pawan Prajapati
      this.__oSystemSettings[0].IsOverallLimitEditable === 2 ? (this.__oPopupTradingCategories = this.__oTradingCategories.filter(x => x.TradingCategoryName.toLowerCase() !== "overall")) : (this.__oPopupTradingCategories = this.__oTradingCategories);
    } catch (oError) {
      this.Logger.Write(oError, 'Error', 'Error occurred while executing btn Add New Click function.');
    }
  }
  btnAddTempLimit_Click() {
    //this.__oNewTempLimit = {};
    //this.__sPopupMessage = "Fill all mandatory  fields to continue";
    //this.__bIsAddNewTempLimitFormFilled = false;
    let dDates: Dates = new Dates();
    try {
      if (!this.__oNewTempLimit.ActiveFrom || !this.__oNewTempLimit.ActiveUntil || !this.__oNewTempLimit.LimitValue) {
        this.__sTempPopupMessage = "Fill all mandatory  fields to continue";
        this.__bIsAddNewTempLimitFormFilled = false;
        return;
      }

      //this.__oMonthNames[dDates.dateAdd(new Date(this.__oSystemSettings[0].ValuationDate), i - 9, "months").getMonth()] + "-" + dDates.dateAdd(new Date(this.__oSystemSettings[0].ValuationDate), i - 9, "months").getFullYear();
      let iStartIndex = this.monthDiff(new Date(this.__oSystemSettings[0].ValuationDate), new Date(this.__oNewTempLimit.ActiveFrom));//CRD-420-Pawan Prajapati
      let iEndIndex = this.monthDiff(new Date(this.__oSystemSettings[0].ValuationDate), new Date(this.__oNewTempLimit.ActiveUntil));//CRD-420-Pawan Prajapati

      if (!this.__oNewTempLimit.Info.data.TempDataValues) {
        this.__oNewTempLimit.Info.data.TempDataValues = [];
        for (let iCount = 0; iCount < this.__oNewTempLimit.Info.data.DataValues.length; iCount++) {
          let oTempDataValue: any = {};
          oTempDataValue.lTradingLimitId = 0;
          oTempDataValue.ColumnName = this.__oNewTempLimit.Info.data.DataValues[iCount].ColumnName;
          oTempDataValue.IsTempLimit = true;
          this.__oNewTempLimit.Info.data.TempDataValues.push(oTempDataValue);
        }
      }

      this.__oNewTempLimit.Info.data.TemporaryLimitFromDate = new Date(this.__oNewTempLimit.ActiveFrom);
      this.__oNewTempLimit.Info.data.TemporaryLimitToDate = new Date(this.__oNewTempLimit.ActiveUntil);

      this.__oNewTempLimit.Info.data.RollingFromMonth = this.rollingMonth(new Date(this.__oNewTempLimit.ActiveFrom), "", false);
      this.__oNewTempLimit.Info.data.RollingToMonth = this.rollingMonth(new Date(this.__oNewTempLimit.ActiveUntil), "", false);

      this.addAmendTempLimit(iStartIndex, iEndIndex, false);

      //for (let iCount = 9; iCount < this.__oNewTempLimit.Info.data.DataValues.length; iCount++)
      //{
      //  if (iCount >= iStartIndex && iCount <= iEndIndex)
      //  {
      //    //this.__oNewTempLimit.Info.data.DataValues[iCount].lTradingLimitId > 0 ? this.__oNewTempLimit.Info.data.DataValues[iCount].EntityState = 2 : this.__oNewTempLimit.Info.data.DataValues[iCount].EntityState = 1;
      //    if (this.__oNewTempLimit.Info.data.TempDataValues && this.__oNewTempLimit.Info.data.TempDataValues.length > 0 && this.__oNewTempLimit.Info.data.TempDataValues[iCount])
      //    {
      //      this.__oNewTempLimit.Info.data.TempDataValues[iCount].lTradingLimitId > 0 ? this.__oNewTempLimit.Info.data.TempDataValues[iCount].EntityState = 2 : this.__oNewTempLimit.Info.data.TempDataValues[iCount].EntityState = 1;
      //    }
      //    else
      //    {
      //      this.__oNewTempLimit.Info.data.TempDataValues[iCount] = {};
      //      this.__oNewTempLimit.Info.data.TempDataValues[iCount].lTradingLimitId = 0;
      //      this.__oNewTempLimit.Info.data.TempDataValues[iCount].EntityState = 1;
      //    }

      //    this.__oNewTempLimit.Info.data.TempDataValues[iCount].IsTempLimit = true;
      //    this.__oNewTempLimit.Info.data.TempDataValues[iCount].LimitValue = this.__oNewTempLimit.LimitValue;
      //    this.__oNewTempLimit.Info.data.TempDataValues[iCount].ColumnName = this.__oNewTempLimit.Info.data.DataValues[iCount].ColumnName;

      //    let dTempStartDate: Date = dDates.dateAdd(new Date(this.__oNewTempLimit.ActiveFrom), iCount - iStartIndex, "months");
      //    let dtActiveFrom: Date = new Date(new Date(this.__oNewTempLimit.ActiveFrom).getFullYear(), new Date(this.__oNewTempLimit.ActiveFrom).getMonth(), new Date(this.__oNewTempLimit.ActiveFrom).getDay());
      //    let dtActiveUntil: Date = new Date(new Date(this.__oNewTempLimit.ActiveUntil).getFullYear(),new Date(this.__oNewTempLimit.ActiveUntil).getMonth(),new Date(this.__oNewTempLimit.ActiveUntil).getDay());

      //    this.__oNewTempLimit.Info.data.TempDataValues[iCount].TempLimitStartDate = iCount === iStartIndex ? new Date(dtActiveFrom) : new Date(dTempStartDate.getFullYear(), dTempStartDate.getMonth(), 1);
      //    this.__oNewTempLimit.Info.data.TempDataValues[iCount].TempLimitEndDate = iCount === iEndIndex ? new Date(dtActiveUntil) : new Date(dTempStartDate.getFullYear(), dTempStartDate.getMonth() + 1, 0);

      //    this.__oNewTempLimit.Info.data.TempDataValues[iCount].TempLimitStartDate = this.formatDate(this.__oNewTempLimit.Info.data.TempDataValues[iCount].TempLimitStartDate);
      //    this.__oNewTempLimit.Info.data.TempDataValues[iCount].TempLimitEndDate = this.formatDate(this.__oNewTempLimit.Info.data.TempDataValues[iCount].TempLimitEndDate);
      //  }
      //}
      //this.__oNewTempLimit.Info.data.IsTempLimitAllocated = 1;
      //this.__oNewTempLimit.Info.data.SubLimitTypeName = "Temporary";
      //this.__oNewTempLimit.Info.data.EntityState = 2;
      //this.__oDatasource.filter(x => x.lCounterpartyLimitId == this.__oNewTempLimit.Info.data.lCounterpartyLimitId)[0] = this.__oNewTempLimit.Info.data;

      this.__bIsAddNewTempLimitFormFilled = true;
      this.__bAddNewTemporaryLimitVisible = false;
      this.checkFourEyeWarningMessage(this.__oNewTempLimit.Info.data);//FB46162-Pawan Prajapati
      this.refreshGridStyle();
    } catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while adding new entry into datagrid.');
    }
  }

  formatDate(dDate: Date): Date {
    let dt;
    try {
      if (dDate) {
        dt = this.__oUtilityService.toLocalISODate(new Date(dDate));
      }
    } catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while formating date.');
    }

    return dt;
  }
  openTempLimitPopup(event: any) {
    try {
      this.__oNewTempLimit = {};
      this.__oNewTempLimit.ActiveFrom = new Date(event.data.From);//CRD-1125 Pawan Prajapati
      this.__oNewTempLimit.ActiveFromPeriod = this.calculatePeriodFromDate(event.data.From); //CRD-1125 Pawan Prajapati
      this.__oNewTempLimit.ActiveUntil = "";
      this.__oNewTempLimit.Info = event;
      this.__oNewTempLimit.Info.columnIndex = 0;//CRD-420-Pawan Prajapati
      this.__oNewTempLimit.Info.data.IsTempLimitActive = false;
      //this.__bAddNewTemporaryLimitVisible = true;
      this.onTempLimitCell_Click(this.__oNewTempLimit.Info);
      if (this.__oNewTempLimit.Info.data.DataValues.filter(x => x.LimitValue !== undefined && x.LimitValue !== "" && x.LimitValue !== null).length === 0) {
        //let widgetOptions =
        //{
        //  message: "There is no permanent limit available to add temp limits.",
        //  closeOnClick: true
        //};
        this.__oConfirmationComponent.show(ConfirmationType.Error, "There is no permanent limit available to add temp limits.", "Error", "Ok", "", false);
        this.__bAddNewTemporaryLimitVisible = false;
      }
      else {
        this.__bAddNewTemporaryLimitVisible = true;
      }
    } catch (oError) {
      this.Logger.Write(oError, 'Error', 'Error occurred while executing open Temp Limit Popup function.');
    }
  }

  // fires when pop up cancel button
  btnPopUpCancel_Click() {
    try {
      this.__bAddNewVisible = false;
      this.__bIsAddNewLimitFormFilled = true;
      this.__bAddNewTemporaryLimitVisible = false;
      this.__bIsOverallNeedToBeCreate = false;//CRD-1034-Pawan Prajapati
    } catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred on pop up cancel click.');
    }
  }
  //Start CRD-1034-Pawan Prajapati
  onCheckOverallLimitExistOrNot() {
    if (!this.__oNewLimit || !this.__oNewLimit.TradingCounterpartyName || !this.__oNewLimit.TradingEntityName || !this.__oNewLimit.LimitTypeName || (!this.__oNewLimit.TradingCategoryName && !this.__oNewLimit.TradingProductName)) {
      this.__bIsOverallNeedToBeCreate = false;
      return;
    }
    let oLimit = null;
    if (this.__oNewLimit.LimitTypeName !== 'Volume') {
      oLimit = this.__oDatasource.filter(x => x.TradingCounterpartyName == this.__oNewLimit.TradingCounterpartyName && x.TradingEntityName == this.__oNewLimit.TradingEntityName && x.LimitTypeName == this.__oNewLimit.LimitTypeName && x.TradingCategoryName == this.__oNewLimit.TradingCategoryName);
    } else {
      oLimit = this.__oDatasource.filter(x => x.TradingCounterpartyName == this.__oNewLimit.TradingCounterpartyName && x.TradingEntityName == this.__oNewLimit.TradingEntityName && x.LimitTypeName == this.__oNewLimit.LimitTypeName && x.TradingProductName == this.__oNewLimit.TradingProductName);
    }
    this.__sPopupDuplicateMessage = '';
    if (oLimit && oLimit.length > 0) {
      this.__sPopupDuplicateMessage = "The selected combination already exists.";
      this.__bIsOverallNeedToBeCreate = false;
      return;
    }
    let oLimitOverall = this.__oDatasource.filter(x => x.TradingCounterpartyName == this.__oNewLimit.TradingCounterpartyName && x.TradingEntityName == this.__oNewLimit.TradingEntityName && x.LimitTypeName == this.__oNewLimit.LimitTypeName && x.TradingCategoryName == "Overall");
    this.__bIsOverallNeedToBeCreate = (this.__oNewLimit.LimitTypeName !== 'Volume' && (!oLimitOverall || oLimitOverall.length === 0) && this.__oNewLimit.TradingCategoryName !== "Overall" && this.__oSystemSettings[0].IsOverAllLimitValidated == 1)
  }
  //Adds new entry into datagrid
  btnContinue_Click(bIsSystemTriggeredEvent: boolean) {
    if (this.__bIsOverallNeedToBeCreate) {
      let oSubLimit = JSON.parse(JSON.stringify(this.__oNewLimit));
      this.__oNewLimit.TradingCategoryName = 'Overall';
      this.btnAddNewLimit_Click(bIsSystemTriggeredEvent);
      this.__bIsOverallNeedToBeCreate = false;
      this.__oNewLimit = JSON.parse(JSON.stringify(oSubLimit));
    }
    this.btnAddNewLimit_Click(bIsSystemTriggeredEvent);
  }
  //End CRD-1034-Pawan Prajapati
  btnAddNewLimit_Click(bIsSystemTriggeredEvent: boolean) {
    try {
      if (!this.__oNewLimit.TradingCounterpartyName || !this.__oNewLimit.TradingEntityName || !this.__oNewLimit.LimitTypeName || (!this.__oNewLimit.TradingCategoryName && !this.__oNewLimit.TradingProductName)) {
        this.__bIsAddNewLimitFormFilled = false;
        return;
      }

      this.__bIsAddNewLimitFormFilled = true;
      let oCounterpartyLimitViewModel: CounterpartyLimitViewModel = new CounterpartyLimitViewModel();
      oCounterpartyLimitViewModel.EntityState = 1;
      this.__ilParentCounterpartyLimitId = oCounterpartyLimitViewModel.lCounterpartyLimitId = this.__oUtilityService.generateUniqueKey();

      oCounterpartyLimitViewModel.TradingCounterpartyName = this.__oNewLimit.TradingCounterpartyName;
      oCounterpartyLimitViewModel.TradingEntityName = this.__oNewLimit.TradingEntityName;
      oCounterpartyLimitViewModel.LimitTypeName = this.__oNewLimit.LimitTypeName;
      oCounterpartyLimitViewModel.TradingCategoryName = this.__oNewLimit.TradingCategoryName;
      if (oCounterpartyLimitViewModel.TradingCategoryName) {
        oCounterpartyLimitViewModel.IsOverall = this.__oTradingCategories.find(x => x.TradingCategoryName === this.__oNewLimit.TradingCategoryName).IsOverall;
        oCounterpartyLimitViewModel.lParentTradingCategoryId = this.__oTradingCategories.find(x => x.TradingCategoryName === this.__oNewLimit.TradingCategoryName).lParentTradingCategoryId;
        oCounterpartyLimitViewModel.TradingCategoryLevel = this.__oTradingCategories.find(x => x.TradingCategoryName === this.__oNewLimit.TradingCategoryName).TradingCategoryLevel;
      }
      oCounterpartyLimitViewModel.TradingProductName = this.__oNewLimit.TradingProductName;
      var CounterParty = this.__oLimitCounterParties.find(x => x.TradingCounterpartyName === this.__oNewLimit.TradingCounterpartyName);
      if (!this.__oUtilityService.IsNullOrUndefined(CounterParty) && CounterParty.IsSave) {
        oCounterpartyLimitViewModel.IsTradingCounterpartyInstanceSaveAccess = true;
      }
      oCounterpartyLimitViewModel.LimitCustomPropertyValues = [];//CRD-408 Pawan Prajapati
      var oLimit = [];

      if (this.__oNewLimit.LimitTypeName !== 'Volume') {
        oLimit = this.__oDatasource.filter(x => x.TradingCounterpartyName == this.__oNewLimit.TradingCounterpartyName && x.TradingEntityName == this.__oNewLimit.TradingEntityName && x.LimitTypeName == this.__oNewLimit.LimitTypeName && x.TradingCategoryName == this.__oNewLimit.TradingCategoryName);
      } else {
        oLimit = this.__oDatasource.filter(x => x.TradingCounterpartyName == this.__oNewLimit.TradingCounterpartyName && x.TradingEntityName == this.__oNewLimit.TradingEntityName && x.LimitTypeName == this.__oNewLimit.LimitTypeName && x.TradingProductName == this.__oNewLimit.TradingProductName);
      }

      let oLimitOverall = this.__oDatasource.filter(x => x.TradingCounterpartyName == this.__oNewLimit.TradingCounterpartyName && x.TradingEntityName == this.__oNewLimit.TradingEntityName && x.LimitTypeName == this.__oNewLimit.LimitTypeName && x.TradingCategoryName == "Overall");

      if (this.__oNewLimit.LimitTypeName !== 'Volume' && (!oLimitOverall || oLimitOverall.length === 0) && this.__oNewLimit.TradingCategoryName !== "Overall" && this.__oSystemSettings[0].IsOverAllLimitValidated && this.__oSystemSettings[0].IsOverallLimitEditable === 2) {
        this.__sPopupDuplicateMessage = "The Overall Limit for this selection doesn't exist, please add Overall Limit.";
        this.__bIsAddNewLimitFormFilled = false;
        return;
      }

      this.__bIsAddNewLimitFormFilled = true;
      this.__sPopupDuplicateMessage = "";

      if (oLimit && oLimit.length > 0) {
        this.__sPopupDuplicateMessage = "The selected combination already exists.";
        this.__bIsAddNewLimitFormFilled = false;
        return;
      }
      this.__bIsAddNewLimitFormFilled = true;
      this.__sPopupDuplicateMessage = "";
      oCounterpartyLimitViewModel.TradingCategoryName = this.__oNewLimit.TradingCategoryName;

      oCounterpartyLimitViewModel.lTradingCounterpartyId = this.__oCounterParties.find(x => x.TradingCounterpartyName == this.__oNewLimit.TradingCounterpartyName).lTradingCounterpartyId;
      oCounterpartyLimitViewModel.lOurEntityId = this.__oTradingEntities.find(x => x.TradingEntityName == this.__oNewLimit.TradingEntityName).lTradingEntityId;
      oCounterpartyLimitViewModel.lLimitTypeId = this.__oLimitTypes.find(x => x.LimitTypeName == this.__oNewLimit.LimitTypeName).lLimitTypeId;
      this.__oNewLimit.LimitTypeName !== 'Volume' ? oCounterpartyLimitViewModel.lTradingCategoryId = this.__oTradingCategories.find(x => x.TradingCategoryName == this.__oNewLimit.TradingCategoryName).lTradingCategoryId : (oCounterpartyLimitViewModel.lTradingProductId = this.__oTradingProducts.find(x => x.TradingProductName == this.__oNewLimit.TradingProductName).lTradingProductId, oCounterpartyLimitViewModel.lUnitId = this.__oSystemSettings[0].lBaseUnitId);
      oCounterpartyLimitViewModel.SubLimitTypeName = this.__oNewLimit.TradingCategoryName == 'Headroom' ? 'HeadRoom' : "Permanent";//FB44260-Pawan Prajapati
      oCounterpartyLimitViewModel.lSubLimitTypeId = this.__oSubLimitTypes.find(x => x.SubLimitTypeName == oCounterpartyLimitViewModel.SubLimitTypeName).lSubLimitTypeId;//FB44260-Pawan Prajapati
      oCounterpartyLimitViewModel.lPeriodTypeId = this.__oPeriodTypes.filter(x => x.PeriodTypeName == "Month(s)")[0].lPeriodTypeId;
      oCounterpartyLimitViewModel.DataValues = [];
      oCounterpartyLimitViewModel.lTenorTypeId = this.__oSystemSettings[0].IsCalendarLimit === 1 ? this.__oTenorTypes.find(x => x.TenorTypeName == "Calendar").lTenorTypeId : this.__oTenorTypes.find(x => x.TenorTypeName == "Rolling").lTenorTypeId;
      oCounterpartyLimitViewModel.TenorTypeName = this.__oSystemSettings[0].IsCalendarLimit === 1 ? this.__oTenorTypes.find(x => x.TenorTypeName == "Calendar").TenorTypeName : this.__oTenorTypes.find(x => x.TenorTypeName == "Rolling").TenorTypeName;

      this.__oNewLimit.LimitTypeName !== 'Volume' ? oCounterpartyLimitViewModel.lLimitValueCurrencyId = this.__oTradingCategories.find(x => x.TradingCategoryName == this.__oNewLimit.TradingCategoryName).lDefaultLimitCurrencyId : oCounterpartyLimitViewModel.lLimitValueCurrencyId = this.__oSystemSettings[0].lBaseCurrencyId;//oCounterpartyLimitViewModel.lUnitId = this.__oSystemSettings[0].lBaseUnitId;
      this.__oNewLimit.LimitTypeName !== 'Volume' ? oCounterpartyLimitViewModel.CurrencyName = this.__oCurrencies.find(x => x.lCurrencyId == oCounterpartyLimitViewModel.lLimitValueCurrencyId).CurrencyName : oCounterpartyLimitViewModel.UnitName = this.__oUnits.find(x => x.lUnitId == this.__oSystemSettings[0].lBaseUnitId).UnitName;

      oCounterpartyLimitViewModel.From = this.__oSystemSettings[0].ValuationDate;
      oCounterpartyLimitViewModel.MaxToDate = this.__oSystemSettings[0].ValuationDate;
      oCounterpartyLimitViewModel.lParentTradingCounterpartyId = (this.__oCounterpartyLegalHierarchyOwnerships.filter(x => x.lChildTradingCounterpartyId == oCounterpartyLimitViewModel.lTradingCounterpartyId) && this.__oCounterpartyLegalHierarchyOwnerships.filter(x => x.lChildTradingCounterpartyId == oCounterpartyLimitViewModel.lTradingCounterpartyId).length > 0) ? this.__oCounterpartyLegalHierarchyOwnerships.find(x => x.lChildTradingCounterpartyId == oCounterpartyLimitViewModel.lTradingCounterpartyId).lParentTradingCounterpartyId : -1;
      oCounterpartyLimitViewModel.lParentTradingEntityId = (this.__oOurEntityLegalHierarchyOwnerships.filter(x => x.lChildTradingEntityId == oCounterpartyLimitViewModel.lOurEntityId) && this.__oOurEntityLegalHierarchyOwnerships.filter(x => x.lChildTradingEntityId == oCounterpartyLimitViewModel.lOurEntityId).length > 0) ? this.__oOurEntityLegalHierarchyOwnerships.find(x => x.lChildTradingEntityId == oCounterpartyLimitViewModel.lOurEntityId).lParentTradingEntityId : -1;
      oCounterpartyLimitViewModel.Warnings = [];

      if (this.__oNewLimit.LimitTypeName !== 'Volume') {
        let oDatasource: any[] = [];
        if (oCounterpartyLimitViewModel.lParentTradingCategoryId === 1) {
          oDatasource = this.__oDatasource.filter(z => z.lTradingCounterpartyId == oCounterpartyLimitViewModel.lTradingCounterpartyId
            && z.lOurEntityId == oCounterpartyLimitViewModel.lOurEntityId
            && z.lPeriodTypeId == oCounterpartyLimitViewModel.lPeriodTypeId
            && z.lLimitTypeId == oCounterpartyLimitViewModel.lLimitTypeId
            && z.lSubLimitTypeId == oCounterpartyLimitViewModel.lSubLimitTypeId
            && z.lTradingCategoryId == 1)//FB43985-Pawan Prajapati
        }
        else {
          oDatasource = this.__oDatasource.filter(z => z.lTradingCounterpartyId == oCounterpartyLimitViewModel.lTradingCounterpartyId
            && z.lOurEntityId == oCounterpartyLimitViewModel.lOurEntityId
            && z.lPeriodTypeId == oCounterpartyLimitViewModel.lPeriodTypeId
            && z.lLimitTypeId == oCounterpartyLimitViewModel.lLimitTypeId
            && z.lSubLimitTypeId == oCounterpartyLimitViewModel.lSubLimitTypeId
            && z.lTradingCategoryId == oCounterpartyLimitViewModel.lParentTradingCategoryId)//FB43985-Pawan Prajapati
        }


        let oParentDataSource: any[] = this.__oDatasource.filter(z => z.lTradingCounterpartyId == oCounterpartyLimitViewModel.lParentTradingCounterpartyId
          && z.lOurEntityId == oCounterpartyLimitViewModel.lOurEntityId
          && z.lPeriodTypeId == oCounterpartyLimitViewModel.lPeriodTypeId
          && z.lLimitTypeId == oCounterpartyLimitViewModel.lLimitTypeId
          && z.lSubLimitTypeId == oCounterpartyLimitViewModel.lSubLimitTypeId
          && z.lTradingCategoryId == 1);//FB43985-Pawan Prajapati

        if (oCounterpartyLimitViewModel.lTradingCategoryId != 1 && oDatasource.length > 0) {
          oCounterpartyLimitViewModel.lParentCounterpartyLimitId = oDatasource[0].lCounterpartyLimitId;
        }

        else if (oParentDataSource.length > 0) {
          oCounterpartyLimitViewModel.lParentCounterpartyLimitId = oParentDataSource[0].lCounterpartyLimitId;
        }
        else {
          oCounterpartyLimitViewModel.lParentCounterpartyLimitId = -1;
          //DO NOTHING
        }
      } else {
        oCounterpartyLimitViewModel.lParentCounterpartyLimitId = -1;
        oCounterpartyLimitViewModel.IsBuy = false;
      }


      let i: number = 0;
      let dDates: Dates = new Dates();
      //Start CRD-420-Pawan Prajapati
      for (i = 0; i < this.__oSystemSettings[0].CounterpartyLimitMaxTenure; i++) {
        let oDataValue: any = {};
        oDataValue.lDataValueId = i;
        oDataValue.lTradingLimitId = 0;
        oDataValue.EntityState = 1;
        oDataValue.ColumnName = this.__oMonthNames[dDates.dateAdd(new Date(this.__oSystemSettings[0].ValuationDate), i, "months").getMonth()] + "-" + dDates.dateAdd(new Date(this.__oSystemSettings[0].ValuationDate), i, "months").getFullYear();

        oDataValue.IsVisible = true;
        oDataValue.IsDisabled = false;
        oDataValue.IsOverAllocation = 0;
        oDataValue.IsEditorVisible = false;
        oDataValue.OverAllLimitBreachAmount = 0;
        oDataValue.EntityState = 1;
        oDataValue.LimitValue = bIsSystemTriggeredEvent ? 0 : null;
        oCounterpartyLimitViewModel.DataValues.push(oDataValue);
      }
      //End CRD-420-Pawan Prajapati


      oCounterpartyLimitViewModel.lParentCounterpartyLimitId !== -1 ? this.__oDatasource.push(oCounterpartyLimitViewModel) : this.__oDatasource.unshift(oCounterpartyLimitViewModel);
      this.__iKeys = this.__oDatasource.map(x => x.lCounterpartyLimitId);

      if (this.__oNewLimit.LimitTypeName === 'Volume') {
        oCounterpartyLimitViewModel.lParentCounterpartyLimitId = -1;
        const oCounterpartyLimitSellModel = JSON.parse(JSON.stringify(oCounterpartyLimitViewModel));
        oCounterpartyLimitSellModel.IsBuy = true;
        oCounterpartyLimitViewModel.lCounterpartyLimitId = this.__oUtilityService.generateUniqueKey();
        oCounterpartyLimitSellModel.lParentCounterpartyLimitId = oCounterpartyLimitViewModel.lCounterpartyLimitId;
        this.__oDatasource.push(oCounterpartyLimitSellModel);
      }

      if (this.__oSystemSettings[0].IsCounterPartyLimitValidated === 1 && this.__oSystemSettings[0].IsEntityLimitValidated === 2) {
        let oCounterpartyLimitsCommonManager: CounterpartyLimitsCommonManager = new CounterpartyLimitsCommonManager(this.__oDatasource, this.__otrCounterpartyLimits, this.Logger);
        this.__oDatasource = oCounterpartyLimitsCommonManager.buildtree(this.__oDatasource, this.__oTradingEntityLegalHierarchyOwnerships, this.__oTradingCounterpartyLegalHierarchyOwnerships)
      }

      this.EntityLimitsOnTopOrder(this.__oDatasource);
      //PD-116 Setting overall limit value when the flag IsOverallLimitEditable set to 0 and IsOverAllLimitValidated=1 Start
      if (this.__oSystemSettings[0].IsOverallLimitEditable === 0) {
        var _olistOfSubLimit = this.__oDatasource.filter(x => x.lTradingCounterpartyId == oCounterpartyLimitViewModel.lTradingCounterpartyId && x.lOurEntityId == oCounterpartyLimitViewModel.lOurEntityId && x.lLimitTypeId == oCounterpartyLimitViewModel.lLimitTypeId && x.TradingCategoryName != 'Overall')
        if (_olistOfSubLimit.length > 0) {
          _olistOfSubLimit.forEach(subLimititem => {
            for (let i = 0; i < this.__oSystemSettings[0].CounterpartyLimitMaxTenure; i++) {
              var evntData: any = {};
              evntData.data = subLimititem;
              evntData.columnIndex = i;
              this.checkForAnyLimitBreachByRow(evntData, false);
            }
          });
        }
        let oOveralllimit = this.__oDatasource.find(x => x.lTradingCounterpartyId == oCounterpartyLimitViewModel.lTradingCounterpartyId && x.lOurEntityId == oCounterpartyLimitViewModel.lOurEntityId && x.lLimitTypeId == oCounterpartyLimitViewModel.lLimitTypeId && x.TradingCategoryName == 'Overall');
        if (oOveralllimit != null && oOveralllimit != undefined)
          this.setFromToDateMonths(oOveralllimit);
      }
      //PD-116 Setting overall limit value when the flag IsOverallLimitEditable set to 0 and IsOverAllLimitValidated=1 END
      this.__otrCounterpartyLimits.instance.refresh();
      this.__bAddNewVisible = false;
      this.__bDisableSave = true;
      if (this.__oReviewDateComponent) {//FB44257-Pawan Prajapati
        this.__oReviewDateComponent.formTradingCounterpartyLimit();
      }
      this.refreshGridStyle();
    }
    catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while adding new entry into datagrid.');
    }
  }
  private CreateAutoMaticOverall(oCounterpartyLimitViewModel: any, oParentDataSource: any[], bIsSystemTriggeredEvent: boolean) {
    try {
      var oLimitOverall = this.__oDatasource.filter(x => x.TradingCounterpartyName == this.__oNewLimit.TradingCounterpartyName && x.TradingEntityName == this.__oNewLimit.TradingEntityName && x.LimitTypeName == this.__oNewLimit.LimitTypeName && x.TradingCategoryName == "Overall");
      //if ((!oLimitOverall || oLimitOverall.length === 0) && this.__oNewLimit.TradingCategoryName !== "Overall") {
      //    confirm("There is no overall limit available for this combination,do you want system to generate one?", "Confirmation").then((result) => {
      //        if (result) {
      //            oCounterpartyLimitViewModel.lParentCounterpartyLimitId !== -1 ? this.__oDatasource.push(oCounterpartyLimitViewModel) : this.__oDatasource.unshift(oCounterpartyLimitViewModel);
      //            this.__otrCounterpartyLimits.instance.refresh();
      //            this.__iKeys = this.__oDatasource.map(x => x.lCounterpartyLimitId);
      //            this.__otrCounterpartyLimits.instance.option('autoExpandAll', true);
      //            this.__bAddNewVisible = false;
      //            this.__otrCounterpartyLimits.instance.option('autoExpandAll', true);
      //        }
      //    });
      //}
      if ((!oLimitOverall || oLimitOverall.length === 0) && this.__oNewLimit.TradingCategoryName !== "Overall" && !bIsSystemTriggeredEvent) {
        let oCounterpartyLimitOverallViewModel: any = {};
        oCounterpartyLimitOverallViewModel = JSON.parse(JSON.stringify(oCounterpartyLimitViewModel)); //JSON.parse(JSON.stringify(this.__oCIPolicy))
        oCounterpartyLimitOverallViewModel.lCounterpartyLimitId = this.__oUtilityService.generateUniqueKey();
        oCounterpartyLimitOverallViewModel.TradingCategoryName = "Overall";
        oCounterpartyLimitOverallViewModel.lTradingCategoryId = this.__oTradingCategories.find(x => x.TradingCategoryName == "Overall").lTradingCategoryId;
        if (oParentDataSource.length > 0) {
          oCounterpartyLimitOverallViewModel.lParentCounterpartyLimitId = oParentDataSource[0].lCounterpartyLimitId;
        } else {
          oCounterpartyLimitOverallViewModel.lParentCounterpartyLimitId = -1;
        }
        oCounterpartyLimitOverallViewModel.lParentCounterpartyLimitId !== -1 ? this.__oDatasource.push(oCounterpartyLimitOverallViewModel) : this.__oDatasource.unshift(oCounterpartyLimitOverallViewModel);
        oCounterpartyLimitViewModel.lParentCounterpartyLimitId = oCounterpartyLimitOverallViewModel.lCounterpartyLimitId;
      } else {
        this.__oDatasource.filter(z => z.TradingCategoryName !== "Overall").forEach(x => {
          let oLimit: any = this.__oDatasource.find(z => z.TradingCounterpartyName == x.TradingCounterpartyName && z.TradingEntityName == x.TradingEntityName && z.LimitTypeName == x.LimitTypeName && z.TradingCategoryName === "Overall" && z.TenorTypeName == x.TenorTypeName);
          if (!oLimit) {
            this.__oNewLimit = {};
            this.__ilParentCounterpartyLimitId;
            this.__oNewLimit.TradingCounterpartyName = x.TradingCounterpartyName;
            this.__oNewLimit.TradingEntityName = x.TradingEntityName;
            this.__oNewLimit.LimitTypeName = x.LimitTypeName;
            this.__oNewLimit.TradingCategoryName = "Overall";
            this.btnContinue_Click(true);
            x.lParentCounterpartyLimitId = this.__ilParentCounterpartyLimitId;
          }
          this.__oNewLimit = {};
        });
      }
    } catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while creating automatic overall.');
    }
  }
  refresh(oCounterparty: any) {
    try {
      this.__oTradingcounterpartySearchView = oCounterparty;

      //this.__oDataService.__oCounterpartLimitCurrentDataStore.subscribe(x => {
      //    if (x == null || x == undefined || (Array.isArray(x) && x.length == 0)) {
      //        x = JSON.parse(localStorage.getItem('SystemSettingData'));
      //    }
      //    let otrCounterpartyLimits: any = x;
      //    this.__otrCounterpartyLimits = otrCounterpartyLimits;
      //});

      this.getStaticDataFromAPI();
    } catch (oError) {
      this.Logger.Write(oError, 'Error', 'Error occurred while executing refresh function.');
    }
  }

  onTreeIntialized(event: any) {
    //this.__oDataService.setCounterpartLimitDataGrid(event.component.instance());
  }
  //fires  on to get counterparty limits
  btnEdit_Clicked() {
    try {

      if (!this.__oTradingcounterpartySearchView || !this.__oTradingcounterpartySearchView.lTradingCounterpartyId) {
        return;
      }
      this.__bIsLimitLoadingVisible = true; this.__sTabContent = 'General'; this.__iTabIndex = 0;
      this.__oDatasourceDeleted = [];
      this.onLoad_GetDataFromService();
      this.__oService.getDataByObservable(this.__sGetApiUrl + "api/CounterpartyLimit/" + this.__oTradingcounterpartySearchView.lTradingCounterpartyId).subscribe((Data) => {
        if (Data != null) {
          this.__oApiDataSource = CommonHelper.clone(Data);//FB46162-Pawan Prajapati
          this.__oDatasource = Data;
          this.__oDatasource.forEach(oItem => this.getLinkedLCPCGMessage(oItem));//FB44260-Pawan Prajapati
          if (this.__oSystemSettings[0].IsCounterPartyLimitValidated === 1 && this.__oSystemSettings[0].IsEntityLimitValidated === 2) {
            let oCounterpartyLimitsCommonManager: CounterpartyLimitsCommonManager = new CounterpartyLimitsCommonManager(this.__oDatasource, this.__otrCounterpartyLimits, this.Logger);
            this.__oDatasource = oCounterpartyLimitsCommonManager.buildtree(JSON.parse(JSON.stringify(this.__oDatasource)), this.__oTradingEntityLegalHierarchyOwnerships, this.__oTradingCounterpartyLegalHierarchyOwnerships)
          }

          this.EntityLimitsOnTopOrder(this.__oDatasource);
          this.updateWarnings();
          let iCounterpartyLimitId = this.__oDatasource && this.__oDatasource.length > 0 && this.__oDatasource[0] ? this.__oDatasource[0].lCounterpartyLimitId : 0;
          if (!this.__oFourEyeManager.__bIsFourEyeEnabled && !this.__oSystemSettings[0].IsCompleteHeirarchyLoadedByDefault && this.__otrCounterpartyLimits && this.__otrCounterpartyLimits.instance) {//FB44205-Pawan Prajapati
            this.__otrCounterpartyLimits.instance.columnOption("TradingCounterpartyName", "filterValue", this.__oTradingcounterpartySearchView.TradingCounterparty);
          }
          this.__oReviewDateComponent ? (this.__oReviewDateComponent.__oCounterpartyLimits = this.__oDatasource, this.__oReviewDateComponent.formTradingCounterpartyLimit()) : "";
          this.IsAuthorized(iCounterpartyLimitId);

        }
      });

      this.__otrCounterpartyLimits.instance.option('autoExpandAll', true);
      this.__otrCounterpartyLimits.instance.refresh();
    }
    catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while getting counterparty limits.');
    }
  }

  ///Place ultimate entity limits on top order
  EntityLimitsOnTopOrder(Data: CounterpartyLimitViewModel[]) {
    try {
      let oCounterpartyLimitsCommonManager: CounterpartyLimitsCommonManager = new CounterpartyLimitsCommonManager(this.__oDatasource, this.__otrCounterpartyLimits, this.Logger);
      this.CreateTreeViewByDataSource();
      if (this.__oSystemSettings[0].IsEntityLimitValidated) {
        this.__oDatasource = Data.filter(x => x.lOurEntityId != this.__oTradingEntityLegalHierarchyOwnerships[0].lChildTradingEntityId && x.lTradingCounterpartyId != this.__oTradingCounterpartyLegalHierarchyOwnerships[0].lChildTradingCounterpartyId && x.LimitTypeName !== 'Volume');
        Data.filter(x => x.lOurEntityId != this.__oTradingEntityLegalHierarchyOwnerships[0].lChildTradingEntityId && x.lTradingCounterpartyId === this.__oTradingCounterpartyLegalHierarchyOwnerships[0].lChildTradingCounterpartyId && x.LimitTypeName !== 'Volume').forEach(x => this.__oDatasource.unshift(x));
        Data.filter(x => x.lOurEntityId === this.__oTradingEntityLegalHierarchyOwnerships[0].lChildTradingEntityId && x.lTradingCounterpartyId != this.__oTradingCounterpartyLegalHierarchyOwnerships[0].lChildTradingCounterpartyId && x.LimitTypeName !== 'Volume').forEach(x => this.__oDatasource.unshift(x));
        Data.filter(x => x.lOurEntityId === this.__oTradingEntityLegalHierarchyOwnerships[0].lChildTradingEntityId && x.lTradingCounterpartyId === this.__oTradingCounterpartyLegalHierarchyOwnerships[0].lChildTradingCounterpartyId && x.LimitTypeName !== 'Volume').forEach(x => this.__oDatasource.unshift(x));
        Data.filter(x => x.LimitTypeName === 'Volume').forEach(x => this.__oDatasource.push(x));
      }

      let oDatasource = oCounterpartyLimitsCommonManager.buildHeadroomOrder(JSON.parse(JSON.stringify(this.__oDatasource)), this.__oDatasource);
      this.__oDatasource = oDatasource;
    }
    catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while getting counterparty limits.');
    }
  }

  private IsAuthorized(iCounterpartyLimitId: any) {
    try {
      if (iCounterpartyLimitId) {
        this.__oService.getDataByObservable(this.__sGetApiUrl + "api/CounterpartyLimit/463/" + iCounterpartyLimitId + "/false/Authorize").subscribe((Data) => {
          if (Data != null) {
            this.__bDisableSave = (Data[0] == "1") ? true : false;
            this.__oDatasource.forEach(x => {
              x.IsEditorEnabled = !this.__bDisableSave;
            });
            this.__bIsLimitLoadingVisible = false;
          }
        });
      }
      else {
        this.__bIsLimitLoadingVisible = false;
      }

    } catch (oError) {
      this.Logger.Write(oError, 'Error', 'Error occurred while executing IsAuthorized function.');
    }
  }

  //aligns datasource to create tree view
  private CreateTreeViewByDataSource() {
    try {
      let oCounterpartyLimitsCommonManager: CounterpartyLimitsCommonManager = new CounterpartyLimitsCommonManager(this.__oDatasource, this.__otrCounterpartyLimits, this.Logger);
      this.__oDatasource.forEach(x => x.MaxToDate = x.From);//FB37914-Pawan Prajapati
      let oDatasource = this.__oDatasource;
      this.__oDatasource = []; this.__iCptysUnderHierarchy = [];

      oDatasource.filter(x => x.lParentCounterpartyLimitId === -1).forEach(z => {
        this.__iCptysUnderHierarchy.push(z.lCounterpartyLimitId)
        this.__iCptysUnderHierarchy = oCounterpartyLimitsCommonManager.ExtractCptys(z, oDatasource, oDatasource, this.__iCptysUnderHierarchy);//CRD-592-Pawan Prajapati
      });

      this.__iCptysUnderHierarchy.forEach(x => {
        oDatasource.find(z => z.lCounterpartyLimitId === x && z.LimitTypeName !== 'Volume') ? this.__oDatasource.push(oDatasource.find(z => z.lCounterpartyLimitId === x && z.LimitTypeName !== 'Volume')) : "";
      });
      oDatasource.filter(x => x.TradingCategoryName !== "Overall" && x.LimitTypeName !== 'Volume').forEach(z => {
        if (!this.__oDatasource.find(x => x.lCounterpartyLimitId === z.lCounterpartyLimitId)) {
          this.__oDatasource.unshift(z);
        }
      });

      oDatasource.filter(x => x.LimitTypeName === 'Volume').forEach(z => {
        //if (!this.__oDatasource.find(x => x.lCounterpartyLimitId === z.lCounterpartyLimitId)) {
        this.__oDatasource.push(z);
        //}
      });

      this.__iKeys = this.__oDatasource.map(x => x.lCounterpartyLimitId);
    } catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred creating tree view data source.');
    }
  }

  //currency conversion to be done wrt overall limit currency
  currencyConversion(limitValue: any, fromCurrency: number, toCurrency: number): number {
    let nReturn = limitValue;
    try {
      let nExchangeRate = 1;
      if (this.__oExchangeRateEFs && this.__oExchangeRateEFs.length > 0 && this.__oExchangeRateEFs.find(x => x.lFromCurrencyId == fromCurrency && x.lToCurrencyId == toCurrency)) {
        nExchangeRate = this.__oExchangeRateEFs.find(x => x.lFromCurrencyId == fromCurrency && x.lToCurrencyId == toCurrency).ConversionRate;
      }
      nReturn = Math.floor(limitValue * nExchangeRate);
    }
    catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while updating warnings.');
    }
    return nReturn;
  }

  //updates warnings
  private updateWarnings() {
    try {
      this.__oDatasource.filter(z => z.TradingCategoryName === "Overall" || z.IsOverall === 1).forEach(data => {
        data.Warnings = [];

        let oHeadroomLimit = this.__oDatasource.filter(x => x.lTradingCounterpartyId == data.lTradingCounterpartyId && x.lOurEntityId == data.lOurEntityId
          && x.lLimitTypeId == data.lLimitTypeId && x.TradingCategoryName === 'Headroom');//FB43985-Pawan Prajapati
        if (data.TradingCategoryName === "Overall") { //FB39524-Pawan Prajapati
          oHeadroomLimit && oHeadroomLimit.length > 0 ? oHeadroomLimit[0].Warnings = [] : "";
        }

        let iParentLimit = data.lTradingCategoryId;
        var oDataSource = [];
        if (iParentLimit != -1 && iParentLimit === 1) {
          oDataSource = this.__oDatasource.filter(x => (x.TradingCategoryName !== "Overall" && (x.lParentTradingCategoryId === 1 || !x.lParentTradingCategoryId)) && x.lTradingCounterpartyId == data.lTradingCounterpartyId && x.lOurEntityId == data.lOurEntityId
            && x.lLimitTypeId == data.lLimitTypeId && x.lSubLimitTypeId == data.lSubLimitTypeId && x.TradingCategoryName !== 'Headroom');//FB43985-Pawan Prajapati
        }
        else {
          oDataSource = this.__oDatasource.filter(x => x.lParentTradingCategoryId === iParentLimit && x.lTradingCounterpartyId == data.lTradingCounterpartyId && x.lOurEntityId == data.lOurEntityId
            && x.lLimitTypeId == data.lLimitTypeId && x.lSubLimitTypeId == data.lSubLimitTypeId && x.TradingCategoryName !== 'Headroom');//FB43985-Pawan Prajapati
        }

        for (let i = (this.__oSystemSettings[0].CounterpartyLimitMaxTenure - 1); i >= 0; i--) {//CRD-420-Pawan Prajapati
          let iSum = 0;
          oDataSource.forEach(x => {
            if (x.DataValues[i].LimitValue) {
              iSum = (data ? (iSum + (this.currencyConversion(x.DataValues[i].LimitValue, x.lLimitValueCurrencyId, data.lLimitValueCurrencyId))) : (iSum + x.DataValues[i].LimitValue));//iSum + x.DataValues[i].LimitValue;
            }
          });

          if (data && data.DataValues[i] && data.DataValues[i].LimitValue < iSum) {
            data.DataValues[i].IsOverAllocation = 1;

            let oWarning: any = {};
            oWarning.ColumnName = data.DataValues[i].ColumnName;
            oWarning.RowIndex = this.__otrCounterpartyLimits.instance.getRowIndexByKey(data.lCounterpartyLimitId);
            oWarning.ColumnIndex = i;

            data.Warnings.push(oWarning);
            if (this.__bSidebarApply) {
              oDataSource.filter(k => k.IsOverall == 0).forEach(x => {//FB43985-Pawan Prajapati
                if (x.DataValues[i]) {
                  x.DataValues[i].IsOverAllocation = 1;
                }
              });
            }
          }
          else {
            data.DataValues[i].IsOverAllocation = 0;
            if (this.__bSidebarApply) {
              oDataSource.forEach(x => {
                if (x.DataValues[i]) {
                  x.DataValues[i].IsOverAllocation = 0;
                }
              });
            }
          }
          if (data.TradingCategoryName === "Overall") { //FB39524-Pawan Prajapati
            this.updateWarningsForHeadroom(oHeadroomLimit, data, i);
          }
        }
      });

      this.__oDatasource.forEach(data => {
        var sDistinctValues: any[] = [];
        this.checkLimitVaryingOverTime(data, sDistinctValues);
      });
    }
    catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while updating warnings.');
    }
  }
  ///updates warnings for headroom
  private updateWarningsForHeadroom(oHeadroomLimit: CounterpartyLimitViewModel[], data: CounterpartyLimitViewModel, i: number) {
    try {
      if (oHeadroomLimit && oHeadroomLimit.length > 0 && data && data.DataValues[i] && data.DataValues[i].LimitValue != oHeadroomLimit[0].DataValues[i].LimitValue && data.DataValues[i].LimitValue > oHeadroomLimit[0].DataValues[i].LimitValue) {
        oHeadroomLimit[0].DataValues[i].IsOverAllocation = 1;

        let oWarning: any = {};
        oWarning.ColumnName = data.DataValues[i].ColumnName;
        oWarning.RowIndex = this.__otrCounterpartyLimits.instance.getRowIndexByKey(oHeadroomLimit[0].lCounterpartyLimitId);
        oWarning.ColumnIndex = i;

        oHeadroomLimit[0].Warnings.push(oWarning);
      }
      else if (oHeadroomLimit && oHeadroomLimit.length > 0 && data && data.DataValues[i] && (data.DataValues[i].LimitValue == oHeadroomLimit[0].DataValues[i].LimitValue || data.DataValues[i].LimitValue < oHeadroomLimit[0].DataValues[i].LimitValue)) {
        oHeadroomLimit[0].DataValues[i].IsOverAllocation = 0;
      }
    }
    catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while updating warnings.');
    }
  }

  //set flag if limitvalue changes by row
  private checkLimitVaryingOverTime(x: CounterpartyLimitViewModel, sDistinctValues: any[]) {
    try {
      if (x) {
        let sDistinctTempValues: any[] = [];
        for (let iCount = 0; iCount < x.DataValues.length; iCount++) {//CRD-420-Pawan Prajapati
          if (x.DataValues[iCount].LimitValue != undefined && x.DataValues[iCount].LimitValue != null) {
            sDistinctValues.push(x.DataValues[iCount].LimitValue);
          }

          if (x.TempDataValues && x.TempDataValues[iCount] && x.TempDataValues[iCount].LimitValue !== undefined && x.TempDataValues[iCount].LimitValue !== null && x.TempDataValues[iCount].LimitValue !== "") {
            sDistinctTempValues.push(x.TempDataValues[iCount].LimitValue);
          }
        }
        var aDuplicates = Array.from(new Set(sDistinctValues));
        x.IsLimitValueVaryingOverTime = (sDistinctValues.length != 0 && aDuplicates.length != 1) ? true : false;

        var aTempDuplicates = Array.from(new Set(sDistinctTempValues));
        x.IsTempLimitValueVaryingOverTime = (sDistinctTempValues.length != 0 && aTempDuplicates.length != 1) ? true : false;
      }
    } catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while checking limit variation by row.');
    }
  }

  //fires  on while row is prepared
  onRow_Prepared(evnt: any) {
    try {
      if (evnt.rowType === 'data') { //FB39524-Pawan Prajapati
        if (evnt.data.EntityState == 3) {
          evnt.rowElement.hidden = true;
        }
      }
      if (evnt.key && evnt.key > 5000000 && evnt.rowType === "data") {
        evnt.rowElement.style.backgroundColor = 'darkgray';
      }
      if (evnt.rowType === 'data') {
        this.__oFourEyeManager.setStyle(evnt);//FB46162-Pawan Prajapati
        if (evnt.data.IsEntityRestricted) {//FB47392-Pawan Prajapati
          evnt.rowElement.style.pointerEvents = 'none';
          evnt.rowElement.hidden = true;
        }
        if (evnt.data.IsReadonlyAccess || !evnt.data.IsTradingCounterpartyInstanceSaveAccess) {//FB47392-Pawan Prajapati
          evnt.rowElement.style.pointerEvents = 'none';
        }
      }
    } catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while preparing row.');
    }
  }
  //fires  on cell prepared
  onCell_Prepared(e: any) {
    var self = this;
    if (e.rowType === "data" && e.columnIndex == 0 && this.__oFourEyeManager.isFourEyeRow(e.data))//FB46162-Pawan Prajapati
      this.__oFourEyeManager.updateRowsStyle(e.rowIndex, e.columnIndex);
    try {
      if (e.rowType === "data" && e.data && (e.data.lTradingCategoryId === 1 || e.data.IsOverall)) {
        e.cellElement.style.fontWeight = "bold";
      }
      if (e.rowType === "data" && e.data && (e.data.IsOverall && this.__oTradingCounterpartyLegalHierarchyOwnerships.length > 0 && e.data.lTradingCounterpartyId === this.__oTradingCounterpartyLegalHierarchyOwnerships[0].lChildTradingCounterpartyId && this.__oTradingEntityLegalHierarchyOwnerships.length > 0 && e.data.lOurEntityId === this.__oTradingEntityLegalHierarchyOwnerships[0].lChildTradingEntityId)) {
        e.cellElement.style.fontWeight = "bold"; e.cellElement.style.fontStyle = "italic"; e.cellElement.style.color = '#3CACB6';
      }
      if (e.rowType === "data" && e.data.lTradingCategoryId === 1 &&
        (this.__oSystemSettings[0].IsOverallLimitEditable === 2 || this.__oSystemSettings[0].IsOverallLimitEditable === 0) && e.columnIndex == this.__oGridcolumns.length && e.cellElement && e.cellElement.getElementsByClassName("dx-link-delete")) {
        e.cellElement.getElementsByClassName("dx-link-delete")[0].style.display = "none";
      }
    } catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while executing cell prepared event.');
    }

  }
  ///fires while editor is preparing
  onEditorPreparing(event: any) {
    try {
      if (event.row && event.row.data && event.row.data.IsEditButtonClicked) {
        event.editorOptions.disabled = true;
      }
    } catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while preparing editor.');
    }

  }
  //fires on row removed
  onRow_Removed(event: any) {
    try {
      this.__oDatasource.forEach(x => {
        if (x.lParentCounterpartyLimitId == event.data.lCounterpartyLimitId) {
          x.lParentCounterpartyLimitId = -1;
        }
      });
    }
    catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while executing row removed event.');
    }
  }
  //fires when a row is removing
  onRow_Removing(event: any, name: any) {
    try {
      let sTempMessage = "";
      var oCounterpartyVolumeLimit = null;
      //volume limits
      event.data.LimitTypeName === 'Volume' ? oCounterpartyVolumeLimit = this.__oDatasource.filter(x => x.lLimitTypeId == 2 && x.lTradingCounterpartyId == event.data.lTradingCounterpartyId && x.lOurEntityId == event.data.lOurEntityId && x.lLimitTypeId == event.data.lLimitTypeId && x.lSubLimitTypeId == event.data.lSubLimitTypeId && x.lTradingProductId == event.data.lTradingProductId && x.lUnitId == event.data.lUnitId
        && x.lPeriodTypeId == event.data.lPeriodTypeId && x.IsBuy !== event.data.IsBuy)[0] : "";//FB43985-Pawan Prajapati
      //volume limits
      let sLimitType = Constants.PERMANENT_LIMIT;
      if (name === Constants.PERMANENTLIMIT && event.data.LimitTypeName === Constants.VOLUME) {
        sLimitType = Constants.VOLUME_LIMIT;
      } else if (name === Constants.PERMANENTLIMIT && event.data.TradingCategoryName === Constants.HEADROOM) {
        sLimitType = Constants.HEADROOM_LIMIT;
      }
      event.data.TempDataValues && event.data.TempDataValues.length > 0 && event.data.IsTempLimitAllocated ? sTempMessage = "and Temporary limit " : sTempMessage = "";
      let sMessage = name === "permnentLimit" ? sLimitType + sTempMessage + "will be deleted. Are you sure you want to delete this record?" : "Temporary limit will be deleted. Are you sure you want to delete this record?";
      this.__oConfirmationComponent.show(ConfirmationType.Information, sMessage, "Confirmation", "Yes", "No").then((result) => {
        if (result) {
          let i: number = 0; (event.data.DataValues && event.data.DataValues.length > 0 && event.data.DataValues.filter(x => x.lTradingLimitId > 0).length > 0) ? event.data.EntityState = 2 : event.data.EntityState = 1;//CRD-420-Pawan Prajapati
          (event.data.DataValues && event.data.DataValues.length > 0 && event.data.DataValues.filter(x => x.lTradingLimitId > 0).length > 0) ? event.data.EntityState = 2 : event.data.EntityState = 1;
          if (event.data.EntityState != 1 && name === "permnentLimit") {
            for (i; i < this.__oSystemSettings[0].CounterpartyLimitMaxTenure; i++) {//CRD-420-Pawan Prajapati
              if (event.data.DataValues[i].lTradingLimitId > 0) {
                event.data.EntityState = 3;
                event.data.DataValues[i].EntityState = 3;
                //volume limits
                oCounterpartyVolumeLimit ? (oCounterpartyVolumeLimit.DataValues[i].EntityState = 3, oCounterpartyVolumeLimit.EntityState = 3) : "";
                //volume limits
              } else {
                event.data.DataValues[i].EntityState = 0;
                //volume limits
                oCounterpartyVolumeLimit ? oCounterpartyVolumeLimit.DataValues[i].EntityState = 0 : "";
                //volume limits
              }

              if (event.data.TempDataValues && event.data.TempDataValues[i] && event.data.TempDataValues[i].lTradingLimitId > 0) {
                event.data.TempDataValues[i].EntityState = 3;
              }
              else if (event.data.TempDataValues && event.data.TempDataValues[i] && event.data.TempDataValues[i].lTradingLimitId === 0) {
                event.data.TempDataValues[i].EntityState = 0;
              }

              //event.data.EntityState = 3;)
            }
            this.__oDatasourceDeleted.push(event.data);
            //volume limits
            oCounterpartyVolumeLimit ? (this.__oDatasourceDeleted.push(oCounterpartyVolumeLimit), this.__oDatasource.splice(this.__oDatasource.indexOf(oCounterpartyVolumeLimit), 1)) : "";
            //volume limits
            this.__oDatasource.forEach(x => {
              if (x.lParentCounterpartyLimitId == event.data.lCounterpartyLimitId) {
                x.lParentCounterpartyLimitId = -1;
              }
            });
            this.__oDatasource.splice(this.__oDatasource.indexOf(event.data), 1);
          }
          else if (event.data.EntityState === 1 && event.data.DataValues && event.data.DataValues.filter(x => x.lTradingLimitId).length === 0 && name === "permnentLimit") {
            this.__oDatasource.splice(this.__oDatasource.indexOf(event.data), 1);
            //volume limits
            oCounterpartyVolumeLimit ? (this.__oDatasourceDeleted.push(oCounterpartyVolumeLimit), this.__oDatasource.splice(this.__oDatasource.indexOf(oCounterpartyVolumeLimit), 1)) : "";
            //volume limits
          }
          else {
            for (i; i < this.__oSystemSettings[0].CounterpartyLimitMaxTenure; i++) {//CRD-420-Pawan Prajapati
              if (event.data.TempDataValues && event.data.TempDataValues[i] && event.data.TempDataValues[i].lTradingLimitId > 0 && event.data.EntityState != 1) {
                event.data.TempDataValues[i].EntityState = 3;
                //event.data.EntityState = 4;
                event.data.IsTempLimitAllocated = false;
              } else if (event.data.TempDataValues && event.data.TempDataValues[i] && event.data.TempDataValues[i].lTradingLimitId === 0) {
                event.data.TempDataValues[i].EntityState = 0;
                event.data.IsTempLimitAllocated = false;
              }
            }
            this.checkFourEyeWarningMessage(event.data);//FB46162-Pawan Prajapati
          }
          this.onRow_Removed(event);
          this.refreshBindingData();//FB46162-Pawan Prajapati
          this.refreshGridStyle();
        } else {

        }
      });

    } catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while executing row removed event.');
    }
  }

  //fires when a row gets updated
  onRow_Updating(event: any) {

  }
  //fires  on row updation
  onRow_Updated(event: any) {

  }
  //fires  on cell click
  onCell_Click(evnt: any) {
    evnt.columnIndex = evnt.columnIndex - this.__iColumnCountBeforeLimitValue;
    try {
      var sDistinctValues: any[] = [];
      let iLastValueIndex = 0;
      let dDates: Dates = new Dates();
      if (evnt && evnt.columnIndex > -1 && evnt.columnIndex !== this.__oColuDetails.length && evnt.data.LimitTypeName !== 'Volume') {
        evnt.data.DataValues[evnt.columnIndex].IsEditorVisible = true;
        if (!this.__bTimelineViewVisible) {
          evnt.data.DataValues[evnt.columnIndex].IsDisabled = false;
          for (let iCount = 0; iCount < evnt.data.DataValues.length; iCount++) {//CRD-420-Pawan Prajapati
            if (evnt.data.DataValues[iCount].LimitValue != undefined && evnt.data.DataValues[iCount].LimitValue != null) {
              sDistinctValues.push(evnt.data.DataValues[iCount].LimitValue);
            }
          }
          var aDuplicates = Array.from(new Set(sDistinctValues));//[...new Set(sDistinctValues)];
          evnt.data.DataValues[evnt.columnIndex].IsDisabled = (sDistinctValues.length != 0 && aDuplicates.length != 1) ? true : false;
        }
        else if (this.__bTimelineViewVisible) {
          evnt.data.DataValues[evnt.columnIndex].IsDisabled = false;
        }

        if (this.__oSystemSettings[0].IsOverAllLimitValidated && evnt.data.TradingCategoryName !== 'Overall' && evnt.data.TradingCategoryName !== 'Headroom' && this.__oDatasource.find(x => x.lCounterpartyLimitId === evnt.data.lParentCounterpartyLimitId)) {

          let oOverall = this.__oDatasource.find(x => x.lCounterpartyLimitId === evnt.data.lParentCounterpartyLimitId)

          for (let i = oOverall.DataValues.length - 1; i >= 0; i--) {//CRD-420-Pawan Prajapati
            if (oOverall.DataValues[i].LimitValue) {
              //iLastValue = event.DataValues[i].LimitValue;
              iLastValueIndex = i + 1;
              break;
            }
            else {
              var oNotNullCells = evnt.data.DataValues.filter(x => x.LimitValue != null);
              var oGroupItem = oNotNullCells.reduce( //FB39524-Pawan Prajapati
                (result, item) => ({
                  ...result,
                  [item.LimitValue]: [
                    ...(result[item.LimitValue] || []),
                    item,
                  ],
                }),
                {})
              evnt.data.DataValues[i].IsDisabled = oNotNullCells.length == 0 ? false : Object.keys(oGroupItem).length != 1; //FB39524-Pawan Prajapati
            }
          }
          let dDates: Dates = new Dates();
          this.__dtMaxDate = dDates.dateAdd(new Date(new Date(this.__oSystemSettings[0].ValuationDate).getFullYear(), new Date(this.__oSystemSettings[0].ValuationDate).getMonth(), new Date(this.__oSystemSettings[0].ValuationDate).getDate() == 29 ? 1 : new Date(this.__oSystemSettings[0].ValuationDate).getDate()), iLastValueIndex, "months");//CRD-420-Pawan Prajapati
        }

        evnt.data.TempDataValues && evnt.data.TempDataValues.length > 0 ? this.onTempLimitCell_Click(evnt) : null;
        if (evnt.data.TradingCategoryName !== 'Overall' && evnt.data.TradingCategoryName !== 'Headroom') {
          this.getMaxOrOverAllocation(evnt, true);
        }
        else if ((!this.__oSystemSettings[0].IsOverallLimitEditable || this.__oSystemSettings[0].IsOverallLimitEditable === 2) && evnt.data.TradingCategoryName !== 'Headroom') {
          evnt.data.DataValues[evnt.columnIndex].IsDisabled = true;
          evnt.data.TempDataValues && evnt.data.TempDataValues.length > 0 ? evnt.data.TempDataValues[evnt.columnIndex].IsDisabled = true : null;
        }

        else if (this.__oSystemSettings[0].IsOverallLimitEditable === 1 && evnt.data.TradingCategoryName === 'Overall' && evnt.data.TradingCounterpartyLimit && evnt.data.TradingCounterpartyLimit.lOverallLimitSettingId) {
          evnt.data.DataValues[evnt.columnIndex].IsDisabled = !this.__bTimelineViewVisible || evnt.data.DataValues[evnt.columnIndex].lOverallLimitSettingId ? true : false;//FB44260-Pawan Prajapati
        }
      }
      for (let i = evnt.data.DataValues.length - 1; i >= 0; i--) {//CRD-420-Pawan Prajapati
        if (evnt.data.DataValues[i].LimitValue) {
          evnt.data.RollingToMonthMax = i;//CRD-420-Pawan Prajapati
          let tempLimitMaxDate = dDates.dateAdd(new Date(this.__oSystemSettings[0].ValuationDate), i, "months");//CRD-420-Pawan Prajapati
          evnt.data.TemporaryLimitToDateMax = new Date(tempLimitMaxDate.getFullYear(), tempLimitMaxDate.getMonth() + 1, 0);
          this.__dtMaxTempDate = evnt.data.TemporaryLimitToDateMax;
          break;
        }
      }
      if (evnt && evnt.column.caption == "From" || evnt && evnt.column.caption == "To" && evnt.data.TenorTypeName == 'Rolling') {
        if (!evnt.data.RollingFromMonth)
          evnt.data.RollingFromPeriod = this.calculatePeriodFromDate(evnt.data.From);
        evnt.data.MinRollingFromPeriod = 0;
        if (this.monthDiff(new Date(this.__oSystemSettings[0].ValuationDate), new Date(evnt.data.To)) == 0)
          evnt.data.MaxRollingFromPeriod = this.__oSystemSettings[0].CounterpartyLimitMaxTenure;
        else
          evnt.data.MaxRollingFromPeriod = this.calculatePeriodFromDate(evnt.data.To);

        if (!evnt.data.RollingFromMonth)
          evnt.data.RollingToPeriod = this.calculatePeriodFromDate(evnt.data.To);
        evnt.data.MinRollingToPeriod = this.calculatePeriodFromDate(evnt.data.From);
        evnt.data.MaxRollingToPeriod = this.__oSystemSettings[0].CounterpartyLimitMaxTenure;

        evnt.data.RollingFromPeriodSuspendValueChagned = false;
        evnt.data.RollingToPeriodSuspendValueChagned = false;
      }

      if (evnt && evnt.column.caption == "To" && evnt.data.TradingCategoryName !== 'Overall' && evnt.data.TradingCategoryName !== 'Headroom' && this.__oDatasource.find(x => x.lCounterpartyLimitId === evnt.data.lParentCounterpartyLimitId) && evnt.data.LimitTypeName !== 'Volume') {
        let oOverall = this.__oDatasource.find(x => x.lCounterpartyLimitId === evnt.data.lParentCounterpartyLimitId);

        this.__dtMaxDate = oOverall.To;
      }
      else if (evnt && evnt.column.caption == "To" && evnt.data.TradingCategoryName === 'Overall' || evnt.data.TradingCategoryName !== 'Headroom') {
        this.__dtMaxDate = dDates.dateAdd(new Date(this.__oSystemSettings[0].ValuationDate), this.__oSystemSettings[0].CounterpartyLimitMaxTenure - 1, "months"); // this.__dValuationDate;
      }
      if (evnt.data.LimitTypeName === 'Volume') {
        evnt.data.DataValues[evnt.columnIndex].IsEditorVisible = true;
        evnt.data.DataValues[evnt.columnIndex].IsDisabled = false; //FB30719-Pawan Prajapati
        evnt.data.DataValues.filter(x => (x.lTradingLimitId && x.lTradingLimitId > 0)) && evnt.data.DataValues.filter(x => (x.lTradingLimitId && x.lTradingLimitId > 0)).length > 0 ? evnt.data.EntityState = 2 : evnt.data.EntityState = 1;

        var aDuplicates = this.handleDuplicates(evnt, [], aDuplicates);

      }
      if (evnt.columnIndex >= this.__iColumnCountBeforeLimitValue) {
        this.checkFourEyeWarningMessage(evnt.data);//FB46162-Pawan Prajapati
      }
    }
    catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while executing cell clicked event.');
    }
  }

  private handleDuplicates(evnt: any, sDistinctValues: any[], aDuplicates: any[]) {
    try {
      if (!this.__bTimelineViewVisible && evnt.columnIndex >= 0 && evnt.columnIndex !== this.__oColuDetails.length) {
        evnt.data.DataValues[evnt.columnIndex].IsDisabled = false;
        for (let iCount = 0; iCount < evnt.data.DataValues.length; iCount++) {//CRD-420-Pawan Prajapati
          if (evnt.data.DataValues[iCount].LimitValue != undefined && evnt.data.DataValues[iCount].LimitValue != null && evnt.data.DataValues[iCount].LimitValue != "") {
            sDistinctValues.push(evnt.data.DataValues[iCount].LimitValue);
          }
        }
        var aDuplicates = Array.from(new Set(sDistinctValues)); //[...new Set(sDistinctValues)];
        evnt.data.DataValues[evnt.columnIndex].IsDisabled = (sDistinctValues.length != 0 && aDuplicates.length != 1) ? true : false;
      }
      return aDuplicates;
    } catch (oError) {
      this.Logger.Write(oError, 'Error', 'Error occurred while executing handle Duplicates function.');
    }
  }

  //Simple view temp limit cell click
  onTempLimitCell_Click(evnt: any) {
    try {
      let dDates: Dates = new Dates();
      var sDistinctValues: any[] = [];
      let iLastValueIndex = 0;
      //this.bIsIndexPresent = false;
      if (evnt && evnt.columnIndex >= 0 && evnt.columnIndex !== this.__oColuDetails.length) {
        evnt.data.TempDataValues && (evnt.data.TempDataValues[evnt.columnIndex] || evnt.data.TempDataValues[evnt.columnIndex] === 0) ? this.disableTempLimits(evnt, sDistinctValues) : null;

        // if (this.__oSystemSettings[0].IsOverAllLimitValidated && evnt.data.TradingCategoryName !== 'Overall' && this.__oDatasource.find(x => x.lCounterpartyLimitId === evnt.data.lParentCounterpartyLimitId)) { //CRD-1125 Pawan Prajapati

        let oOverall = this.__oDatasource.find(x => x.lCounterpartyLimitId === evnt.data.lCounterpartyLimitId)

          for (let i = oOverall.DataValues.length - 1; i >= 0; i--) {//CRD-420-Pawan Prajapati
            if (oOverall.DataValues[i].LimitValue || oOverall.DataValues[i].LimitValue === 0) {//CRD-612 -Venkat
              //iLastValue = event.DataValues[i].LimitValue;
              iLastValueIndex = i + 1;
              break;
            } else {
              evnt.data.TempDataValues && (evnt.data.TempDataValues[i] || evnt.data.TempDataValues[i] === 0) ? evnt.data.TempDataValues[i].IsDisabled = true : null;
            }
          }

          for (let i = 0; i < oOverall.DataValues.length - 1; i++) {//CRD-420-Pawan Prajapati
            if (oOverall.DataValues[i].LimitValue || oOverall.DataValues[i].LimitValue === 0) {//CRD-612 -Venkat
              //this.bIsIndexPresent = true;
              let dTempLimitDate = dDates.dateAdd(new Date(this.__oSystemSettings[0].ValuationDate), i, "months");//CRD-420-Pawan Prajapati
              this.__oNewTempLimit.ActiveFrom = (new Date(this.__oSystemSettings[0].ValuationDate) < dTempLimitDate) ? new Date(dTempLimitDate.getFullYear(), dTempLimitDate.getMonth(), 1) : new Date();
              (new Date(this.__oSystemSettings[0].ValuationDate) < dTempLimitDate) ? this.__dtMinTempDate = this.__oNewTempLimit.ActiveFrom : this.__dtMinTempDate = new Date(this.__oSystemSettings[0].ValuationDate);
              break;
            }
          }


        let dMaxDate = dDates.dateAdd(new Date(new Date(this.__oSystemSettings[0].ValuationDate).getFullYear(), new Date(this.__oSystemSettings[0].ValuationDate).getMonth(), new Date(this.__oSystemSettings[0].ValuationDate).getDate() == 29 ? 1 : new Date(this.__oSystemSettings[0].ValuationDate).getDate()), iLastValueIndex, "months");//CRD-420-Pawan Prajapati
        this.__dtMaxTempDate = new Date(dMaxDate.getFullYear(), dMaxDate.getMonth(), 0);
      }
      // } //CRD-1125 Pawan Prajapati
    } catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred on temp limit cell click.');
    }
  }

  private disableTempLimits(evnt: any, sDistinctValues: any[]) {
    try {
      evnt.data.TempDataValues[evnt.columnIndex].IsEditorVisible = true;
      if (!this.__bTimelineViewVisible) {
        evnt.data.TempDataValues[evnt.columnIndex].IsDisabled = false;
        for (let iCount = 0; iCount < evnt.data.TempDataValues.length; iCount++) {//CRD-420-Pawan Prajapati
          if (evnt.data.TempDataValues[iCount].LimitValue !== undefined && evnt.data.TempDataValues[iCount].LimitValue !== null && evnt.data.TempDataValues[iCount].LimitValue !== "") {
            sDistinctValues.push(evnt.data.TempDataValues[iCount].LimitValue);
          }
        }
        var aDuplicates = Array.from(new Set(sDistinctValues)); //[...new Set(sDistinctValues)];
        evnt.data.TempDataValues[evnt.columnIndex].IsDisabled = (sDistinctValues.length != 0 && aDuplicates.length != 1) ? true : false;
      } else if (this.__bTimelineViewVisible) {
        evnt.data.TempDataValues[evnt.columnIndex].IsDisabled = false;
      }
    } catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while disabling temp limits.');
    }
  }

  //gets data source updated with max allocation OR is over allocated
  private getMaxOrOverAllocation(evnt: any, IsMaxAllocation: boolean) {
    try {
      var iSum = 0;
      let iParentLimit = this.__oDatasource.filter(x => x.lCounterpartyLimitId == evnt.data.lParentCounterpartyLimitId) && this.__oDatasource.filter(x => x.lCounterpartyLimitId == evnt.data.lParentCounterpartyLimitId).length > 0 ? this.__oDatasource.find(x => x.lCounterpartyLimitId == evnt.data.lParentCounterpartyLimitId).lTradingCategoryId : -1;

      var oDataSource = [];
      if (iParentLimit === -1 || iParentLimit === 1) {
        oDataSource = this.__oDatasource.filter(x => (x.lParentTradingCategoryId === 1 || !x.lParentTradingCategoryId) && x.lTradingCounterpartyId == evnt.data.lTradingCounterpartyId && x.lOurEntityId == evnt.data.lOurEntityId && x.lLimitTypeId == evnt.data.lLimitTypeId && x.lSubLimitTypeId == evnt.data.lSubLimitTypeId && x.TradingCategoryName !== 'Headroom');//FB43985-Pawan Prajapati
      }
      else {
        oDataSource = this.__oDatasource.filter(x => (x.lParentTradingCategoryId === iParentLimit || x.lTradingCategoryId == iParentLimit) && x.lTradingCounterpartyId == evnt.data.lTradingCounterpartyId && x.lOurEntityId == evnt.data.lOurEntityId && x.lLimitTypeId == evnt.data.lLimitTypeId && x.lSubLimitTypeId == evnt.data.lSubLimitTypeId && x.TradingCategoryName !== 'Headroom');//FB43985-Pawan Prajapati
      }

      if (iParentLimit === -1 || iParentLimit === 1) {
        oDataSource.filter(z => z.TradingCategoryName !== "Overall").forEach(x => {
          if (x.DataValues[evnt.columnIndex].LimitValue || x.DataValues[evnt.columnIndex].LimitValue === 0) {//CRD-612 -Venkat
            iSum = (oDataSource.filter(z => z.TradingCategoryName === "Overall") && oDataSource.filter(z => z.TradingCategoryName === "Overall").length > 0 ? (iSum + (this.currencyConversion(x.DataValues[evnt.columnIndex].LimitValue, x.lLimitValueCurrencyId, oDataSource.find(z => z.TradingCategoryName === "Overall").lLimitValueCurrencyId))) : (iSum + x.DataValues[evnt.columnIndex].LimitValue));
          }
        });
        var oData = oDataSource.find(z => z.TradingCategoryName === "Overall");
        if (oData && oData.DataValues) {
          if (IsMaxAllocation) {
            (oData && oData.DataValues[evnt.columnIndex] && oData.DataValues[evnt.columnIndex].LimitValue) ? evnt.data.DataValues[evnt.columnIndex].MaxAllocation = this.currencyConversion(((oData.DataValues[evnt.columnIndex].LimitValue - (iSum - (evnt.data.DataValues[evnt.columnIndex].LimitValue ? (this.currencyConversion(evnt.data.DataValues[evnt.columnIndex].LimitValue, evnt.data.lLimitValueCurrencyId, oData.lLimitValueCurrencyId)) : 0))) < 0 ? (oData.DataValues[evnt.columnIndex].LimitValue - (iSum - (evnt.data.DataValues[evnt.columnIndex].LimitValue ? (this.currencyConversion(evnt.data.DataValues[evnt.columnIndex].LimitValue, evnt.data.lLimitValueCurrencyId, oData.lLimitValueCurrencyId)) : 0))) : ((oData.DataValues[evnt.columnIndex].LimitValue - (iSum - (evnt.data.DataValues[evnt.columnIndex].LimitValue ? (this.currencyConversion(evnt.data.DataValues[evnt.columnIndex].LimitValue, evnt.data.lLimitValueCurrencyId, oData.lLimitValueCurrencyId)) : 0))))), oData.lLimitValueCurrencyId, evnt.data.lLimitValueCurrencyId) : evnt.data.DataValues[evnt.columnIndex].MaxAllocation = 0;
            evnt.data.TempDataValues && evnt.data.TempDataValues[evnt.columnIndex] ? evnt.data.TempDataValues[evnt.columnIndex].MaxAllocation = evnt.data.DataValues[evnt.columnIndex].MaxAllocation : null
          }
          else {
            !this.__bTimelineViewVisible ? this.updateWarnings() : ((oData && oData.DataValues[evnt.columnIndex] && oData.DataValues[evnt.columnIndex].LimitValue < iSum) ? oData.DataValues[evnt.columnIndex].IsOverAllocation = 1 : oData.DataValues[evnt.columnIndex].IsOverAllocation = 0);
          }
        }
      }
      else {
        oDataSource.filter(z => z.IsOverall !== 1).forEach(x => {
          if (x.DataValues[evnt.columnIndex].LimitValue || x.DataValues[evnt.columnIndex].LimitValue === 0) {//CRD-612 -Venkat
            iSum = (oDataSource.filter(z => (z.IsOverall === 1)) && oDataSource.filter(z => (z.IsOverall === 1)).length > 0 ? (iSum + (this.currencyConversion(x.DataValues[evnt.columnIndex].LimitValue, x.lLimitValueCurrencyId, oDataSource.filter(z => (z.IsOverall === 1))[0].lLimitValueCurrencyId))) : (iSum + x.DataValues[evnt.columnIndex].LimitValue));
          }
        });
        var oData = oDataSource.filter(z => (z.IsOverall === 1))[0];
        if (oData && oData.DataValues) {
          if (IsMaxAllocation) {
            (oData && oData.DataValues[evnt.columnIndex] && oData.DataValues[evnt.columnIndex].LimitValue) ? evnt.data.DataValues[evnt.columnIndex].MaxAllocation = this.currencyConversion(((oData.DataValues[evnt.columnIndex].LimitValue - (iSum - (evnt.data.DataValues[evnt.columnIndex].LimitValue ? (this.currencyConversion(evnt.data.DataValues[evnt.columnIndex].LimitValue, evnt.data.lLimitValueCurrencyId, oData.lLimitValueCurrencyId)) : 0))) < 0 ? (oData.DataValues[evnt.columnIndex].LimitValue - (iSum - (evnt.data.DataValues[evnt.columnIndex].LimitValue ? (this.currencyConversion(evnt.data.DataValues[evnt.columnIndex].LimitValue, evnt.data.lLimitValueCurrencyId, oData.lLimitValueCurrencyId)) : 0))) : ((oData.DataValues[evnt.columnIndex].LimitValue - (iSum - (evnt.data.DataValues[evnt.columnIndex].LimitValue ? (this.currencyConversion(evnt.data.DataValues[evnt.columnIndex].LimitValue, evnt.data.lLimitValueCurrencyId, oData.lLimitValueCurrencyId)) : 0))))), oData.lLimitValueCurrencyId, evnt.data.lLimitValueCurrencyId) : evnt.data.DataValues[evnt.columnIndex].MaxAllocation = 0;
            evnt.data.TempDataValues && evnt.data.TempDataValues[evnt.columnIndex] ? evnt.data.TempDataValues[evnt.columnIndex].MaxAllocation = evnt.data.DataValues[evnt.columnIndex].MaxAllocation : null
          }
          else {
            !this.__bTimelineViewVisible ? this.updateWarnings() : ((oData && oData.DataValues[evnt.columnIndex] && iSum != 0 && oData.DataValues[evnt.columnIndex].LimitValue != 0 && oData.DataValues[evnt.columnIndex].LimitValue < iSum) ? oData.DataValues[evnt.columnIndex].IsOverAllocation = 1 : oData.DataValues[evnt.columnIndex].IsOverAllocation = 0);
          }
        }
      }
    }
    catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while updating datasource with max allocation.');
    }

  }

  //gets data source updated with max allocation OR is over allocated
  private checkForAnyLimitBreachByRow(evnt: any, IsMaxAllocation: boolean) {
    try {
      let iParentLimit = this.__oDatasource.filter(x => x.lCounterpartyLimitId == evnt.data.lParentCounterpartyLimitId) && this.__oDatasource.filter(x => x.lCounterpartyLimitId == evnt.data.lParentCounterpartyLimitId).length > 0 ? this.__oDatasource.filter(x => x.lCounterpartyLimitId == evnt.data.lParentCounterpartyLimitId)[0].lTradingCategoryId : -1;
      var oDataSource = [];
      if (iParentLimit === -1 || iParentLimit === 1) {
        oDataSource = this.__oDatasource.filter(x => (x.lParentTradingCategoryId === 1 || !x.lParentTradingCategoryId) && x.lTradingCounterpartyId == evnt.data.lTradingCounterpartyId && x.lOurEntityId == evnt.data.lOurEntityId && x.lLimitTypeId == evnt.data.lLimitTypeId && x.lSubLimitTypeId == evnt.data.lSubLimitTypeId && x.TradingCategoryName !== 'Headroom');//FB43985-Pawan Prajapati
      }
      else {
        oDataSource = this.__oDatasource.filter(x => (x.lParentTradingCategoryId === iParentLimit || x.lTradingCategoryId == iParentLimit) && x.lTradingCounterpartyId == evnt.data.lTradingCounterpartyId && x.lOurEntityId == evnt.data.lOurEntityId && x.lLimitTypeId == evnt.data.lLimitTypeId && x.lSubLimitTypeId == evnt.data.lSubLimitTypeId && x.TradingCategoryName !== 'Headroom');//FB43985-Pawan Prajapati
      }

      if (iParentLimit === -1 || iParentLimit === 1) {
        for (var columnIndex = evnt.data.DataValues.length - 1; columnIndex >= 0; columnIndex--) {//CRD-420-Pawan Prajapati
          var iSum = 0;
          var iLimitSum: number = null;
          var iColourVariant = 1;
          oDataSource.filter(z => z.TradingCategoryName !== "Overall").forEach(x => {
            if (x.DataValues[columnIndex].LimitValue || x.DataValues[columnIndex].LimitValue === 0) {//CRD-612 -Venkat
              iSum = (oDataSource.filter(z => z.TradingCategoryName === "Overall") && oDataSource.filter(z => z.TradingCategoryName === "Overall").length > 0 ? (iSum + (this.currencyConversion(x.DataValues[columnIndex].LimitValue, x.lLimitValueCurrencyId, oDataSource.filter(z => z.TradingCategoryName === "Overall")[0].lLimitValueCurrencyId))) : (iSum + x.DataValues[columnIndex].LimitValue));;
              iLimitSum = (oDataSource.filter(z => z.TradingCategoryName === "Overall") && oDataSource.filter(z => z.TradingCategoryName === "Overall").length > 0 ? (iLimitSum + (this.currencyConversion(x.DataValues[columnIndex].LimitValue, x.lLimitValueCurrencyId, oDataSource.filter(z => z.TradingCategoryName === "Overall")[0].lLimitValueCurrencyId))) : (iLimitSum + x.DataValues[columnIndex].LimitValue));;
            }
          });
          var oData = oDataSource.filter(z => z.TradingCategoryName === "Overall")[0];
          if (oDataSource.filter(z => z.TradingCategoryName === "Overall") && oDataSource.filter(z => z.TradingCategoryName === "Overall").length > 0 && this.__oSystemSettings[0].IsOverallLimitEditable === 0 && iLimitSum !== null) {
            oData.DataValues[columnIndex].LimitValue = iSum;
            oData.DataValues[columnIndex].lTradingLimitId > 0 ? (oData.EntityState = 2, oData.DataValues[columnIndex].EntityState = 2) : (oData.EntityState = 1, oData.DataValues[columnIndex].EntityState = 1);
          }
          if (IsMaxAllocation && oData) {
            (oData && oData.DataValues[columnIndex] && oData.DataValues[columnIndex].LimitValue) ? evnt.data.DataValues[columnIndex].MaxAllocation = this.currencyConversion(((oData.DataValues[columnIndex].LimitValue - (iSum - (evnt.data.DataValues[columnIndex].LimitValue ? (this.currencyConversion(evnt.data.DataValues[columnIndex].LimitValue, evnt.data.lLimitValueCurrencyId, oData.lLimitValueCurrencyId)) : 0))) < 0 ? (oData.DataValues[columnIndex].LimitValue - (iSum - (evnt.data.DataValues[columnIndex].LimitValue ? (this.currencyConversion(evnt.data.DataValues[columnIndex].LimitValue, evnt.data.lLimitValueCurrencyId, oData.lLimitValueCurrencyId)) : 0))) : ((oData.DataValues[columnIndex].LimitValue - (iSum - (evnt.data.DataValues[columnIndex].LimitValue ? (this.currencyConversion(evnt.data.DataValues[columnIndex].LimitValue, evnt.data.lLimitValueCurrencyId, oData.lLimitValueCurrencyId)) : 0))))), oData.lLimitValueCurrencyId, evnt.data.lLimitValueCurrencyId) : evnt.data.DataValues[columnIndex].MaxAllocation = 0;
          }
        }

        if (!IsMaxAllocation && oData) {
          !this.__bTimelineViewVisible ? this.updateWarnings() : ((oData && oData.DataValues[evnt.columnIndex] && oData.DataValues[evnt.columnIndex].LimitValue < iSum) ? oData.DataValues[evnt.columnIndex].IsOverAllocation = 1 : oData.DataValues[evnt.columnIndex].IsOverAllocation = 0);
        }
      }
      else {
        for (var columnIndex = evnt.data.DataValues.length - 1; columnIndex >= 0; columnIndex--) {//CRD-420-Pawan Prajapati
          var iSum = 0;
          var iColourVariant = 1;
          oDataSource.filter(z => z.IsOverall !== 1).forEach(x => {
            if (x.DataValues[columnIndex].LimitValue || x.DataValues[columnIndex].LimitValue === 0) {//CRD-612 -Venkat
              iSum = (oDataSource.filter(z => (z.IsOverall === 1)) && oDataSource.filter(z => (z.IsOverall === 1)).length > 0 ? (iSum + (this.currencyConversion(x.DataValues[columnIndex].LimitValue, x.lLimitValueCurrencyId, oDataSource.filter(z => (z.IsOverall === 1))[0].lLimitValueCurrencyId))) : (iSum + x.DataValues[columnIndex].LimitValue));;
            }
          });

          var oData = oDataSource.filter(z => (z.IsOverall === 1))[0];
          //if (oDataSource.filter(z => (z.IsOverall === 1)) && oDataSource.filter(z => (z.IsOverall === 1)).length > 0 && this.__oSystemSettings[0].IsOverallLimitEditable === 0) {
          //  oData.DataValues[columnIndex].LimitValue = iSum;
          //  oData.DataValues[columnIndex].lTradingLimitId > 0 ? (oData.EntityState = 2, oData.DataValues[columnIndex].EntityState = 2) : (oData.EntityState = 1, oData.DataValues[columnIndex].EntityState = 1);
          //}

          if (IsMaxAllocation && oData) {
            (oData && oData.DataValues[columnIndex] && oData.DataValues[columnIndex].LimitValue) ? evnt.data.DataValues[columnIndex].MaxAllocation = this.currencyConversion(((oData.DataValues[columnIndex].LimitValue - (iSum - (evnt.data.DataValues[columnIndex].LimitValue ? (this.currencyConversion(evnt.data.DataValues[columnIndex].LimitValue, evnt.data.lLimitValueCurrencyId, oData.lLimitValueCurrencyId)) : 0))) < 0 ? (oData.DataValues[columnIndex].LimitValue - (iSum - (evnt.data.DataValues[columnIndex].LimitValue ? (this.currencyConversion(evnt.data.DataValues[columnIndex].LimitValue, evnt.data.lLimitValueCurrencyId, oData.lLimitValueCurrencyId)) : 0))) : ((oData.DataValues[columnIndex].LimitValue - (iSum - (evnt.data.DataValues[columnIndex].LimitValue ? (this.currencyConversion(evnt.data.DataValues[columnIndex].LimitValue, evnt.data.lLimitValueCurrencyId, oData.lLimitValueCurrencyId)) : 0))))), oData.lLimitValueCurrencyId, evnt.data.lLimitValueCurrencyId) : evnt.data.DataValues[columnIndex].MaxAllocation = 0;
          }
        }

        if (!IsMaxAllocation && oData) {
          !this.__bTimelineViewVisible ? this.updateWarnings() : ((oData && oData.DataValues[evnt.columnIndex] && oData.DataValues[evnt.columnIndex].LimitValue < iSum) ? oData.DataValues[evnt.columnIndex].IsOverAllocation = 1 : oData.DataValues[evnt.columnIndex].IsOverAllocation = 0);
        }
      }
      //Start CRD-420-Pawan Prajapati
      evnt.data.DataValues[0].ColourVariant = iColourVariant;
      for (var columnIndex = 0; columnIndex < evnt.data.DataValues.length; columnIndex++) {
        if (columnIndex > 0 && (evnt.data.DataValues[columnIndex].MaxAllocation === evnt.data.DataValues[columnIndex - 1].MaxAllocation)) {
          evnt.data.DataValues[columnIndex].ColourVariant = iColourVariant;
        }
        else {
          iColourVariant = iColourVariant + 1;
          evnt.data.DataValues[columnIndex].ColourVariant = iColourVariant;
        }
      }
      //End CRD-420-Pawan Prajapati
    }
    catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while updating datasource with max allocation.');
    }
  }

  //cell template
  cellTemplate(e: any) {

  }
  //fires when key is pressed
  private numberBox_KeyPress(e: any, data: any, ColumnIndex: any, rowIndex: any, name: any) {
    try {
      if (e.event.key.toString().toUpperCase() == "M" || e.event.key.toString().toUpperCase() == "B" || e.event.key.toString().toUpperCase() == "K" || e.event.key.toString().toUpperCase() == "H" || e.event.key.toString().toUpperCase() == "T" || e.event.key.toString().toUpperCase() == "-") {
        this.__otrCounterpartyLimits.instance.focus(this.__otrCounterpartyLimits.instance.getCellElement(rowIndex, ColumnIndex + this.__iColumnCountBeforeLimitValue));
        if (e.event.key.toString().toUpperCase() == "M") {
          let oDataValue = data.DataValues[ColumnIndex];
          name === "limitvalue" ? data.DataValues[ColumnIndex].LimitValue = this.parseFloat(e.event.target.value.toString(), 1000000) : data.TempDataValues[ColumnIndex].LimitValue = this.parseFloat(e.event.target.value.toString(), 1000000);
        } else if (e.event.key.toString().toUpperCase() == "B") {

          let oDataValue = data.DataValues[ColumnIndex];
          name === "limitvalue" ? data.DataValues[ColumnIndex].LimitValue = this.parseFloat(e.event.target.value.toString(), 1000000000) : data.TempDataValues[ColumnIndex].LimitValue = this.parseFloat(e.event.target.value.toString(), 1000000000);
        } else if (e.event.key.toString().toUpperCase() == "K" || e.event.key.toString().toUpperCase() == "T") {

          let oDataValue = data.DataValues[ColumnIndex];
          name === "limitvalue" ? data.DataValues[ColumnIndex].LimitValue = this.parseFloat(e.event.target.value.toString(), 1000) : data.TempDataValues[ColumnIndex].LimitValue = this.parseFloat(e.event.target.value.toString(), 1000);
        } else if (e.event.key.toString().toUpperCase() == "H") {
          let oDataValue = data.DataValues[ColumnIndex];
          name === "limitvalue" ? data.DataValues[ColumnIndex].LimitValue = this.parseFloat(e.event.target.value.toString(), 100) : data.TempDataValues[ColumnIndex].LimitValue = this.parseFloat(e.event.target.value.toString(), 100);
        } else if (e.event.key.toString().toUpperCase() == "-") {
          let oDataValue = data.DataValues[ColumnIndex];
          name === "limitvalue" ? data.DataValues[ColumnIndex].LimitValue = Math.abs(e.event.target.value.toString()) : data.TempDataValues[ColumnIndex].LimitValue = Math.abs(e.event.target.value.toString());
        }

        this.limitValue_Changed(e, data, null, ColumnIndex, name === "limitvalue" ? false : true);
      }
    } catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while executing key press event.');
    }
  }

  /// parses to float value
  private parseFloat(fValue: string, sKey: number) {
    try {
      return parseFloat(fValue.replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * sKey
    } catch (oError) {
      this.Logger.Write(oError, 'Error', 'Error occurred while executing parse Float function.');
    }
  }
  private onKeyPressNumberBoxState(e: any, type: any, data: any) {
    try {
      if (type == "tempLimit") {
        if (e.event.key == 'm' || e.event.key == "M") {
          this.__oNewTempLimit.LimitValue = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 1000000;
        } else if (e.event.key == "b" || e.event.key == "B") {
          this.__oNewTempLimit.LimitValue = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 1000000000;
        } else if (e.event.key == "k" || e.event.key == "K") {
          this.__oNewTempLimit.LimitValue = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 1000;
        } else if (e.event.key == "h" || e.event.key == "H") {
          this.__oNewTempLimit.LimitValue = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 100;
        } else if (e.event.key == "t" || e.event.key == "T") {
          this.__oNewTempLimit.LimitValue = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 1000;
        }
      }

      if (type == "tempLimitFromMonth" && data.RollingFromMonth && data.RollingToMonth && e.event.target.value) {
        var iCurrentMonth = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", ""));
        data.RollingToMonth && data.RollingFromMonth && (iCurrentMonth >= parseFloat(data.RollingFromMonth) && iCurrentMonth <= parseFloat(data.RollingToMonth)) ? data.RollingFromMonth = iCurrentMonth.toString() : "";
      }

      if (type == "tempLimitToMonth") {
        var iCurrentMonth = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", ""));
        data.RollingToMonthMax && data.RollingToMonth && (iCurrentMonth >= parseFloat(data.RollingToMonth) && iCurrentMonth <= parseFloat(data.RollingToMonthMax)) ? data.RollingToMonth = iCurrentMonth.toString() : "";
      }
    } catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred on number box key press event.');
    }
  }

  /// creates columns runtime
  private createGridColumns(iColumnIndex: number, oColuDetails: any[]) {
    try {
      this.__oGridcolumns = [];

      this.pushColumn("TradingCounterpartyName", "Counterparty", "cellTemplateCPComboBox", "", "15.2rem", true, true, false, false, false, false, "", "", this.__bIsFreezed ? true : false);
      this.pushColumn("TradingEntityName", "Our Entity", "cellTemplateOurEntityComboBox", "", "15.2rem", true, true, false, false, false, false, "", "", this.__bIsFreezed ? true : false);
      this.pushColumn("LimitTypeName", "Limit Type", "", "cellTemplateLimitTypeComboBox", "8.8rem", true, true, false, false, false, false, "", "", this.__bIsFreezed ? true : false);
      this.pushColumn("TradingCategoryName", "Trading Category or Product", "editcellTemplateTradingCategoryComboBox", "cellTemplateTradingCategoryComboBox", "9rem", true, true, false, false, false, false, "", "", this.__bIsFreezed ? true : false);
      //Start CRD-409 Pawan Prajapati
      this.__iColumnCountBeforeAmanded = this.__oGridcolumns.length;
      if (this.__bIsIsCustomColumn) {
        for (let i = 0; i < this.__oLimitCustomProperties.length; i++) {
          this.pushColumn(i, this.__oLimitCustomProperties[i].LimitCustomProperty, "cellTemplateCustomColumn", "cellTemplateCustomColumn", 200, true, true, false, false, false, false, "", "", false);
        }
      }
      //End CRD-409 Pawan Prajapati
      this.pushColumn("UserNameFirstLetters", "Amended", "editCellTemplateTextArea", "cellTemplateTextArea", "4.3rem", true, true, false, false, false, false, "", "", false);

      this.pushColumn("TenorTypeName", "Tenor Type", "editCellTemplateTenorTypeComboBox", "cellTemplateTenorTypeComboBox", "8.1rem", true, true, false, false, false, true, "", "", false);

      this.pushColumn("From", "From", "editCellTemplateFromDate", "cellTemplateFromDate", "9.8rem", true, true, false, false, false, true, "date", "monthAndYear", false);

      this.pushColumn("To", "To", "editCellTemplateToDate", "cellTemplateToDate", "9.8rem", true, true, false, false, false, true, "date", "monthAndYear", false);

      this.pushColumn("", "", "", "cellTemplateIcon", 'auto', false, false, false, false, false, false, "", "", false, 'padding0pxImp');//FB44260-Pawan Prajapati
      delete this.__oGridcolumns[this.__oGridcolumns.length - 1].minWidth;
      this.__oGridcolumns[this.__oGridcolumns.length - 1].width = 'auto';//PD-122

      this.pushColumn("CurrencyName", "Currency or Unit", "editcellTemplateCurrencyComboBox", "cellTemplateCurrencyComboBox", "4.6rem", true, true, false, false, false, true, "", "", false);
      this.__iColumnCountBeforeLimitValue = this.__oGridcolumns.length;//CRD-420-Pawan Prajapati
      if (this.__bTimelineViewVisible) {
        for (iColumnIndex; iColumnIndex < oColuDetails.length; iColumnIndex++) {
          this.pushColumn("DataValues[" + iColumnIndex + "].LimitValue", oColuDetails[iColumnIndex].ColumnName, "cellTemplateLimitValue", "cellTemplate", "8.9rem", true, false, false, false, false, true, "", "", false);
        }
        this.__oGridcolumns.push({
          cellTemplate: 'cellDeleteTemplate',
          caption: '',
          width: 50,
          allowHiding: false,
          showInColumnChooser: false,
          allowEditing: false,
          fixed: true,
          fixedPosition: "right"
        });
      } else {
        this.pushColumn("DataValues[" + iColumnIndex + "].LimitValue", "Current Month Limit Value", "cellTemplateLimitValue", "cellTemplate", "8.9rem", true, false, false, false, false, true, "", "", false);
        this.__oGridcolumns.push({
          cellTemplate: 'cellDeleteTemplate',
          caption: '',
          width: 50,
          allowHiding: false,
          showInColumnChooser: false,
          allowEditing: false,
          fixed: true,
          fixedPosition: "right"
        });
      }
      this.__otrCounterpartyLimits.instance.option("columns", this.__oGridcolumns);//CRD-409 Pawan Prajapati
    } catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while creating grid columns.');
    }
  }

  //Start CRD-409 Pawan Prajapati
  getCustomColumnValue(oLimit: CounterpartyLimitViewModel, oCustomColumn: LimitCustomPropertyData) {
    var sValue = '';
    if (oLimit && oLimit.LimitCustomPropertyValues) {
      var oItem = oLimit.LimitCustomPropertyValues.find(k => k.lLimitCustomPropertyId == oCustomColumn.lLimitCustomPropertyId);
      sValue = oItem ? oItem.Value : '';
    }
    return sValue;
  }
  //End CRD-409 Pawan Prajapati

  /// creates columns runtime
  private pushColumn(sDataField: any, sCaption: any, editCellTemplate: any, cellTemplate: any, nWidth: any,
    bAllowSorting: boolean, bAllowFiltering: boolean, bAllowReordering: boolean, bAllowHiding: boolean, bShowInColumnChooser: boolean, bAllowEditing: boolean, sDataType: string, sFormat: string, bAllowFixing: boolean, sClassName: string = null) {

    try {
      let oColumn: any =
      {
        dataField: sDataField,
        caption: sCaption,
        //editCellTemplate: editCellTemplate,
        //cellTemplate: 'cellTemplateMultilineReadOnly',
        //width: nWidth,
        minWidth: nWidth,
        //fixed: true,
        //sortOrder: 'asc',
        allowSorting: bAllowSorting,
        allowFiltering: bAllowFiltering,
        allowReordering: bAllowReordering,
        allowHiding: bAllowHiding,
        showInColumnChooser: bShowInColumnChooser,
        allowEditing: bAllowEditing,
        fixed: bAllowFixing

      }
      if (editCellTemplate) {
        oColumn.editCellTemplate = editCellTemplate;
      }

      if (cellTemplate) {
        oColumn.cellTemplate = cellTemplate;
      }
      if (bAllowFixing) {
        oColumn.fixedPosition = "left";
      }
      if (sDataField === "TradingCounterpartyName") {
        oColumn.headerCellTemplate = "titleHeaderTemplate"
      }
      if (sDataType) {
        oColumn.dataType = sDataType;
        oColumn.format = sFormat;
      }
      if (sClassName) {//FB44260-Pawan Prajapati
        oColumn.cssClass = sClassName;
      }

      this.__oGridcolumns.push(oColumn);
    }
    catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while executing push column function.');
    }
  }

  ///Limit value change thorugh popup
  btnLimitValue_Clicked(evnt: any, rowData: any, columnIndex: number) {
    try {
      let oDates: Dates = new Dates();
      this.__bAmendLimitsVisible = false;
      this.__oDatasource.forEach(x => {
        x.IsEditButtonClicked = 0;
      });

      rowData.IsEditButtonClicked = 1;
      this.__otrCounterpartyLimits.instance.focus();

      var evntData: any = {};
      evntData.data = rowData;
      evntData.columnIndex = columnIndex;
      this.__bIsTempLimitEditing = evnt.IsTempLimit;
      this.__dtMaxDate = (evnt.IsTempLimit ? rowData.To : this.__dtMaxDate);
      this.checkForAnyLimitBreachByRow(evntData, true);
      this.__bSideBar = true;
      this.__oSideBarCounterPartyLimit = rowData;
      this.__oSideBarCounterPartyLimit.DefaultDate = oDates.dateAdd(new Date(new Date(this.__oSystemSettings[0].ValuationDate).getFullYear(), new Date(this.__oSystemSettings[0].ValuationDate).getMonth(), new Date(this.__oSystemSettings[0].ValuationDate).getDate() == 29 ? 1 : new Date(this.__oSystemSettings[0].ValuationDate).getDate()), columnIndex, "months");//CRD-420-Pawan Prajapati
      this.__oSideBarCounterPartyLimit.IsTempLimit = evnt.IsTempLimit;
      this.__bAllowDeleting = false;
      //Start FB39751-Pawan Prajapati

      this.__otrCounterpartyLimits.instance.refresh();

      setTimeout(() => {

        if (document.getElementById("divlimitsContainer") && document.getElementById("divlimitsContainer").getElementsByClassName("dx-treelist-table-fixed")[2]) {

          (document.getElementById("divlimitsContainer").getElementsByClassName("dx-treelist-table-fixed")[2] as any).style.pointerEvents = "none";

        }

      }, 100);

      //End FB39751-Pawan Prajapati

    }
    catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while saving limits.');
    }
  }
  //numeric box focus out
  numberBox_FocusOut(rowData: any, columnIndex: number) {
    try {
      rowData.DataValues[columnIndex].IsVisible = true;
      this.__oOverAllocation = {};
      if (1 !== 1 && rowData && rowData.TradingCategoryName !== "Overall" && rowData.TradingCategoryName !== 'Headroom' && rowData.DataValues[columnIndex].LimitValue && rowData.DataValues[columnIndex].MaxAllocation && rowData.DataValues[columnIndex].LimitValue > rowData.DataValues[columnIndex].MaxAllocation) {
        var oData = this.__oDatasource.find(x => x.lCounterpartyLimitId === rowData.lParentCounterpartyLimitId);
        this.__oOverAllocation.difference = Math.abs(rowData.DataValues[columnIndex].MaxAllocation - rowData.DataValues[columnIndex].LimitValue);
        this.__oOverAllocation.OverallLimitValue = oData && oData.DataValues ? oData.DataValues[columnIndex].LimitValue : 0;
        this.__oOverAllocation.LimitValue = rowData.DataValues[columnIndex].LimitValue;
        this.__bOverAllocationFocusOutAlertVisible = true;
        this.__bOverAllocationAlertVisible = false;
      }
    } catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred on number box fucus out event.');
    }
  }
  /// temp limit non negative acceptance
  tempLimit_FocusOut(eventData: any) {
    try {
      this.__oNewTempLimit.LimitValue = eventData ? Math.abs(eventData) : eventData;
    } catch (oError) {
      this.Logger.Write(oError, 'Error', 'Error occurred while executing tempLimit FocusOut function.');
    }
  }
  //save limits to database
  btnSave_Clicked() {
    try {
      this.__iKeys = this.__oDatasource.map(x => x.lCounterpartyLimitId);
      this.__bValidationFailed = false;
      let oComponentInstance = this; this.__otrCounterpartyLimits.instance.forEachNode(function (node) { oComponentInstance.__otrCounterpartyLimits.instance.expandRow(node.key); });
      this.__otrCounterpartyLimits.instance.refresh();
      //this.__otrCounterpartyLimits.instance.focus(this.__otrCounterpartyLimits.instance.getCellElement(0, 0));
      this.__oDatasourceDeleted = this.__oDatasourceDeleted.filter(x => x.lCounterpartyLimitId > 0);
      if (this.__oDatasource.length > 0 || this.__oDatasourceDeleted.length > 0) {
        let bIsLimitValueUnAvailable: boolean = false;
        let oCounterpartyLimit: CounterpartyLimitViewModel = new CounterpartyLimitViewModel()
        this.__oDatasource.forEach(x => {
          let bIsIndexReached = false;
          if (x.lCounterpartyLimitId > 5000000 && !bIsLimitValueUnAvailable) {
            for (var i = x.DataValues.length - 1; i >= 0; i--) {//CRD-420-Pawan Prajapati
              if ((x.DataValues[i].LimitValue !== null && x.DataValues[i].LimitValue !== undefined && x.DataValues[i].LimitValue !== "") && !bIsIndexReached) {
                bIsIndexReached = true;
                break;
              }
              x.DataValues[i].EntityState = 0;
            }
            !bIsIndexReached ? (bIsLimitValueUnAvailable = true, oCounterpartyLimit = x) : bIsLimitValueUnAvailable = false;

          }
          else {
            for (var i = x.DataValues.length - 1; i >= 0; i--) {//CRD-420-Pawan Prajapati
              if ((x.DataValues[i].LimitValue !== null && x.DataValues[i].LimitValue !== undefined && x.DataValues[i].LimitValue !== "") && !bIsIndexReached) {
                bIsIndexReached = true;
                i = i - 1;
              }

              if (bIsIndexReached && i >= 0 && x.DataValues[i].lTradingLimitId == 0) {//CRD-420-Pawan Prajapati
                x.DataValues[i].EntityState = 1;
              }
            }
          }
        });

        if (bIsLimitValueUnAvailable) {
          this.__bValidationFailed = true;
          this.__sMessage = 'Please enter the Limit value and To date to continue for the combination of counterparty: ' + oCounterpartyLimit.TradingCounterpartyName + ", our entity: " + oCounterpartyLimit.TradingEntityName + " and limit type: " + oCounterpartyLimit.LimitTypeName + "."; this.__sMessageTitle = 'Error'; this.__sMessageType = "Error";
          this.__bConfirmationVisible = true;
          return;
        }

        this.__oDatasource.forEach(x => {
          x.CounterpartyLimitWarnings = [];
          if (!this.__oDatasource.find(z => z.lTradingCounterpartyId == x.lTradingCounterpartyId && z.lOurEntityId == x.lOurEntityId && z.SubLimitTypeName === z.SubLimitTypeName && z.LimitTypeName == x.LimitTypeName && z.TradingCategoryName === "Overall") && this.__oDatasource.find(z => z.lTradingCounterpartyId == x.lTradingCounterpartyId && z.lOurEntityId == x.lOurEntityId && z.SubLimitTypeName === z.SubLimitTypeName && z.LimitTypeName == x.LimitTypeName && z.TradingCategoryName === "Overall")) {//FB43985-Pawan Prajapati
            let sMessage = "The Tenor Type of Trading Category limit has to be same as its Overall Limit for " + x.TradingCounterpartyName + "," + x.TradingEntityName + "," + x.LimitTypeName + " and " + x.TradingCategoryName + ", please correct it";
            (this.__bValidationFailed = true, (this.__oAlertComponent ? (this.__oAlertComponent.__bConfirmationVisible = true, this.__bConfirmationVisible = true) : this.__bConfirmationVisible = true), this.__sMessage = sMessage, this.__sMessageTitle = 'Limit validation', this.__sMessageType = "Error");
          }
        });

        if (this.__bValidationFailed) {
          return;
        }
        //this.validateLimit(true);
        let oComponentInstance = this; this.__otrCounterpartyLimits.instance.forEachNode(function (node) { oComponentInstance.__otrCounterpartyLimits.instance.expandRow(node.key); });
        this.__otrCounterpartyLimits.instance.refresh();
        let oCounterpartyLimitsManager: CounterpartyLimitsManager = new CounterpartyLimitsManager(this.Logger);
        let oResult: any = oCounterpartyLimitsManager.validateLimit(true, this.__oDatasource, this.__oSystemSettings, this.__oExchangeRateEFs, this.__otrCounterpartyLimits, this.__oTradingCounterpartyLegalHierarchyOwnerships, this.__oUtilityService, this.__oTradingEntityLegalHierarchyOwnerships);

        this.__oDatasource = oResult.__oDatasource;
        this.__oBreaches = [];

        if (!oResult.bValidated && this.__oDatasource.find(z => (z.TradingCategoryName === "Overall" || z.IsOverall === 1) && z.CounterpartyLimitWarnings && z.CounterpartyLimitWarnings.length > 0)) {
          this.__oDatasource.filter(z => (z.TradingCategoryName === "Overall" || z.IsOverall === 1) && z.CounterpartyLimitWarnings && z.CounterpartyLimitWarnings.length > 0).forEach(x => {
            this.__oBreaches.push(x.CounterpartyLimitWarnings[0]);//x.CounterpartyLimitWarnings[0].reverse().forEach(y => this.__oBreaches.push(y));
          })
          this.__bValidationsVisible = true;
          return;
        }

        if (!oResult.bValidated) {
          oResult.sMessage ? (this.__bValidationFailed = true, (this.__oAlertComponent ? (this.__oAlertComponent.__bConfirmationVisible = true, this.__bConfirmationVisible = true) : this.__bConfirmationVisible = true), this.__sMessage = oResult.sMessage, this.__sMessageTitle = 'Limit validation', this.__sMessageType = "Error") : (this.__oAlertComponent ? (this.__oAlertComponent.__bConfirmationVisible = false, this.__bConfirmationVisible = false) : this.__bConfirmationVisible = false);
          return;
        }

        let oOurEntityLimitsManager: OurEntityLimitsManager = new OurEntityLimitsManager(this.Logger);
        oResult = oOurEntityLimitsManager.validateLimit(true, this.__oDatasource.filter(z => this.__oOurEntityLegalHierarchyOwnerships.filter(x => x.lChildTradingEntityId == z.lOurEntityId).length > 0 || this.__oTradingEntityLegalHierarchyOwnerships[0].lChildTradingEntityId === z.lOurEntityId), this.__oSystemSettings, this.__oExchangeRateEFs, this.__otrCounterpartyLimits, this.__oTradingEntityLegalHierarchyOwnerships, this.__oUtilityService, this.__oTradingCounterpartyLegalHierarchyOwnerships);

        //this.__oDatasource = oResult.__oDatasource;
        this.__oBreaches = [];
        if (!oResult.bValidated && oResult.__oDatasource.find(z => (z.TradingCategoryName === "Overall" || z.IsOverall === 1) && z.CounterpartyLimitWarnings && z.CounterpartyLimitWarnings.length > 0)) {
          oResult.__oDatasource.filter(z => (z.TradingCategoryName === "Overall" || z.IsOverall === 1) && z.CounterpartyLimitWarnings && z.CounterpartyLimitWarnings.length > 0).forEach(x => {
            this.__oBreaches.push(x.CounterpartyLimitWarnings[0]);//x.CounterpartyLimitWarnings[0].reverse().forEach(y => this.__oBreaches.push(y));
          })
          this.__bValidationsVisible = true;
          return;
        }

        if (!oResult.bValidated) {
          oResult.sMessage ? (this.__bValidationFailed = true, (this.__oAlertComponent ? (this.__oAlertComponent.__bConfirmationVisible = true, this.__bConfirmationVisible = true) : this.__bConfirmationVisible = true), this.__sMessage = oResult.sMessage, this.__sMessageTitle = 'Limit validation', this.__sMessageType = "Error") : (this.__oAlertComponent ? (this.__oAlertComponent.__bConfirmationVisible = false, this.__bConfirmationVisible = false) : this.__bConfirmationVisible = false);
          return;
        }
        this.__oReviewDateComponent ? (this.__oDatasource = this.__oReviewDateComponent.transformTradingCounterpartyLimit(this.__oDatasource), this.__oReviewDateComponent.__oDGSetDates.instance.saveEditData()) : "";
        //review dates are mandatory
        if (this.__oReviewDateComponent) {
          let sMessage = "The effective date is mandatory in Limit Review Dates tab.";
          this.__oDatasource.forEach(oCounterpartyLimit => {
            if (oCounterpartyLimit.TradingCounterpartyLimit && !oCounterpartyLimit.TradingCounterpartyLimit.StartDate) {
              (this.__bValidationFailed = true, (this.__oAlertComponent ? (this.__oAlertComponent.__bConfirmationVisible = true, this.__bConfirmationVisible = true) : this.__bConfirmationVisible = true), this.__sMessage = sMessage, this.__sMessageTitle = 'Limit validation', this.__sMessageType = "Error");
            }
          })
        }
        if (this.__bValidationFailed) {
          return;
        }
        //review dates are mandatory
        this.__sTabContent = 'General'; this.__iTabIndex = 0;
        this.__oDatasourceDeleted.forEach(x => {
          this.__oDatasource.push(x);
        });
        this.__bIsLimitLoadingVisible = true;
        //Start FB44675-Pawan Prajapati
        let oCustomPropertyValues = this.__oCustomPropertyComponent.getCustomPropertyCollection();
        var oLimitViewModel = {
          CounterpartyLimitViewModels: this.__oDatasource,
          CustomPropertyValues: oCustomPropertyValues
        }
        //End FB44675-Pawan Prajapati
        //Start FB46162-Pawan Prajapati
        if (this.__oFourEyeManager.__bIsFourEyeEnabled) {
          this.__oConfirmationComponent.show(ConfirmationType.Information, Constants.FOUR_EYE_ENABLED_MESSAGE, "Pending approval", "Ok", "", false).then(oResult => {
            this.onSaveApi(oLimitViewModel);
          })
        } else {
          this.onSaveApi(oLimitViewModel);
        }
        //End FB46162-Pawan Prajapati
      }
    }
    catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while saving limits.');
    }
  }

  //Start FB46162-Pawan Prajapati
  private async onSaveApi(oLimitViewModel) {
    try {
      //console.table(oLimitViewModel);     
      // Use the Promise variant that rethrows on HTTP errors so catch() executes reliably.
      // GenericService.UpdateAllDataByPromiseWithException returns a Promise that rejects on error.
      const result = await this.__oService.UpdateAllDataByPromiseWithException(
        oLimitViewModel,
        this.__sGetApiUrl + "api/CounterpartyLimit/Save"
      );

      this.OnSuccessSave(result);
    } catch (error) {
      // Ensure failures always route to OnError
      this.OnError(error);
    }
  }
  //End FB46162-Pawan Prajapati

  onCloseAlert() {//FB44260-Pawan Prajapati
    this.__bValidationFailed = false;
    this.__bConfirmationVisible = false;
  }

  ///fires on review click
  btnReview_Click(event: any) {
    try {
      this.__sViewName = "Timeline view";
      let eventInfo: any = {};
      eventInfo.value = true;
      this.radioButton_OnValueChanged(eventInfo);
      this.__otrCounterpartyLimits.instance.refresh();

      //this.__otrCounterpartyLimits.instance.editCell(event.RowIndex, event.ColumnName);
      this.__otrCounterpartyLimits.instance.focus(this.__otrCounterpartyLimits.instance.getCellElement(event.RowIndex, event.ColumnIndex + this.__iColumnCountBeforeLimitValue));
      this.__bWarningVisible = false;
      this.__bValidationsVisible = false;
    } catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred on review click.');
    }
  }

  ///open alerts popup
  alert(rowData: any, columnIndex: number, action: any) {
    try {
      switch (action) {
        case "locatecell":
          this.updateWarnings();
          this.__bWarningVisible = true;
          this.__oWarnings = rowData.Warnings.reverse();
          this.__sAlert = "Alerts " + rowData.Warnings.length;
          break;
        case "warning":
          this.__oOverAllocation = {};
          var oData = this.__oDatasource.find(x => x.lCounterpartyLimitId === rowData.lParentCounterpartyLimitId);
          this.__oOverAllocation.MaxAllocation = Math.abs(rowData.DataValues[columnIndex].MaxAllocation);
          this.__oOverAllocation.MaxAllocationCurrencyName = rowData.CurrencyName;
          this.__oOverAllocation.OverallLimitValue = oData && oData.DataValues ? oData.DataValues[columnIndex].LimitValue : 0;
          this.__oOverAllocation.OverallLimitValueCurrencyName = oData && oData.DataValues ? oData.CurrencyName : '';
          this.__bOverAllocationAlertVisible = true;
          this.__bOverAllocationFocusOutAlertVisible = false;
          break;
      }
    } catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred on cancel click.');
    }
  }

  ///close alerts button
  btnClose_Click() {
    try {
      this.__bWarningVisible = false;
      this.__bOverAllocationAlertVisible = false;
      this.__bOverAllocationFocusOutAlertVisible = false;
      this.__bValidationsVisible = false;
    }
    //this.__otrCounterpartyLimits.instance.focus(this.__otrCounterpartyLimits.instance.getCellElement(0, 0));
    catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred on close button click.');
    }
  }

  ///fires on cancel click
  btnCancel_Clicked() {
    try {
      this.__oDatasource = [];
      this.btnEdit_Clicked();
    } catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred on cancel click.');
    }
  }
  //for any errors on save
  private OnError(error: any) {
    try {
      if (error != null) {
        (this.__bValidationFailed = true, (this.__oAlertComponent ? (this.__oAlertComponent.__bConfirmationVisible = true, this.__bConfirmationVisible = true) : this.__bConfirmationVisible = true), this.__sMessage = "Trading limit failed to save successfully.Please contact Administrator.", this.__sMessageTitle = 'Limit Error', this.__sMessageType = "Error");
        this.__bIsLimitLoadingVisible = false;
      }
    } catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred on saving data to database.');
    }
  }
  //save success
  private OnSuccessSave(response: any) {
    try {
      this.loadCustomPropertyComponent();//FB44675-Pawan Prajapati
      if (response) {

        if (response == Constants.ENTITY_ASSOCIATION_MESSAGE) {
          (this.__bValidationFailed = true, (this.__oAlertComponent ? (this.__oAlertComponent.__bConfirmationVisible = true, this.__bConfirmationVisible = true) : this.__bConfirmationVisible = true), this.__sMessage = Constants.ENTITY_ASSOCIATION_MESSAGE, this.__sMessageTitle = 'Entity Restriction Error', this.__sMessageType = "Error");
          this.__bIsLimitLoadingVisible = false;
        }
        else {
          this.__oDatasource = [];
          this.btnEdit_Clicked();
          (this.__bValidationFailed = true, (this.__oAlertComponent ? (this.__oAlertComponent.__bConfirmationVisible = true, this.__bConfirmationVisible = true) : this.__bConfirmationVisible = true), this.__sMessage = "Counterparty Limit saved successfully.", this.__sMessageTitle = 'Limit Save', this.__sMessageType = "Success");
          this.__oDatasourceDeleted = [];
        }
      }
      else {
        (this.__bValidationFailed = true, (this.__oAlertComponent ? (this.__oAlertComponent.__bConfirmationVisible = true, this.__bConfirmationVisible = true) : this.__bConfirmationVisible = true), this.__sMessage = "Counterparty Limit failed to save successfully.Please contact administrator", this.__sMessageTitle = 'Limit Error', this.__sMessageType = "Error");
        this.__bIsLimitLoadingVisible = false;
      }
    } catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred on save success.');
    }
  }

  getSideBarChangeCallback(e: boolean) {
    try {
      if (document.getElementById("divlimitsContainer") && document.getElementById("divlimitsContainer").getElementsByClassName("dx-treelist-table-fixed")[2]) {//FB39751-Pawan Prajapati
        (document.getElementById("divlimitsContainer").getElementsByClassName("dx-treelist-table-fixed")[2] as any).style.pointerEvents = "all";
      }
      this.__bAllowDeleting = true;
      this.__bSideBar = e;
      this.__bSidebarApply = false;
      this.__bIsTempLimitEditing = false;
      this.__oDatasource.forEach(x => { x.IsEditButtonClicked = 0 });
      if (this.__oSideBarCounterPartyLimit && this.__oSideBarCounterPartyLimit.TradingCategoryName !== 'Overall' && this.__oSideBarCounterPartyLimit.TradingCategoryName !== 'Headroom' && this.__oSideBarCounterPartyLimit.IsOverall !== 1) {
        this.__oDatasource.find(x => x.lCounterpartyLimitId == this.__oSideBarCounterPartyLimit.lCounterpartyLimitId).DataValues.forEach(x => x.IsOverAllocation = 0);
        //this.__oDatasource.find(x => x.lCounterpartyLimitId == this.__oSideBarCounterPartyLimit.lCounterpartyLimitId).DataValues.forEach(x => x.IsOverAllocation = 0);
      }
      this.refreshGridStyle();
    } catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while updating data source.');
    }
  }
  calculatePeriodFromDate(sDate: any) {
    if (!sDate)
      return '';

    let dValuationDate: Date = new Date(this.__oSystemSettings[0].ValuationDate);
    let dDate: Date = new Date(sDate);
    return `${this.monthDiff(dValuationDate, dDate)}`;
  }
  calculateLimitPeriodFromPeriod(Info: any, nRowNumber: any, sColumnName: string, event: any) {
    if (Info) {
      if (Info.RollingFromPeriodSuspendValueChagned) {
        Info.RollingFromPeriodSuspendValueChagned = false;
        return;
      }
      if (Info.RollingToPeriodSuspendValueChagned) {
        Info.RollingToPeriodSuspendValueChagned = false;
        return;
      }
      let dValuationDate: Date = new Date(this.__oSystemSettings[0].ValuationDate);
      Info.MinRollingFromPeriod = 0;
      if (Info.RollingToPeriod == 0)
        Info.MaxRollingFromPeriod = this.__oSystemSettings[0].CounterpartyLimitMaxTenure;
      else
        Info.MaxRollingFromPeriod = Info.RollingToPeriod;

      Info.MinRollingToPeriod = Info.RollingFromPeriod;
      Info.MaxRollingToPeriod = this.__oSystemSettings[0].CounterpartyLimitMaxTenure;
      switch (sColumnName) {
        case 'From':
          if (Info.RollingFromPeriod < Info.MinRollingFromPeriod || Info.RollingFromPeriod > Info.MaxRollingFromPeriod) {
            let msg = `The period must be higher than ${Info.MinRollingFromPeriod} and lower than ${Info.MaxRollingFromPeriod}.`;
            this.__oConfirmationComponent.show(ConfirmationType.Error, msg, "Error", "Ok", "", false);
            Info.RollingFromPeriodSuspendValueChagned = true;
            event.component.option('value', event.previousValue);
            return;
          }
          break;
        case 'To':
          if (Info.RollingToPeriod < Info.MinRollingToPeriod || Info.RollingToPeriod > Info.MaxRollingToPeriod) {
            let msg = `The period must be higher than ${Info.MinRollingToPeriod} and lower than ${Info.MaxRollingToPeriod}.`;
            this.__oConfirmationComponent.show(ConfirmationType.Error, msg, "Error", "Ok", "", false);
            Info.RollingToPeriodSuspendValueChagned = true;
            event.component.option('value', event.previousValue);
            return;
          }
          break;
      }
      let dDates: Dates = new Dates();//CRD-1125 Pawan Prajapati
      switch (sColumnName) {
        case 'From':
          Info.From = dDates.dateAdd(dValuationDate, Info.RollingFromPeriod, "months");//CRD-1125 Pawan Prajapati
          this.date_ValueChanged(event, Info, nRowNumber, 'From');
          break;
        case 'To':
          Info.To = dDates.dateAdd(dValuationDate, Info.RollingToPeriod, "months");//CRD-1125 Pawan Prajapati
          this.date_ValueChanged(event, Info, nRowNumber, 'To');
          break;
      }
    }
  }
  returnSidebarChangesCallback(e: any) {
    try {
      let bIsSimpleViewOpen = false;//FB50743-Pawan Prajapati
      //Start FB47814-Pawan Prajapati
      if (!this.__bTimelineViewVisible) {
        bIsSimpleViewOpen = true;//FB50743-Pawan Prajapati
        let oEventInfo: any = {};
        oEventInfo.value = true;
        this.radioButton_OnValueChanged(oEventInfo);
      }
      //End FB47814-Pawan Prajapati
      let __oPeriodDetails = e;
      let iStartColumIndex = 0;//CRD-420-Pawan Prajapati
      let iEndColumnIndex = 0;//CRD-420-Pawan Prajapati
      var oDataRow = this.__oDatasource.filter(z => z.lCounterpartyLimitId == this.__oSideBarCounterPartyLimit.lCounterpartyLimitId)[0];
      __oPeriodDetails.forEach(x => {
        iStartColumIndex = this.monthDiff(new Date(this.__oSystemSettings[0].ValuationDate), new Date(x.StartDate));//CRD-420-Pawan Prajapati
        iEndColumnIndex = this.monthDiff(new Date(this.__oSystemSettings[0].ValuationDate), new Date(x.EndDate));//CRD-420-Pawan Prajapati
        if (!this.__bIsTempLimitEditing) {
          for (let i = iStartColumIndex; i <= iEndColumnIndex; i++) {
            //var oDataRow = this.__oDatasource.filter(z => z.lCounterpartyLimitId == this.__oSideBarCounterPartyLimit.lCounterpartyLimitId)[0];
            if (!oDataRow.DataValues[i].lOverallLimitSettingId) {//FB44260-Pawan Prajapati
              oDataRow.DataValues[i].LimitValue = x.LimitValue == undefined ? null : x.LimitValue; //FB39524-Pawan Prajapati
              oDataRow.DataValues[i].lTradingLimitId > 0 ? (oDataRow.DataValues[i].EntityState = 2, oDataRow.EntityState = 2) : (oDataRow.DataValues[i].EntityState = 1, oDataRow.EntityState = 1);
            }
          }
        } else {
          this.__oNewTempLimit = {};
          this.__oNewTempLimit.Info = {};
          this.__oNewTempLimit.Info.data = oDataRow
          this.__oNewTempLimit.LimitValue = x.LimitValue == undefined ? null : x.LimitValue; //FB39524-Pawan Prajapati
          this.__oNewTempLimit.ActiveFrom = x.StartDate;
          this.__oNewTempLimit.ActiveUntil = x.EndDate;
          this.addAmendTempLimit(iStartColumIndex, iEndColumnIndex, true);
        }
      });
      this.setTempLimitDates(oDataRow);
      this.__oConfirmationComponent.show(ConfirmationType.Information, "Limits have been successfully applied to the grid. Please click save on the main screen to save all data.", "Limits applied", "Ok", "", false);

      //Jailani M M
      this.__bSidebarApply = true;
      this.updateWarnings();
      this.limitValue_Changed(null, this.__oDatasource.filter(z => z.lCounterpartyLimitId == this.__oSideBarCounterPartyLimit.lCounterpartyLimitId)[0], null, iEndColumnIndex, false);// : null;
      //Start FB50743-Pawan Prajapati
      if (bIsSimpleViewOpen) {
        let oEventInfo: any = {};
        oEventInfo.value = false;
        this.radioButton_OnValueChanged(oEventInfo);
      }
      //End FB50743-Pawan Prajapati
      this.refreshGridStyle();
    } catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while updating audit information.');
    }
    //Jailani M M
  }
  private setTempLimitDates(oDataRow: CounterpartyLimitViewModel) {
    try {
      if (!oDataRow.TempDataValues) {//FB50240-Pawan Prajapati
        return;
      }
      let dDates: Dates = new Dates();
      let dTemporaryLimitFrom = "";
      let dTemporaryLimitTo = "";
      var oRow = oDataRow = this.__oDatasource.filter(z => z.lCounterpartyLimitId == oDataRow.lCounterpartyLimitId)[0];
      for (let i = 0; i < oDataRow.TempDataValues.length; i++) //oDataRow.TempDataValues.forEach(x =>//CRD-420-Pawan Prajapati
      {
        if (oDataRow.TempDataValues[i].LimitValue !== null && oDataRow.TempDataValues[i].LimitValue !== "" && oDataRow.TempDataValues[i].LimitValue !== undefined) {
          let dFirstTempLimitStartDate = dDates.dateAdd(this.__dValuationDate, i, "months");//CRD-420-Pawan Prajapati
          dTemporaryLimitFrom = oDataRow.TempLimitTenorTypeName.toLocaleLowerCase() === "rolling" ? new Date(dFirstTempLimitStartDate.getFullYear(), dFirstTempLimitStartDate.getMonth(), 1).toString() : oDataRow.TempDataValues[i].TempLimitStartDate.toString();
          //oDataRow.TemporaryLimitToDate =
          break;
        }
      } //);

      for (let i = oDataRow.TempDataValues.length - 1; i >= 0; i--) //oDataRow.TempDataValues.reverse().forEach(x =>//CRD-420-Pawan Prajapati
      {
        if (oDataRow.TempDataValues[i].LimitValue !== null && oDataRow.TempDataValues[i].LimitValue !== "" && oDataRow.TempDataValues[i].LimitValue !== undefined) {
          let dFirstTempLimitStartDate = dDates.dateAdd(this.__dValuationDate, i, "months");//CRD-420-Pawan Prajapati
          dTemporaryLimitTo = oDataRow.TempLimitTenorTypeName.toLocaleLowerCase() === "rolling" ? new Date(dFirstTempLimitStartDate.getFullYear(), dFirstTempLimitStartDate.getMonth() + 1, 0).toString() : oDataRow.TempDataValues[i].TempLimitEndDate.toString();
          break;
        }
      } //);

      //oRow.TemporaryLimitFromDate = dTemporaryLimitFrom;
      //oRow.TemporaryLimitToDate = dTemporaryLimitTo;

      this.__oDatasource.filter(x => x.lCounterpartyLimitId == oRow.lCounterpartyLimitId)[0].TemporaryLimitFromDate = new Date(dTemporaryLimitFrom);
      this.__oDatasource.filter(x => x.lCounterpartyLimitId == oRow.lCounterpartyLimitId)[0].TemporaryLimitToDate = new Date(dTemporaryLimitTo);
      this.__oDatasource.filter(x => x.lCounterpartyLimitId == oRow.lCounterpartyLimitId)[0].RollingFromMonth = this.rollingMonth(new Date(dTemporaryLimitFrom), "", false);
      this.__oDatasource.filter(x => x.lCounterpartyLimitId == oRow.lCounterpartyLimitId)[0].RollingToMonth = this.rollingMonth(new Date(dTemporaryLimitTo), "", false);
    } catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while updating datasource.');
    }
  }

  monthDiff(d1: Date, d2: Date) {
    var months;
    try {
      months = (d2.getFullYear() - d1.getFullYear()) * 12;
      months -= d1.getMonth();
      months += d2.getMonth();
    } catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while calculating rolling month differences.');
    }
    return months <= 0 ? 0 : months;
  }

  //End Siju FB 27188

  ///Audit information fetched
  onCellHoverChanged(Info: any) {
    try {
      if (Info.data.EntityGroupAudit) {
        this.__oAudit = Info.data.EntityGroupAudit;
        this.__oAudit.dteDateTime = this._oDatepipe.transform(Info.data.EntityGroupAudit.dteDateTime, sessionStorage.getItem('PortalDateFormat')) + " " + this._oDatepipe.transform(Info.data.EntityGroupAudit.dteDateTime, 'shortTime');


        this.__oAudit.CreationTimeStamp = this._oDatepipe.transform(Info.data.CreationTimeStamp, sessionStorage.getItem('PortalDateFormat')) + " " + this._oDatepipe.transform(Info.data.CreationTimeStamp, 'shortTime');

        this.__oAudit.Createdby = Info.data.Createdby;
        this.defaultVisible = true;
      } else {
        this.defaultVisible = false;
      }
    } catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while updating audit information.');
    }
  }
  //tool tip
  toggleInformation(e: any, data: any) {
    try {
      if (e == 'ttActiveUntil') {
        this.__bTTActiveUntil = !this.__bTTActiveUntil;
      }
      if (e == 'ttLimitValue') {
        this.__bTTLimitValue = !this.__bTTLimitValue;
      }
      if (e == 'ttActiveFrom') {
        this.__bTTActiveFrom = !this.__bTTActiveFrom;
      }
      if (e == "ttTrash") {
        data.__bTTTrash = !data.__bTTTrash
      }
    } catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while toggling.');
    }
  }
  //temp limits
  addAmendTempLimit(iStartIndex: any, iEndIndex: any, IsAmendThroughSide: boolean) {
    try {
      let dDates: Dates = new Dates();
      for (let iCount = 0; iCount < this.__oNewTempLimit.Info.data.DataValues.length; iCount++) {//CRD-420-Pawan Prajapati
        if (iCount >= iStartIndex && iCount <= iEndIndex) {
          //this.__oNewTempLimit.Info.data.DataValues[iCount].lTradingLimitId > 0 ? this.__oNewTempLimit.Info.data.DataValues[iCount].EntityState = 2 : this.__oNewTempLimit.Info.data.DataValues[iCount].EntityState = 1;
          if (this.__oNewTempLimit.Info.data.TempDataValues && this.__oNewTempLimit.Info.data.TempDataValues.length > 0 && this.__oNewTempLimit.Info.data.TempDataValues[iCount]) {
            this.__oNewTempLimit.Info.data.TempDataValues[iCount].lTradingLimitId > 0 ? (this.__oNewTempLimit.Info.data.EntityState = 2, this.__oNewTempLimit.Info.data.TempDataValues[iCount].EntityState = 2) : (this.__oNewTempLimit.Info.data.EntityState = 2, this.__oNewTempLimit.Info.data.TempDataValues[iCount].EntityState = 1);
          } else {
            this.__oNewTempLimit.Info.data.TempDataValues[iCount] = {};
            this.__oNewTempLimit.Info.data.TempDataValues[iCount].lTradingLimitId = 0;
            this.__oNewTempLimit.Info.data.TempDataValues[iCount].EntityState = 1;
          }

          this.__oNewTempLimit.Info.data.TempDataValues[iCount].IsTempLimit = true;
          this.__oNewTempLimit.Info.data.TempDataValues[iCount].LimitValue = this.__oNewTempLimit.LimitValue;
          this.__oNewTempLimit.Info.data.TempDataValues[iCount].IsLimitExpired = false;
          this.__oNewTempLimit.Info.data.TempDataValues[iCount].ColumnName = this.__oNewTempLimit.Info.data.DataValues[iCount].ColumnName;

          let dTempStartDate: Date = dDates.dateAdd(new Date(this.__oNewTempLimit.ActiveFrom), iCount - iStartIndex, "months");
          let dtActiveFrom: Date = new Date(this.__oNewTempLimit.ActiveFrom); //new Date(new Date(this.__oNewTempLimit.ActiveFrom).getFullYear(), new Date(this.__oNewTempLimit.ActiveFrom).getMonth(), 1);
          let dtActiveUntil: Date = new Date(this.__oNewTempLimit.ActiveUntil); //new Date(new Date(this.__oNewTempLimit.ActiveUntil).getFullYear(), new Date(this.__oNewTempLimit.ActiveUntil).getMonth() + 1, 0);

          this.__oNewTempLimit.Info.data.TempDataValues[iCount].TempLimitStartDate = iCount === iStartIndex && !this.__bIsTempLimitEditing ? new Date(dtActiveFrom) : new Date(dTempStartDate.getFullYear(), dTempStartDate.getMonth(), 1);
          this.__oNewTempLimit.Info.data.TempDataValues[iCount].TempLimitEndDate = iCount === iEndIndex && !this.__bIsTempLimitEditing ? new Date(dtActiveUntil) : new Date(dTempStartDate.getFullYear(), dTempStartDate.getMonth() + 1, 0);

          this.__oNewTempLimit.Info.data.TempDataValues[iCount].TempLimitStartDate = this.formatDate(this.__oNewTempLimit.Info.data.TempDataValues[iCount].TempLimitStartDate);
          this.__oNewTempLimit.Info.data.TempDataValues[iCount].TempLimitEndDate = this.formatDate(this.__oNewTempLimit.Info.data.TempDataValues[iCount].TempLimitEndDate);
        }
      }
      this.__oNewTempLimit.Info.data.IsTempLimitAllocated = true;
      this.__oNewTempLimit.Info.data.SubLimitTypeName = "Temporary";
      //this.__oNewTempLimit.Info.data.EntityState = 2;
      !IsAmendThroughSide ? this.__oNewTempLimit.Info.data.lTempLimitTenorTypeId = this.__oNewTempLimit.Info.data.lTenorTypeId : "";
      !IsAmendThroughSide ? this.__oNewTempLimit.Info.data.TempLimitTenorTypeName = this.__oNewTempLimit.Info.data.TenorTypeName : "";

      //let iMin = this.__oNewTempLimit.Info.data.TempDataValues.filter(x => x.LimitValue != null).length > 0 ? (Math.min(...this.__oNewTempLimit.Info.data.TempDataValues.filter(x => x.LimitValue != null).map(x => x.lDataValueId))) : 0;
      //let iMax = this.__oNewTempLimit.Info.data.TempDataValues.filter(x => x.LimitValue != null).length > 0 ? (Math.max(...this.__oNewTempLimit.Info.data.TempDataValues.filter(x => x.LimitValue != null).map(x => x.lDataValueId))) : 0;

      //this.__oNewTempLimit.Info.data.TemporaryLimitFromDate = dDates.dateAdd(new Date(this.__oSystemSettings[0].ValuationDate), iMin - 9, "months");
      //this.__oNewTempLimit.Info.data.TemporaryLimitToDate = dDates.dateAdd(new Date(this.__oSystemSettings[0].ValuationDate), (iMax - 9), "months");

      this.__oDatasource.filter(x => x.lCounterpartyLimitId == this.__oNewTempLimit.Info.data.lCounterpartyLimitId)[0] = this.__oNewTempLimit.Info.data;
    } catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while adding/amnding temp limits.');
    }
  }

  rollingMonth(d2: any, name: any, bIsfromUI: boolean = false, event?: any) {
    if (bIsfromUI && !d2) {//CRD-1125 Pawan Prajapati
      return;
    }
    var months;
    try {
      if(event) {
        d2 = event.value;
      }
      var d1 = this.__dValuationDate;
      d2 ? "" : d2 = d1;
      months = (d2.getFullYear() - d1.getFullYear()) * 12;
      months -= d1.getMonth();
      months += d2.getMonth();

      name === "tempLimitActiveFrom" ? this.__oNewTempLimit.ActiveFromPeriod = (months <= 0 ? 0 : months) : null;
      name === "tempLimitActiveUntil" ? this.__oNewTempLimit.ActiveUntilPeriod = (months <= 0 ? 0 : months) : null;
      name === "tempLimitActiveUntil" ? this.__dtMaxTempDate = d2 : null;

    } catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while updating rolling month.');
    }
    return months <= 0 ? 0 : months;
  }

  //update comments
  updateComments(Info: any) {
    try {
      this.__oCounterpartyLimit = JSON.parse(JSON.stringify(Info.data));
      this.__bCommentVisible = true;
    } catch (oError) {
      this.Logger.Write(oError, 'Error', 'Error occurred while executing update Comments function.');
    }
  }

  //call back to update comments from comments component
  getCommentsUpdatedCallback(oCounterpartyLimitViewModel: CounterpartyLimitViewModel) {
    try {
      let oCounterpartyLimit = this.__oDatasource.find(x => x.lCounterpartyLimitId == oCounterpartyLimitViewModel.lCounterpartyLimitId);
      this.__bCommentVisible = this.__oCommentsComponent.__bCommentVisible;
      oCounterpartyLimit.TradingLimitComment = oCounterpartyLimitViewModel.TradingLimitComment;
      oCounterpartyLimit.lTradingLimitCommentId > 0 ? (oCounterpartyLimit.TradingLimitCommentEntityState = 2, oCounterpartyLimit.EntityState = 2) : (oCounterpartyLimit.TradingLimitCommentEntityState = 1, oCounterpartyLimit.EntityState = 2);
      oCounterpartyLimit.DataValues.filter(z => z.lTradingLimitId > 0).forEach(x => {
        x.EntityState === 0 ? x.EntityState = 2 : x.EntityState;
      });
      this.refreshGridStyle();
    }
    catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while executing comments updated event.');
    }
  }
  // call back to cancel the comments updated
  getCommentsCancelledCallback(bIsCancelled: boolean) {
    try {
      this.__bCommentVisible = bIsCancelled;
    }
    catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while executing comments cancel event.');
    }
  }

  //Start CRD-408-Pawan Prajapati
  editLimitCustomProperty(Info: any) {
    try {
      this.__oCounterpartyLimit = JSON.parse(JSON.stringify(Info.data));
      this.__bLimitCustomPropertyVisible = true;
    } catch (oError) {
      this.Logger.Write(oError, 'Error', 'Error occurred while executing edit LimitCustomProperty function.');
    }
  }
  getLimitCustomPropertyUpdatedCallback(oCounterpartyLimitViewModel: CounterpartyLimitViewModel) {
    try {
      if (this.__oLimitCustomProperties && this.__oLimitCustomProperties.length > 0) {
        let oCounterpartyLimit = this.__oDatasource.find(x => x.lCounterpartyLimitId == oCounterpartyLimitViewModel.lCounterpartyLimitId);
        this.__bLimitCustomPropertyVisible = this.__oLimitCustomPropertyComponent.__bVisible;
        oCounterpartyLimit.LimitCustomPropertyValues = this.__oCounterpartyLimit.LimitCustomPropertyValues;
        oCounterpartyLimit.CustomPropertyEntityState = this.__oCounterpartyLimit.CustomPropertyEntityState;
        oCounterpartyLimit.DataValues.filter(z => z.lTradingLimitId > 0).forEach(x => {
          x.EntityState === 0 ? x.EntityState = 2 : x.EntityState;
        });
        this.refreshGridStyle();
      }
    }
    catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while executing LimitCustomProperty updated event.');
    }
  }
  getLimitCustomPropertyCancelledCallback(bIsCancelled: boolean) {
    try {
      this.__bLimitCustomPropertyVisible = bIsCancelled;
    }
    catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while executing LimitCustomProperty cancel event.');
    }
  }
  //End CRD-408-Pawan Prajapati

  getReviewDateUpdateCancelledCallBack(IsCancelled: boolean) {

  }

  getReviewDateUpdatedCallBack(oCounterpartyLimitViewModels: CounterpartyLimitViewModel[]) {

  }
  //Start FB42946-Pawan Prajapati
  dateCheck(from, to, check) {

    var fDate, lDate, cDate;
    fDate = new Date(from.getFullYear(), from.getMonth())
    lDate = Date.parse(to);
    cDate = Date.parse(check);

    if ((cDate <= lDate && cDate >= fDate)) {
      return true;
    }
    return false;
  }
  //FB42947-Pawan Prajapati
  btnLCPCG_Click() {
    try {
      if (this.__oLCPCGLimit.IsEnabled) {
        this.__bIsLimitLoadingVisible = true;
        this.__oService.getDataByObservable(this.__sGetApiUrl + "api/CounterpartyLimit/OverallLimitSetting/" + this.__oLCPCGLimit.OverallLimitSettingName + "/" + this.__oLCPCGLimit.Info.data.lTradingCounterpartyId + "/" + this.__oLCPCGLimit.Info.data.lOurEntityId).subscribe((oResults) => {
          let oCounterpartyLimitsCommonManager: CounterpartyLimitsCommonManager = new CounterpartyLimitsCommonManager(this.__oDatasource, this.__otrCounterpartyLimits, this.Logger);
          let oLimit = this.__oDatasource.find(x => x.lCounterpartyLimitId === this.__oLCPCGLimit.Info.data.lCounterpartyLimitId);
          const lOverallLimitSettingId = this.__oOverallLimitSettings.find(x => x.OverallLimitSettingName === this.__oLCPCGLimit.OverallLimitSettingName).lOverallLimitSettingId;
          const iEndMonth = oLimit.DataValues.length - 1;
          for (let j = 0; j <= iEndMonth; j++) {//CRD-420-Pawan Prajapati
            let iLimitValue = null;
            if (oResults && oResults.length > 0) {
              for (let oResult of oResults) {
                if (this.dateCheck(new Date(oResult.StartDate), new Date(oResult.EndDate), new Date(oLimit.DataValues[j].ColumnName))) {
                  const iSourceAmount = lOverallLimitSettingId == 1 ? (oResult.GuaranteeHaircutAmount ?? oResult.Amount) : oResult.Amount;
                  let iConvertedValue = oCounterpartyLimitsCommonManager.currencyConversion(iSourceAmount, oResult.lCurrencyId, oLimit.lLimitValueCurrencyId, this.__oExchangeRateEFs);
                  iLimitValue = iLimitValue == null ? iConvertedValue : (iLimitValue + iConvertedValue);
                }
              }
            }
            //Start FB44260-Pawan Prajapati
            if (oLimit.DataValues[j].lOverallLimitSettingId > 0 && oLimit.DataValues[j].lOverallLimitSettingId != lOverallLimitSettingId) {
              oLimit.DataValues[j].LimitValue = oLimit.DataValues[j].OldLimitValue;
            }
            //End FB44260-Pawan Prajapati

            //Start FB42947-Pawan Prajapati
            oLimit.DataValues[j].lOverallLimitSettingId = null;
            if (iLimitValue != null) {
              oLimit.DataValues[j].LimitValue = iLimitValue;
              oLimit.DataValues[j].lOverallLimitSettingId = lOverallLimitSettingId;//FB44260-Pawan Prajapati
              oLimit.DataValues[j].lTradingLimitId > 0 ? (oLimit.EntityState = 2) : (oLimit.EntityState = 1);//FB39932-Pawan Prajapati
            }
            //End FB42947-Pawan Prajapati
            if (j == 0 && oLimit.TradingCounterpartyLimit) {//CRD-420-Pawan Prajapati
              oLimit.TradingCounterpartyLimit.lOverallLimitSettingId = lOverallLimitSettingId;
              oLimit.TradingCounterpartyLimit.lLCPCGLinkedToLimitId = oResults ? oResults.map(x => x.lId).join(',') : '';
            }

          }
          this.getLinkedLCPCGMessage(oLimit);//FB44260-Pawan Prajapati
          this.setFromToDateMonths(oLimit);//FB44260-Pawan Prajapati
          this.updateWarnings();
          this.__bIsLimitLoadingVisible = false;
          this.refreshGridStyle();
        });
      }
      else {
        this.__bIsLimitLoadingVisible = true;
        let oLimit = this.__oDatasource.find(x => x.lCounterpartyLimitId === this.__oLCPCGLimit.Info.data.lCounterpartyLimitId);
        oLimit.TradingCounterpartyLimit.lOverallLimitSettingId = null;
        oLimit.TradingCounterpartyLimit.lLCPCGLinkedToLimitId = null;
        const iEndMonth = oLimit.DataValues.length - 1;
        for (let j = 0; j <= iEndMonth; j++) {//CRD-420-Pawan Prajapati
          if (oLimit.DataValues[j].ColumnName && oLimit.DataValues[j].lOverallLimitSettingId) {
            oLimit.DataValues[j].LimitValue = oLimit.DataValues[j].OldLimitValue;
            oLimit.DataValues[j].lOverallLimitSettingId = null;
            oLimit.DataValues[j].lTradingLimitId > 0 ? (oLimit.EntityState = 2, oLimit.DataValues[j].EntityState = 2) : (oLimit.EntityState = 1); //FB42947-Pawan Prajapati
          }
        }
        this.getLinkedLCPCGMessage(oLimit);//FB44260-Pawan Prajapati
        this.setFromToDateMonths(oLimit);
        this.updateWarnings();
      }
      this.__bLCPCGVisible = false;
      this.__bIsLimitLoadingVisible = false;
      this.refreshGridStyle();
    }
    catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while executing LC/PCG value assignment click event.');
    }
  }
  //End FB42946-Pawan Prajapati

  //Start FB44260-Pawan Prajapati
  private getLinkedLCPCGMessage(oLimit: CounterpartyLimitViewModel) {
    try {
      oLimit.LinkedLCPCGMessage = null;
      if (oLimit.TradingCounterpartyLimit && oLimit.TradingCounterpartyLimit.lOverallLimitSettingId) {
        if (oLimit.DataValues.find(x => x.lOverallLimitSettingId)) {
          oLimit.LinkedLCPCGMessage = 'One or more Overall Limits are linked to ' + (oLimit.TradingCounterpartyLimit.lOverallLimitSettingId == 1 ? 'Guarantees' : 'LCs');
        } else {
          oLimit.LinkedLCPCGMessage = 'There are no ' + (oLimit.TradingCounterpartyLimit.lOverallLimitSettingId == 1 ? 'Guarantee' : 'LC') + ' available to be linked';
        }
      }
    } catch (oError) {
      this.Logger.Write(oError, 'Error', 'Error occurred while executing on getLinkedLCPCGMessage function.');
    }
  }
  setFromToDateMonths(oLimit) {
    try {
      const addMonths = (value) => {
        const dValuationDate = new Date(this.__oSystemSettings[0].ValuationDate);
        dValuationDate.setDate(1);
        dValuationDate.setMonth(dValuationDate.getMonth() + value);
        return dValuationDate;
      }
      const dValuationDate = new Date(this.__oSystemSettings[0].ValuationDate);
      var oDataValues = oLimit.DataValues.filter(d => d.LimitValue != null);
      oLimit.To = oDataValues.length == 0 ? dValuationDate : addMonths(Math.max(...oDataValues.map(z => z.lDataValueId)));//CRD-420-Pawan Prajapati
      oLimit.From = oDataValues.length == 0 ? dValuationDate : addMonths(Math.min(...oDataValues.map(z => z.lDataValueId)));//CRD-420-Pawan Prajapati
      //Start FB46162-Pawan Prajapati
      if (this.__oFourEyeManager.isFourEyeRow(oLimit) && oDataValues.length == 0) {
        oLimit.From = null;
        oLimit.To = null;
      }
      //End FB46162-Pawan Prajapati
    } catch (oError) {
      this.Logger.Write(oError, 'Error', 'Error occurred while executing on setFromToDateMonths function.');
    }
  }
  //End FB44260-Pawan Prajapati

  btnLCPCGCancel_Click() {
    try {
      this.__bLCPCGVisible = false;
    } catch (oError) {
      this.Logger.Write(oError, 'Error', 'Error occurred while executing btn LC/PCG Cancel Click function.');
    }
  }

  ImportLCPCGValues(Info: any) {
    try {
      this.__bLCPCGVisible = true;
      this.__oLCPCGLimit.Info = Info;
      this.__oReviewDateComponent ? (this.__oReviewDateComponent.__oCounterpartyLimits = this.__oDatasource, this.__oReviewDateComponent.formTradingCounterpartyLimit(), this.__oDatasource = this.__oReviewDateComponent.transformTradingCounterpartyLimit(this.__oDatasource)) : "";
      let lOverallLimitSettingId = this.__oDatasource.find(x => x.lCounterpartyLimitId === this.__oLCPCGLimit.Info.data.lCounterpartyLimitId).TradingCounterpartyLimit ? this.__oDatasource.find(x => x.lCounterpartyLimitId === this.__oLCPCGLimit.Info.data.lCounterpartyLimitId).TradingCounterpartyLimit.lOverallLimitSettingId : null;
      lOverallLimitSettingId ? (this.__oLCPCGLimit.OverallLimitSettingName = this.__oOverallLimitSettings.find(x => x.lOverallLimitSettingId === lOverallLimitSettingId).OverallLimitSettingName, this.__oLCPCGLimit.IsEnabled = true) : (this.__oLCPCGLimit.OverallLimitSettingName = null, this.__oLCPCGLimit.IsEnabled = false);
    }
    catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while executing LCPCG value assignment event.');
    }
  }

  onButtonClick(Info: any) {
    try {
      this.__oProfileSettings = [];
      if (Info.data.lCounterpartyLimitId > 0 &&
        !Info.data.IsLimitValueChanged &&
        !Info.data.IsTempLimitAllocated &&
        Info.data.LimitTypeName !== 'Volume' &&
        Info.data.TradingCategoryName !== 'Headroom' &&
        (!Info.data.TradingCounterpartyLimit || !Info.data.TradingCounterpartyLimit.lOverallLimitSettingId) &&
        !(this.__oSystemSettings[0].IsOverallLimitEditable === 2 && Info.data.TradingCategoryName === 'Overall') &&
        this.__oSubLimitTypes.find(x => x.SubLimitTypeName == "Temporary")) {
        this.__oProfileSettings.push({ value: 1, name: 'Add Temporary Limit' })
      }
      if (Info.data.IsTempLimitAllocated &&
        !Info.data.IsLimitValueChanged &&
        Info.data.LimitTypeName !== 'Volume' &&
        this.__oSubLimitTypes.find(x => x.SubLimitTypeName == "Temporary")) {
        this.__oProfileSettings.push({ value: 4, name: 'Delete Temporary Limit', disabled: !this.__bIsDeleteRowEnabled });
      }
      if (!Info.data.IsTempLimitValueChanged && !Info.data.IsTempLimitAllocated && (this.__oSystemSettings[0].IsOverallLimitEditable === 1 || this.__oSystemSettings[0].IsOverallLimitEditable === 0) || (this.__oSystemSettings[0].IsOverallLimitEditable === 2 && Info.data.TradingCategoryName !== 'Overall')) {
        let sDeleteType = 'Permanent';
        if (Info.data.LimitTypeName == 'Volume') {
          sDeleteType = Info.data.LimitTypeName;
        } else if (Info.data.TradingCategoryName == "Headroom") { //FB39524-Pawan Prajapati
          sDeleteType = Info.data.TradingCategoryName;
        }
        this.__oProfileSettings.push({ value: 2, name: 'Delete ' + sDeleteType + ' Limit', disabled: !this.__bIsDeleteRowEnabled });
      }
      if ((Info.data.LimitTypeName !== 'Volume') || (!Info.data.IsBuy && Info.data.LimitTypeName === 'Volume')) {
        this.__oProfileSettings.push({ value: 3, name: 'Add Comment' });
      }
      if (!Info.data.IsTempLimitValueChanged && !Info.data.IsTempLimitAllocated && Info.data.TradingCategoryName === 'Overall' && this.__oSystemSettings[0].IsOverallLimitEditable === 1 && Info.data.LimitTypeName === 'Exposure' && Info.data.TenorTypeName === 'Calendar') {
        this.__sLinkLCsGuaranteesPopupTitle = 'Link to LCs/Guarantees';//FB44260-Pawan Prajapati
        if (Info.data.TradingCounterpartyLimit && Info.data.TradingCounterpartyLimit.lOverallLimitSettingId) {
          this.__sLinkLCsGuaranteesPopupTitle = 'Manage linked LCs/Guarantees';//FB44260-Pawan Prajapati
        }
        this.__oProfileSettings.push({ value: 4, name: this.__sLinkLCsGuaranteesPopupTitle }); //FB42947-Pawan Prajapati
      }
      //Start CRD-408 Pawan Prajapati
      if (this.__bIsCustomColumnsAvailable && (Info.data.LimitTypeName !== 'Volume') || (!Info.data.IsBuy && Info.data.LimitTypeName === 'Volume')) {
        this.__oProfileSettings.push({ value: 5, name: "Edit Custom Columns" });
      }
      //End CRD-408 Pawan Prajapati
    } catch (oError) {
      this.Logger.Write(oError, 'Error', 'Error occurred while executing on Button Click function.');
    }
  }
  onItemClick(event: any, Info: any) {
    try {
      switch (event.itemData.name) {
        case "Add Temporary Limit":
          this.openTempLimitPopup(Info)
          break;
        case "Delete Temporary Limit":
          this.onRow_Removing(Info, 'tempLimit')
          break;
        case "Delete Volume Limit":
        case "Delete Headroom Limit": //FB39524-Pawan Prajapati
        case "Delete Permanent Limit":
          this.onRow_Removing(Info, 'permnentLimit')
          break;
        case "Add Comment":
          this.updateComments(Info)
          break;
        case "Edit Custom Columns":
          this.editLimitCustomProperty(Info)
          break;
        case "Link to LCs/Guarantees": //FB44260-Pawan Prajapati
        case "Manage linked LCs/Guarantees": //FB44260-Pawan Prajapati
          this.ImportLCPCGValues(Info)
          break;
      }
    } catch (oError) {
      this.Logger.Write(oError, 'Error', 'Error occurred while executing on Item Click function.');
    }
  }
  //Start FB47392-Pawan Prajapati
  public isEntityRestrictedRow(Info) {
    if (!Info.data.IsTradingCounterpartyInstanceSaveAccess) {
      return true;
    }
    return !this.isFourEyeRow(Info) && Info.data.IsReadonlyAccess;
  }
  //End FB47392-Pawan Prajapati

  //Start FB46162-Pawan Prajapati
  public isFourEyeRow(oInfo) {
    return this.__oFourEyeManager.isFourEyeRow(oInfo.data);
  }
  public isFourEyeNewLimit(oInfo) {
    return oInfo.data.lCounterpartyLimitId > 0 && oInfo.data.FourEyeRequestStatus == FourEyeStatus.Added;
  }
  public isFourEyeNewTempLimit(oInfo) {
    return oInfo.data.lCounterpartyLimitId > 0 && oInfo.data.FourEyeRequestTempStatus == FourEyeStatus.Added;
  }
  public isFourEyeRowSubLimitType(oInfo) {
    return this.isFourEyeRow(oInfo) && oInfo.data.FourEyeRequestTempStatus != FourEyeStatus.Added;
  }

  private checkFourEyeWarningMessage(oLimit) {
    try {
      if (this.__oFourEyeManager.__bIsFourEyeEnabled) {
        oLimit.PermanentLimitvalueDisabledMessage = null;
        oLimit.TempLimitvalueDisabledMessage = null;
        oLimit.IsLimitValueChanged = oLimit.DataValues.find(k => k.LimitValue != k.OldLimitValue) != null;
        oLimit.IsTempLimitValueChanged = oLimit.TempDataValues?.find(k => (k.EntityState != DataEntityState.Unchanged && k.LimitValue != k.OldLimitValue) || k.EntityState == DataEntityState.Deleted) != null;
        if (oLimit.IsTempLimitValueChanged) {
          for (let i = 0; i < oLimit.DataValues.length; i++) {
            oLimit.DataValues[i].IsDisabled = true;
          }
          oLimit.PermanentLimitvalueDisabledMessage = Constants.PERMANENT_CAN_NOT_UPDATE;
        }
        if (oLimit.IsLimitValueChanged && oLimit.IsTempLimitAllocated) {
          for (let i = 0; i < oLimit.TempDataValues.length; i++) {
            oLimit.TempDataValues[i].IsDisabled = true;
          }
          oLimit.TempLimitvalueDisabledMessage = Constants.TEMPORARY_CAN_NOT_UPDATE;
        }
      }
    } catch (oError) {
      this.Logger.Write(oError, 'Error', 'Error occurred while checkFourEyeWarningMessage function.');
    }
  }

  public refreshBindingData() {
    try {
      if (this.__oFourEyeManager.__bIsFourEyeEnabled) {
        this.__oBindDatasource = this.__oFourEyeManager.createRows(this.__oCurrencies, this.__oUnits, this.__oTenorTypes, this.__oDatasource, this.__oApiDataSource);
        for (var __oBindDatasourceItem of this.__oBindDatasource) {
          if (this.__oFourEyeManager.isFourEyeRow(__oBindDatasourceItem)) {
            this.setFromToDateMonths(__oBindDatasourceItem);
            if (__oBindDatasourceItem.FourEyeRequestStatus != FourEyeStatus.Added)
              __oBindDatasourceItem.From = __oBindDatasourceItem.To = null;
            if (__oBindDatasourceItem.FourEyeRequestTempStatus != FourEyeStatus.Added)
              __oBindDatasourceItem.TemporaryLimitFromDate = __oBindDatasourceItem.TemporaryLimitToDate = null;
          }
        }
      }
    } catch (oError) {
      this.Logger.Write(oError, 'Error', 'Error occurred while refreshBindingData function.');
    }
  }
  //End FB46162-Pawan Prajapati

  //Start FB47640-Pawan Prajapati
  public onOpenWorkflowPopup(oData: CounterpartyLimitViewModel) {
    try {
      this.__iBPIId = oData.lwfBusinessProcessInstanceId;
      this.__bPendingApprovalVisible = true;
      let oTimer = setInterval(() => {
        if (this.__oWorkflowDashBoardcomponent) {
          this.__oWorkflowDashBoardcomponent.__bHideStateSidebar = true;
          this.__oWorkflowDashBoardcomponent.__bIsFullWidthContent = true;
          clearInterval(oTimer);
        }
      }, 100);
    } catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while executing onOpenWorkflowPopup function.');
    }
  }

  public onCloseWorkflowPopup(sExecutedAction: string) {
    try {
      this.__bPendingApprovalVisible = false;
      if (sExecutedAction == Constants.APPROVE_ACTION || sExecutedAction == Constants.REJECT_ACTION) {//FB47642-Pawan Prajapati
        this.btnEdit_Clicked();
      }
    } catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while executing onCloseWorkflowPopup function.');
    }
  }
  //End FB47640-Pawan Prajapati

  onExporting(e: any, filename: string) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Sheet');
    const name = filename + '.xlsx';

    exportDataGrid({
      component: e.component,
      worksheet: worksheet,
      selectedRowsOnly: e.selectedRowsOnly,
      customizeCell: (options: any) => {
        const exportedValue = options.excelCell?.value;
        if (typeof exportedValue === 'string') {
          options.excelCell.value = exportedValue.trim();
        }
      }
    }).then(function() {
      workbook.xlsx.writeBuffer()
        .then(function(buffer: BlobPart) {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), name);
        });
    });
    e.cancel = true;
  }
}
